var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWebinar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 263,
    viewBox: "0 0 262 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2687_2583",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 262,
    height: 263
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.494 0H0.5V262.513H261.494V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2687_2583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.447 91.1584L113.775 116.035L143.894 223.34L231.565 198.463L201.447 91.1584Z",
    fill: "#9C3471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.066 88.7134H149.939V201.294H236.467V111.735L214.066 88.7134Z",
    fill: "url(#paint0_linear_2687_2583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.557 94.4832V119.735L236.317 111.735L215.547 112.934L212.557 94.4832Z",
    fill: "#9C3471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.934 200.755L236.536 130.353L236.461 200.755",
    fill: "#D7AEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.49 170.203H162.914V177.108H195.49V170.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.246 157.412H162.914V164.323H210.246V157.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.246 143.208H162.914V150.119H210.246V143.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.798 88.551C178.177 127.352 151.149 150.918 119.178 150.918C117.796 150.918 116.338 150.263 114.609 150.176V156.45C116.338 156.531 117.796 157.18 119.178 157.18C154.601 157.18 183.403 130.758 188.098 88.9971L182.798 88.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4219 146.764L73.3844 140.073L78.178 146.156L68.2278 152.98L65.4219 146.764Z",
    fill: "#880C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8343 187.101L74.7965 154.851C71.7313 144.569 64.5927 141.846 64.5927 141.846L23.9219 173.899C26.964 175.718 31.8037 179.112 34.8343 187.101Z",
    fill: "#9C3471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16 65.976C164.935 39.7687 128.585 32.151 97.9738 48.9506C67.3625 65.7501 54.0818 100.612 68.3074 126.814C82.527 153.021 118.883 160.644 149.494 143.839C180.105 127.045 193.386 92.1834 179.16 65.976ZM144.522 135.231C118.427 149.551 87.626 143.376 75.7168 121.432C63.8076 99.4883 75.3019 70.1006 101.39 55.7805C127.485 41.4661 158.286 47.6356 170.195 69.5735C182.11 91.5172 170.61 120.911 144.522 135.231Z",
    fill: "#9C3471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.793 62.9172C129.127 49.3385 159.22 55.5312 171.008 76.7565C171.411 77.4807 171.78 78.2106 172.132 78.9463C171.377 76.4379 170.357 73.9759 169.043 71.6124C157.255 50.387 127.041 44.2639 101.564 57.9236C76.086 71.5834 64.9892 99.853 76.7774 121.078C77.0251 121.519 77.2844 121.942 77.5494 122.364C68.7515 101.643 79.8541 75.7486 103.793 62.9172Z",
    fill: "#880C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.623 83.9282C189.44 107.297 175.549 132.879 150.325 146.724C119.829 163.46 83.9456 156.931 68.4297 132.398C69.0923 133.974 69.726 135.59 70.6537 137.061C87.368 163.408 122.128 171.674 153.131 154.66C181.092 139.315 195.507 110.541 186.623 83.9282Z",
    fill: "#880C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.584 174.571C22.584 174.571 31.0017 179.744 33.1738 187.645C33.1738 187.645 26.3809 186.591 22.584 174.571Z",
    fill: "#880C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.661 76.7392C157.912 57.8774 130.401 52.8317 106.219 65.4719C82.038 78.1121 70.3362 103.642 80.0849 122.504C89.8335 141.365 117.345 146.411 141.526 133.771C165.708 121.136 177.41 95.6011 167.661 76.7392Z",
    fill: "url(#paint1_radial_2687_2583)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M144.42 124.207L154.566 70.7783C154.566 70.7783 179.278 95.41 144.42 124.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.447 262.513C109.366 262.27 109.309 261.853 109.199 261.818C108.669 261.656 108.658 260.689 108.041 260.59C108.277 260.393 108.421 260.277 108.6 260.127C108.421 259.849 107.966 259.831 108.248 259.298C108.571 259.547 108.571 259.547 109.061 259.229C109.02 259.101 108.98 258.974 108.94 258.852C108.957 258.823 108.969 258.777 108.98 258.777C109.366 258.771 109.752 258.777 110.173 258.777C110.144 258.626 110.075 258.464 110.086 258.314C110.092 258.215 110.213 258.128 110.277 258.035C110.305 258.157 110.328 258.279 110.363 258.395C110.38 258.447 110.415 258.481 110.455 258.557C110.824 258.441 111.02 258.174 110.847 257.601C111.221 257.497 111.544 257.404 111.89 257.306C111.798 258.001 111.348 257.474 111.095 257.856C111.435 258.012 111.59 258.586 112.04 258.232C112.166 258.134 112.443 258.377 112.639 258.493C112.887 258.638 112.915 258.916 112.852 259.258C112.835 259.35 112.892 259.478 112.892 259.634C112.645 259.038 112.241 259.009 111.832 258.899C111.371 258.777 111.002 259.038 110.622 259.281C110.305 259.484 110.317 259.518 109.983 259.275C109.879 259.461 109.781 259.64 109.66 259.86C109.746 259.964 109.85 260.098 109.965 260.237C109.89 260.428 109.816 260.608 109.741 260.787C109.885 260.984 109.96 261.337 110.213 261.025C110.248 260.984 110.374 261.065 110.449 261.117C110.68 261.274 110.899 261.505 111.141 261.587C111.342 261.656 111.556 261.679 111.642 261.158C111.711 260.735 112.04 260.393 112.264 260.04C112.287 259.999 112.414 260.098 112.575 260.161C112.103 260.804 111.97 261.476 112.351 262.177C112.241 262.635 111.844 261.928 111.786 262.519C111.02 262.513 110.236 262.513 109.447 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 248.726C0.765033 248.57 0.966689 248.205 1.28358 248.234C1.42185 248.245 1.56013 248.321 1.69265 248.489C1.56013 248.529 1.43338 248.57 1.23748 248.628C1.34119 248.691 1.38728 248.744 1.43914 248.744C2.89682 248.813 4.3545 248.883 5.81218 248.946C5.93894 248.952 6.06569 248.964 6.20397 248.97C6.20397 249.155 6.20397 249.288 6.20397 249.52C7.07973 249.52 7.93821 249.52 8.79669 249.52C8.79669 249.572 8.79669 249.618 8.79669 249.67C6.03113 249.786 3.26556 249.902 0.5 250.018C0.5 249.595 0.5 249.161 0.5 248.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.488 262.513C185.194 261.141 185.35 259.831 185.753 258.557C185.937 257.978 186.346 257.862 186.715 257.711C186.963 257.607 187.24 257.618 187.481 257.503C187.787 257.358 188.133 257.224 188.346 256.923C188.968 256.06 189.498 255.075 189.855 253.94C189.994 253.5 190.086 252.972 190.051 252.497C190.005 251.802 190.259 251.368 190.558 250.974C190.789 250.661 191.088 250.447 191.353 250.186C191.371 250.209 191.388 250.238 191.411 250.261C191.33 250.4 191.261 250.574 191.163 250.678C190.593 251.275 190.449 252.144 190.368 253.065C190.276 254.137 189.999 255.081 189.463 255.869C189.164 256.309 188.899 256.813 188.576 257.219C188.219 257.671 187.81 258.001 187.297 258.07C186.917 258.122 186.554 258.325 186.128 258.476C186.249 258.858 186.335 259.125 186.439 259.455C185.92 259.715 185.557 260.092 185.903 260.909C185.765 261.048 185.667 261.152 185.557 261.268C185.672 261.708 185.776 262.108 185.886 262.513C185.747 262.513 185.615 262.513 185.488 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48438 262.513C6.2622 261.187 7.04577 259.86 7.82359 258.528C7.96186 258.29 8.09438 258.041 8.2269 257.798C8.35941 257.549 8.52074 257.392 8.72239 257.636C8.90676 257.856 9.00471 258.14 8.83186 258.447C8.51498 259.02 8.17504 259.571 7.84087 260.127C7.36266 260.926 6.87869 261.72 6.40047 262.513C6.0951 262.513 5.78974 262.513 5.48438 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5282 262.513C57.3553 262.137 57.1882 261.754 56.998 261.343C57.2055 261.198 57.361 261.123 57.4993 260.99C58.0697 260.457 58.5194 260.526 58.9573 261.239C59.2223 261.668 59.4873 262.085 59.7524 262.513C59.0149 262.513 58.2716 262.513 57.5282 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.52 -6.64042e-05C175.543 0.115792 175.612 0.30696 175.589 0.330132C175.111 0.810947 174.817 1.65092 174.178 1.81313C174.154 1.81892 174.137 1.81313 174.074 1.81313C173.97 1.60458 173.855 1.37286 173.705 1.07742C173.809 0.973149 173.912 0.776189 173.993 0.793568C174.471 0.909427 174.679 0.492334 174.863 -0.00585938C175.088 -6.64042e-05 175.307 -6.64042e-05 175.52 -6.64042e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 229.725C1.22596 230.038 1.95768 229.667 2.6894 229.777C3.00629 229.83 3.32318 229.853 3.72649 229.899C3.30013 230.322 2.3898 230.357 0.5 230.102C0.5 229.974 0.5 229.847 0.5 229.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0168 262.513C75.9131 262.415 75.8209 262.276 75.7057 262.224C75.4579 262.102 75.5213 261.894 75.5962 261.668L75.5847 261.673C75.6423 261.702 75.7057 261.731 75.7978 261.778C75.9707 261.523 75.8036 260.938 76.23 260.839C76.276 261.152 76.2933 261.459 76.3682 261.737C76.4374 262.009 76.5699 262.253 76.6736 262.513C76.4547 262.513 76.2357 262.513 76.0168 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 197.117C0.97245 197.042 1.13954 197.592 1.40457 197.98C1.20868 198.635 0.868742 198.588 0.5 198.426C0.5 197.986 0.5 197.551 0.5 197.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6094 262.513C64.7765 262.166 64.9493 261.813 65.1279 261.453C65.3123 261.471 65.5139 261.494 65.7156 261.517C65.7271 261.795 65.7329 262.038 65.7387 262.282C65.6061 262.131 65.4794 261.986 65.2374 261.708C65.3065 262.033 65.3123 262.259 65.3641 262.282C65.4736 262.334 65.6119 262.276 65.7329 262.27C65.8827 262.351 66.0325 262.432 66.1823 262.513C65.658 262.513 65.1337 262.513 64.6094 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.336 0C198.065 0.289648 197.806 0.614053 197.518 0.86315C197.293 1.05432 197.034 1.13542 196.729 0.753084C196.896 0.614053 197.028 0.50978 197.155 0.388128C197.287 0.266476 197.414 0.127445 197.541 0C197.812 0 198.071 0 198.336 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9805 262.513C43.0727 262.062 43.1591 261.604 43.2628 261.152C43.2974 260.99 43.3838 260.857 43.476 260.66C43.6258 260.822 43.7352 260.944 43.7986 261.019C43.741 261.384 43.6891 261.691 43.6431 261.998C43.5278 262.148 43.3838 262.328 43.2455 262.513C43.1533 262.513 43.0669 262.513 42.9805 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 35.4009C0.834172 35.3256 1.03007 35.0707 1.0243 34.5261C1.22596 34.5493 1.42185 34.5783 1.69841 34.613C1.60623 34.81 1.54861 34.9374 1.49099 35.0707C1.13377 35.2329 0.960927 35.9106 0.5 35.7716C0.5 35.65 0.5 35.5225 0.5 35.4009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 119.798C0.551854 119.752 0.649801 119.717 0.649801 119.671C0.667086 119.393 0.765033 119.254 0.937881 119.404C1.04735 119.497 1.20291 119.705 0.920596 119.827C0.955166 119.943 0.983974 120.053 1.01854 120.169C1.06464 120.337 1.11649 120.505 1.19139 120.754C0.89755 120.661 0.701656 120.603 0.5 120.54C0.5 120.296 0.5 120.047 0.5 119.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 61.1099C0.97245 61.3184 0.983974 61.3358 1.00702 62.1468C0.845695 62.2337 0.672848 62.3206 0.5 62.4133C0.5 61.9788 0.5 61.5443 0.5 61.1099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9361 0C69.0571 0.243304 69.1839 0.480815 69.374 0.845771C68.867 0.747291 68.5616 0.405507 68.2793 0C68.4982 0 68.7172 0 68.9361 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 63.1606C0.695894 63.3171 0.89755 63.4677 1.11073 63.6357C0.937881 64.0759 0.75351 64.1918 0.5 64.0933C0.5 63.7805 0.5 63.4735 0.5 63.1606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7542 262.513C67.6851 262.345 67.6159 262.183 67.541 262.009C68.025 262.166 68.025 262.166 68.3937 261.778C68.3476 262.079 68.3131 262.293 68.2785 262.513C68.1057 262.513 67.927 262.513 67.7542 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64624 262.513C3.63471 262.426 3.59438 262.276 3.61167 262.264C3.79028 262.119 3.98041 261.992 4.21663 261.946C4.11293 262.131 4.01498 262.322 3.91127 262.513C3.81908 262.513 3.73266 262.513 3.64624 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 48.0698C0.805364 48.1278 1.17411 48.0524 1.15106 48.8113C0.914834 48.6086 0.707417 48.4348 0.5 48.2552C0.5 48.1915 0.5 48.1335 0.5 48.0698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 155.014C0.793841 154.828 0.86298 155.187 1.06464 155.471C0.822649 155.518 0.661325 155.547 0.5 155.576C0.5 155.384 0.5 155.199 0.5 155.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.845 0C238.897 0.0926872 238.948 0.185374 239.041 0.35337C238.885 0.440264 238.747 0.50978 238.557 0.614053C238.568 0.347577 238.574 0.173789 238.58 0.00579295C238.672 0 238.758 0 238.845 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8223 262.513C71.8568 262.322 71.8914 262.131 71.9317 261.928C72.2659 261.865 72.2141 262.322 72.3466 262.513C72.168 262.513 71.9951 262.513 71.8223 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.891 0C247.874 0.121652 247.845 0.35337 247.84 0.347577C247.655 0.318612 247.373 0.521366 247.367 0C247.54 0 247.719 0 247.891 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 222.455C0.828411 222.391 0.701656 222.785 0.747748 222.994C0.75351 223.029 0.586424 223.133 0.5 223.202C0.5 222.953 0.5 222.704 0.5 222.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 193.392C0.667086 193.554 0.828411 193.716 0.995497 193.878C0.97245 193.931 0.949404 193.977 0.926358 194.029C0.788079 193.942 0.64404 193.849 0.505762 193.763C0.5 193.641 0.5 193.519 0.5 193.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 28.1364C0.730464 28.0785 0.960927 28.0206 1.25477 27.9395C1.04735 28.5014 0.736225 28.2291 0.5 28.3218C0.5 28.2581 0.5 28.1943 0.5 28.1364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.244 262.513C258.319 262.235 258.4 261.957 258.475 261.673C258.515 261.685 258.555 261.697 258.596 261.708C258.567 261.975 258.538 262.247 258.509 262.513C258.423 262.513 258.336 262.513 258.244 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6426 262.513C11.7578 262.322 11.8673 262.131 11.9998 261.899C12.0517 262.079 12.1093 262.293 12.1669 262.513C11.994 262.513 11.8212 262.513 11.6426 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.148 262.513C162.454 262.235 162.759 262.079 163.065 262.513C162.765 262.513 162.46 262.513 162.148 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.804C0.597947 10.9082 0.695894 11.0067 0.788079 11.111C0.690132 11.2558 0.597947 11.4006 0.5 11.5512C0.5 11.3021 0.5 11.0531 0.5 10.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64461 0C3.33924 0.237511 3.03388 0.393921 2.72852 0C3.03388 0 3.33924 0 3.64461 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 129.299C0.597947 129.426 0.695894 129.559 0.793841 129.687C0.695894 129.745 0.597947 129.803 0.5 129.855C0.5 129.675 0.5 129.49 0.5 129.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9499 262.513C28.9269 262.357 28.9038 262.201 28.875 262.009C29.1573 262.009 29.2092 262.23 29.2149 262.513C29.1227 262.513 29.0363 262.513 28.9499 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.738 262.513C167.055 261.986 167.078 261.986 167.263 262.513C167.084 262.513 166.911 262.513 166.738 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 189.482C0.626755 189.569 0.747748 189.655 0.955166 189.8C0.75351 189.91 0.626755 189.974 0.5 190.044C0.5 189.852 0.5 189.667 0.5 189.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 117.006C0.620993 117.023 0.741987 117.041 0.857219 117.058C0.86298 117.093 0.868742 117.134 0.874503 117.168C0.747748 117.238 0.626755 117.307 0.5 117.377C0.5 117.255 0.5 117.128 0.5 117.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28934 0.000471667C1.0243 0.0641944 0.765033 0.127917 0.5 0.185846C0.523046 0.122124 0.540331 0.00626462 0.563377 0.00626462C0.805364 -0.00532126 1.04735 0.000471667 1.28934 0.000471667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 14.9053C0.60947 14.9284 0.71894 14.9574 0.834172 14.9864C0.834172 15.0327 0.839934 15.0849 0.839934 15.137C0.724702 15.1833 0.60947 15.2297 0.5 15.276C0.5 15.1544 0.5 15.0327 0.5 14.9053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 137.872C0.574901 137.982 0.649801 138.092 0.730464 138.203C0.655563 138.278 0.580662 138.353 0.5 138.428C0.5 138.243 0.5 138.058 0.5 137.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 258.603C0.603709 258.626 0.713179 258.655 0.816887 258.678C0.816887 258.725 0.822649 258.771 0.822649 258.823C0.713179 258.875 0.603709 258.928 0.5 258.974C0.5 258.852 0.5 258.725 0.5 258.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9102 262.513C47.083 261.917 47.2616 262.421 47.4345 262.513C47.2616 262.513 47.0888 262.513 46.9102 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9873 262.513C61.9297 262.403 61.8721 262.293 61.8145 262.177C62.0622 262.044 62.1832 262.206 62.2466 262.513C62.1601 262.513 62.0737 262.513 61.9873 262.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0044 230.693C86.7509 230.751 86.5031 230.861 86.2496 230.861C83.9795 230.861 81.7152 230.832 79.4452 230.826C78.2468 230.82 77.0426 230.838 75.8442 230.843C75.7808 230.843 75.7117 230.867 75.6483 230.861C73.5568 230.594 71.4711 230.988 69.3797 230.878C68.5961 230.838 67.8183 230.814 67.0347 230.797C66.7293 230.791 66.4297 230.838 66.1244 230.832C65.1046 230.809 64.079 230.756 63.0592 230.751C61.6073 230.739 60.1554 230.756 58.7034 230.751C58.5421 230.751 58.3808 230.675 58.2195 230.641C58.0467 230.606 57.8797 230.548 57.7068 230.548C56.664 230.571 55.6211 230.617 54.5783 230.635C53.5988 230.652 52.6193 230.658 51.6399 230.629C50.8851 230.606 50.1303 230.49 49.3755 230.473C48.834 230.461 48.2866 230.554 47.745 230.577C47.2438 230.6 46.7425 230.588 46.2412 230.588C46.1318 230.588 46.0165 230.536 45.9186 230.571C45.7054 230.646 45.5383 230.849 45.2848 230.525C45.1465 230.351 44.7951 230.513 44.5416 230.513C43.4353 230.513 42.3234 230.519 41.2171 230.513C40.5891 230.513 39.9611 230.502 39.3389 230.49C39.2812 230.49 39.2236 230.42 39.0508 230.316C39.2582 230.252 39.3561 230.195 39.4599 230.195C40.7793 230.154 42.0929 230.113 43.4123 230.085C43.8905 230.073 44.3802 230.212 44.8412 230.085C45.5038 229.893 46.1433 230.061 46.7944 230.079C47.4051 230.09 48.0215 229.992 48.6207 230.108C49.3524 230.253 50.0669 230.021 50.7929 230.079C51.5131 230.142 52.2333 230.102 52.9535 230.113C53.691 230.125 54.4342 230.137 55.1717 230.171C55.7997 230.2 56.4335 230.276 57.0615 230.316C57.3611 230.334 57.6665 230.287 57.9661 230.293C59.0779 230.328 60.1842 230.392 61.2962 230.397C62.0567 230.403 62.8172 230.31 63.5778 230.293C64.3383 230.276 65.1046 230.258 65.8651 230.316C67.4495 230.444 69.0282 230.276 70.6069 230.281C70.7394 230.281 70.8662 230.27 70.9987 230.281C71.9493 230.345 72.9 230.461 73.8507 230.473C74.6342 230.484 75.4178 230.368 76.1956 230.334C76.8467 230.305 77.5035 230.305 78.1546 230.305C79.0649 230.305 79.9752 230.316 80.8856 230.334C82.2914 230.357 83.703 230.397 85.1088 230.421C85.7311 230.432 86.3591 230.421 86.9813 230.421C86.9929 230.502 86.9986 230.6 87.0044 230.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3253 145.108C64.141 145.287 63.9739 145.496 63.7722 145.635C63.4957 145.832 63.1961 145.976 62.908 146.144C62.9138 146.208 62.9253 146.266 62.9368 146.33C63.0348 146.359 63.1269 146.411 63.2191 146.417C64.02 146.44 64.8266 146.434 65.6275 146.469C66.1633 146.492 66.6185 146.231 67.0679 145.751C66.8316 145.71 66.5897 145.664 66.3477 145.623C66.7222 145.374 66.7222 145.339 67.2753 145.386C67.5864 145.415 67.8111 145.305 68.0358 145.009C68.2893 144.673 68.6004 144.436 68.8482 144.088C69.0038 143.874 69.0787 143.543 69.1881 143.265C69.8277 143.346 70.0639 142.698 70.2713 141.927C69.9083 142.142 69.5454 142.35 69.2054 142.553C69.2054 142.831 69.2054 143.057 69.2054 143.283C68.6984 142.906 68.2202 143.028 67.7247 143.381C67.3271 143.671 66.8835 143.833 66.4571 144.053C66.4399 143.995 66.4226 143.943 66.4053 143.885C66.9008 143.572 67.3905 143.254 67.8918 142.958C68.9173 142.356 69.9602 141.823 70.9627 141.163C71.7866 140.618 72.5587 139.934 73.2328 139.019C73.6822 138.411 74.2295 137.942 74.7596 137.461C75.8082 136.517 76.8683 135.607 77.9285 134.692C78.7639 133.968 79.5993 133.249 80.4463 132.548C80.7805 132.27 81.1319 132.044 81.541 131.917C81.4488 132.039 81.3624 132.195 81.2529 132.282C80.0718 133.273 78.8906 134.24 77.7153 135.236C77.4963 135.422 77.3177 135.7 77.1218 135.943C76.9778 136.123 76.8626 136.36 76.7012 136.482C75.595 137.287 74.5522 138.208 73.5842 139.32C73.4517 139.471 73.2443 139.517 73.348 139.923C73.371 140.021 73.0254 140.311 72.8352 140.531C72.9389 140.659 73.0426 140.786 73.1809 140.954C72.7776 141.342 72.3916 140.282 72.0516 140.995C71.9825 141.134 71.9537 141.313 71.8903 141.545C71.5331 141.539 71.1816 141.707 70.9973 142.298C70.9685 142.391 70.8763 142.466 70.8071 142.495C70.1157 142.819 69.6836 143.625 69.1248 144.181C69.1881 144.389 69.2285 144.528 69.2918 144.748C69.0959 144.696 68.9404 144.65 68.7733 144.604C68.5947 144.795 68.4103 144.992 68.1856 145.235C68.3988 145.339 68.5716 145.42 68.7387 145.501C68.7387 145.542 68.733 145.588 68.733 145.629C68.4103 145.652 68.0877 145.669 67.6844 145.693C67.8514 146.26 68.0589 146.446 68.3988 146.457C69.7067 146.492 71.0146 146.55 72.3224 146.602C72.5529 146.614 72.7776 146.631 73.0081 146.643C73.0081 146.706 73.0081 146.77 73.0081 146.834C72.8698 146.857 72.7373 146.892 72.599 146.892C71.2047 146.898 69.8104 146.898 68.4218 146.909C67.8802 146.915 67.3387 146.932 66.7971 146.955C66.532 146.967 66.3131 147.066 66.0942 147.344C65.8579 147.645 65.5353 147.795 65.2299 148.027C65.0455 147.859 64.8381 147.68 64.5789 147.454C64.8669 147.263 65.0974 147.112 65.3163 146.973C65.5526 146.996 65.7139 147.674 66.0135 147.013C65.8752 146.955 65.7485 146.857 65.6217 146.851C64.5097 146.782 63.4035 146.701 62.2915 146.689C61.8421 146.683 61.3754 146.764 60.9779 147.152C60.8626 147.263 60.7186 147.309 60.4708 147.448C60.6034 147.152 60.6667 147.019 60.782 146.764C59.8774 146.689 59.0304 146.614 58.1777 146.538C58.1777 146.475 58.1777 146.405 58.1777 146.341C58.3967 146.341 58.6099 146.336 58.8288 146.341C59.5432 146.359 60.2634 146.428 60.9721 146.388C61.4446 146.365 61.9228 146.249 62.3779 146.058C62.9599 145.808 63.5187 145.438 64.0891 145.137C64.164 145.096 64.262 145.113 64.3484 145.108H64.3253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3367 245.807C90.0857 245.372 90.731 245.025 91.359 244.613C91.6068 244.451 91.7163 244.555 91.8603 244.897C91.4339 245.233 91.0133 245.569 90.587 245.905C90.4948 245.98 90.3853 246.015 90.2989 246.102C89.7573 246.635 89.7804 246.583 89.233 246.189C88.6338 245.76 88.1902 245.088 87.6774 244.521C87.4584 244.283 87.2107 244.074 86.9514 243.941C86.623 243.773 86.3119 243.86 86.0872 244.312C85.874 244.735 85.632 245.094 85.246 245.256C85.0616 245.332 84.9349 245.662 84.7851 245.882C84.0533 246.942 84.2896 248.24 84.3529 249.491C84.3587 249.607 84.3875 249.723 84.4048 249.838C83.8517 250.064 83.7537 249.972 83.7595 249.271C83.7595 248.9 83.7768 248.523 83.7249 248.164C83.5982 247.272 83.7826 246.536 84.2031 245.876C84.4624 245.465 84.6871 245.025 84.9291 244.602C84.981 244.509 85.0386 244.416 85.1077 244.353C85.3036 244.179 85.5514 244.074 85.6954 243.843C86.116 243.165 86.865 243.177 87.5161 243.524C87.9424 243.75 88.2996 244.161 88.582 244.706C88.7894 245.117 89.0774 245.442 89.3367 245.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.78 254.102C237.642 253.685 237.187 253.546 237.227 252.943C237.919 252.706 238.04 252.81 238.161 253.766C239.261 253.679 240.275 253.337 241.128 252.19C241.612 251.542 242.003 250.841 242.355 250.053C242.62 249.462 242.735 248.9 242.516 248.234C242.43 247.967 242.407 247.66 242.338 247.255C242.891 247.846 243.041 248.715 242.793 249.618C242.505 250.667 242.107 251.617 241.439 252.289C241.226 252.503 241.036 252.758 240.845 253.013C240.35 253.662 239.768 254.009 239.094 254.085C238.691 254.131 238.276 254.108 237.988 254.681C237.659 255.33 237.653 255.62 238.114 256.112C238.287 256.298 238.495 256.419 238.679 256.581C238.8 256.686 238.91 256.813 239.128 257.039C238.91 257.08 238.812 257.138 238.731 257.103C238.42 256.97 238.103 256.825 237.803 256.651C237.325 256.379 237.21 256.054 237.371 255.342C237.463 254.942 237.625 254.571 237.78 254.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74219 30.1756C8.24921 29.4978 8.75623 30.4942 9.18835 30.0018C9.6608 30.2509 10.1736 30.106 10.646 30.2451C11.1242 30.3841 11.5794 30.7433 12.0519 31.0155C12.1268 31.2704 12.2132 31.5485 12.2938 31.815C12.1901 32.1741 12.0115 32.3595 11.7753 32.2089C11.4815 32.0235 11.13 31.983 10.8938 31.7976C10.3522 31.3689 9.78755 31.3168 9.21139 31.2415C8.63523 31.1661 8.18007 30.7664 7.74219 30.1756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8907 250.308C68.8101 249.839 68.7755 249.3 68.2685 249.503C67.508 248.825 66.6725 249.167 65.8659 249.109C65.8371 249.109 65.8141 249.027 65.791 248.987C66.2289 248.703 68.7928 248.773 69.1788 249.045C69.4208 248.929 69.6225 248.744 69.8241 248.744C70.7517 248.755 71.6794 248.819 72.607 248.871C72.6876 248.877 72.7683 248.935 72.9584 249.016C72.7395 249.114 72.63 249.207 72.5148 249.213C71.7831 249.23 71.0571 249.236 70.3254 249.224C70.0776 249.219 69.8241 249.161 69.513 249.12C69.4266 249.213 69.2768 249.363 69.0117 249.642C69.3747 249.746 69.6167 249.867 69.8587 249.873C70.1986 249.885 70.2793 250.099 70.2159 250.528C70.0949 250.528 69.9739 250.528 69.7896 250.528C70.0027 251.298 69.4323 252.005 69.9394 252.926C69.5418 252.816 69.3113 252.747 68.9772 252.654C69.1212 252.295 69.1961 252.046 69.3113 251.843C69.7608 251.072 69.6743 250.644 68.9945 250.366C68.9541 250.348 68.9138 250.319 68.8735 250.296L68.8907 250.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.287 115.934C247.518 115.772 247.685 115.639 247.858 115.535C248.278 115.291 248.71 115.089 249.114 114.805C249.263 114.695 249.338 114.382 249.471 114.191C249.551 114.069 249.678 113.913 249.77 113.93C249.857 113.953 249.966 114.156 249.995 114.312C250.191 115.315 249.909 116.189 249.246 116.653C248.918 116.884 248.578 117.081 248.249 117.313C248.059 117.452 247.909 117.388 247.8 117.157C247.633 116.792 247.495 116.427 247.287 115.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4424 159.862C59.3675 160.082 59.3618 160.123 59.3502 160.135C59.3042 160.164 58.1056 160.123 58.048 160.106C57.8809 160.065 57.7138 160.03 57.5352 159.99C57.2932 159.602 57.4834 158.837 56.9879 158.646C57.1089 157.846 56.573 157.899 56.2734 157.545C56.3541 157.447 56.4175 157.308 56.5039 157.273C56.7228 157.174 56.5846 157.093 56.5154 157.001C56.6076 156.954 56.7113 156.838 56.7862 156.867C57.0973 156.983 57.2068 157.313 57.1262 157.939C57.299 157.696 57.3854 157.58 57.5064 157.412C57.6101 157.829 57.8579 157.945 58.1056 158.107C58.5494 158.385 59.0103 158.669 59.0737 159.532C59.091 159.671 59.3445 159.775 59.4424 159.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8658 251.768C31.5143 252.19 31.4682 252.723 31.5028 253.337C31.1341 252.857 30.6674 252.677 30.5176 251.976C30.6616 252.115 30.8057 252.248 31.0131 252.445C31.1283 252.051 31.3472 251.652 31.33 251.269C31.3184 250.846 31.7448 250.47 31.4452 250.134C31.6584 249.867 31.8658 249.613 32.0732 249.352C32.0502 249.265 32.0329 249.172 32.0156 249.08C32.2691 249.317 32.5053 249.67 32.7876 249.769C33.1679 249.908 33.5885 249.827 33.9861 249.891C34.2799 249.937 34.6198 249.572 34.8791 250.111C34.1243 250.597 33.335 249.908 32.5629 250.215C32.6321 250.47 32.6839 250.632 32.7358 250.829C32.6033 250.91 32.4938 250.98 32.3382 251.072C32.4535 251.443 32.5745 251.814 32.6955 252.196C32.4189 252.057 32.1539 251.918 31.8658 251.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4488 230.363C21.201 230.403 20.9533 230.467 20.6998 230.484C19.9853 230.536 19.2651 230.571 18.5507 230.617C18.4873 230.623 18.4182 230.652 18.3605 230.635C16.9662 230.16 15.5604 230.403 14.1546 230.403C12.766 230.403 11.3775 230.339 9.98896 230.299C9.93134 230.299 9.87373 230.235 9.79883 230.056C10.0351 230.003 10.2713 229.899 10.5075 229.905C11.9018 229.945 13.2904 230.038 14.6847 230.056C15.9004 230.073 17.116 230.009 18.3317 229.986C18.5449 229.98 18.7639 229.992 18.977 230.003C19.7894 230.061 20.6018 230.131 21.4142 230.195C21.4315 230.247 21.443 230.305 21.4488 230.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.913 227.889C111.838 228.526 111.446 228.798 111.129 229.129C110.945 229.326 110.691 229.395 110.461 229.499C110.363 229.54 110.225 229.575 110.144 229.511C109.769 229.21 109.303 228.978 109.066 228.52C108.853 228.103 108.842 227.425 108.83 226.858C108.824 226.475 108.963 226.087 109.043 225.699C109.084 225.491 109.176 225.282 109.17 225.079C109.13 224.309 109.47 223.683 109.556 222.965C109.62 222.409 109.873 221.98 110.202 221.737C110.737 221.349 111.302 221.047 111.878 220.775C111.728 221.297 111.365 221.36 111.072 221.517C109.936 222.119 109.718 222.542 109.706 224.234C109.706 224.564 109.654 224.906 109.585 225.224C109.435 225.966 109.234 226.684 109.107 227.431C109.066 227.663 109.153 227.987 109.251 228.202C109.625 229.024 110.524 229.215 111.072 228.607C111.325 228.323 111.561 228.016 111.803 227.715C111.838 227.773 111.872 227.831 111.913 227.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.469 237.25C164.44 236.903 164.422 236.7 164.405 236.497C164.682 236.266 164.947 236.051 165.252 235.796C165.523 235.993 165.707 236.497 166.116 236.503C166.197 236.503 166.283 236.914 166.393 237.216C165.99 237.187 165.684 237.164 165.35 237.14C165.315 237.332 165.287 237.494 165.269 237.598C164.814 237.801 164.388 238.009 163.95 238.177C163.685 238.282 163.403 238.374 163.132 238.374C162.959 238.374 162.734 238.258 162.619 238.079C162.538 237.951 162.602 237.639 162.602 237.326C163.23 237.488 163.737 236.399 164.469 237.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.006 132.734C25.8735 133.418 26.4266 133.771 26.5706 134.379C26.7204 135.011 26.9566 135.601 27.1641 136.256C27.3427 136.117 27.4579 136.036 27.5731 135.943C27.7575 136.47 27.89 137.009 28.3913 137.009C28.5123 137.009 28.6678 137.189 28.7543 137.345C28.9559 137.704 29.1172 138.104 29.2382 138.602C28.7312 138.226 28.2127 137.878 27.7287 137.461C27.3945 137.177 27.1007 136.795 26.8011 136.436C26.6686 136.279 26.5303 136.1 26.4496 135.885C26.006 134.686 25.5854 133.481 25.159 132.271C25.1302 132.178 25.1533 132.05 25.1533 131.848C25.4529 132.149 25.6891 132.398 26.006 132.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4766 101.944C87.6436 101.637 87.805 101.319 87.9778 101.017C88.4906 100.102 89.2108 99.8879 89.9713 99.9458C90.4899 99.9863 91.0084 100.131 91.5212 100.247C91.8323 100.317 92.0686 100.519 92.2875 100.878C92.5698 101.336 92.9328 101.689 93.267 102.089C93.5896 101.962 93.8892 101.84 94.2464 101.695C93.9468 102.564 93.3707 102.79 92.8867 102.28C92.5756 101.95 92.2875 101.556 92.0225 101.151C91.792 100.797 91.5558 100.682 91.2158 100.71C90.8298 100.739 90.438 100.641 90.0578 100.56C89.7236 100.49 89.424 100.56 89.1244 100.809C88.8363 101.046 88.4848 101.145 88.1795 101.353C88.0297 101.458 87.926 101.684 87.7935 101.834C87.707 101.933 87.5976 102.002 87.4996 102.083C87.4881 102.031 87.4823 101.991 87.4766 101.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.626 180.902C153.775 181.331 153.925 181.76 154.046 182.125C154.254 182.246 154.473 182.304 154.599 182.49C154.663 182.582 154.571 183.086 154.513 183.104C154.104 183.22 154.138 184.372 153.574 183.978C153.096 183.642 152.75 183.04 152.577 182.327C152.508 182.049 152.577 181.655 152.663 181.354C152.842 180.694 153.067 180.062 153.28 179.419C153.47 178.834 153.678 178.267 154.265 178.041C154.023 178.672 153.816 179.182 153.637 179.709C153.585 179.854 153.591 180.045 153.597 180.219C153.603 180.462 153.631 180.7 153.649 180.943C153.539 180.879 153.424 180.81 153.257 180.711C153.286 181.319 152.71 181.632 152.992 182.281C153.199 182.762 153.378 183.301 153.827 183.492C153.764 182.588 153.695 181.748 153.626 180.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0938 249.543C38.9292 249.514 39.7646 249.514 40.6 249.456C41.0437 249.427 41.5449 249.763 41.9252 249.132C41.9367 249.114 42.1096 249.387 42.2133 249.387C42.9047 249.398 43.5903 249.369 44.2817 249.352C44.322 249.352 44.3681 249.317 44.4085 249.329C44.8406 249.468 45.2785 249.612 45.6702 249.74C44.6677 250.128 38.9349 250.093 38.0938 249.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.3 241.89C168.058 242.296 167.902 242.568 167.735 242.823C167.609 243.026 167.493 243.281 167.326 243.385C166.992 243.594 166.79 243.316 166.802 242.771C166.814 242.226 166.756 241.682 166.779 241.143C166.808 240.442 167.194 240.129 167.637 240.436C168.093 240.743 168.323 241.271 168.3 241.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6638 64.1106C51.393 63.9658 51.2087 63.8209 51.007 63.763C50.5345 63.6124 50.5288 63.624 50.6383 62.7898C51.37 63.1084 52.1017 62.9462 52.8392 62.8072C52.9026 62.7956 52.9717 62.7898 53.0351 62.8072C53.9742 63.0621 54.9076 63.317 55.841 63.5892C55.9332 63.6182 56.0138 63.734 56.227 63.9252C55.9677 63.96 55.8583 64.0063 55.7545 63.9831C54.9018 63.7978 54.0491 63.5603 53.1906 63.4096C52.626 63.3112 52.0383 63.2474 51.6638 64.1106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.72 151.266C193.46 150.993 193.455 150.727 193.57 150.466C193.887 149.742 194.14 148.966 194.705 148.479C195.125 148.12 195.506 147.628 195.679 146.915C195.702 146.828 195.725 146.724 195.771 146.672C196.456 145.855 197.073 144.911 197.908 144.071C197.712 144.76 196.912 146 196.537 146.411C196.289 146.683 196.053 147.019 195.88 147.39C195.563 148.056 195.316 148.711 194.751 149.14C194.342 149.447 194.134 150.269 193.841 150.866C193.783 150.959 193.766 151.08 193.72 151.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.064 160.552C176.984 160.285 176.88 160.024 176.828 159.746C176.632 158.669 176.471 157.586 176.269 156.508C176.033 155.24 176.408 154.139 176.753 153.056C176.903 152.581 177.439 152.546 177.871 152.905C178.009 153.021 178.113 153.229 178.228 153.392C178.205 153.455 178.182 153.519 178.159 153.583C177.975 153.49 177.785 153.421 177.606 153.299C177.18 153.003 177.157 153.021 176.92 153.635C176.58 154.533 176.684 155.5 176.719 156.444C176.742 157.116 176.857 157.783 176.926 158.449C177.001 159.132 177.076 159.822 177.151 160.505C177.128 160.517 177.099 160.534 177.064 160.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.318 28.4319C246.341 28.2523 246.37 27.9743 246.405 27.6962C246.704 28.3276 247.194 28.2349 247.551 28.4609C248.012 28.7505 248.318 28.0148 248.744 27.8932C248.692 27.7367 248.646 27.6035 248.606 27.4703C249.067 27.2501 249.078 27.2559 249.493 28.0322C249.263 28.3971 249.124 28.9359 248.715 29.017C247.909 29.185 247.073 29.7006 246.318 28.4319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.225 230.884C105.667 230.884 103.108 230.884 100.55 230.884C100.539 230.832 100.533 230.78 100.521 230.728C100.614 230.658 100.706 230.536 100.798 230.536C101.639 230.507 102.486 230.49 103.327 230.502C104.197 230.513 105.073 230.583 105.943 230.588C106.352 230.594 106.756 230.507 107.165 230.478C107.522 230.455 107.885 230.392 108.225 230.612C108.225 230.699 108.225 230.791 108.225 230.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7344 207.672C24.8669 207.498 24.9879 207.307 25.1319 207.156C25.564 206.693 26.025 206.27 26.4456 205.783C27.3444 204.746 27.2407 202.446 25.8694 201.763C25.7887 201.722 25.7196 201.641 25.5929 201.543C25.6678 201.299 25.7369 201.073 25.8406 200.737C26.6069 201.676 27.2291 202.62 27.3156 203.993C27.3444 204.428 27.1427 204.955 26.9468 205.343C26.6991 205.841 26.3591 206.258 26.0423 206.675C25.8636 206.919 25.6332 207.052 25.4891 207.399C25.3854 207.643 25.0513 207.677 24.8208 207.805C24.792 207.758 24.7632 207.712 24.7344 207.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.104 156.23C234.266 156.578 234.404 156.873 234.559 157.203C234.289 157.493 234.064 157.568 233.943 157.151C233.718 156.404 233.54 155.628 233.344 154.863C233.897 154.243 234.398 154.179 234.629 154.701C234.865 155.234 234.692 155.761 234.104 156.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6413 197.36C48.108 197.435 48.7014 198.125 48.7418 198.652C48.7533 198.785 48.7014 199.011 48.638 199.057C48.3845 199.225 48.1195 199.376 47.8429 199.451C47.7219 199.486 47.5779 199.324 47.4454 199.26C47.3244 199.202 47.2034 199.144 46.9902 199.046C47.2149 198.467 47.4281 197.91 47.6413 197.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1223 148.085C55.9494 147.471 55.9494 147.471 56.1626 146.927C56.3124 147.176 56.4334 147.396 56.5659 147.616C56.854 147.523 56.7445 147.147 56.8194 146.88C56.8886 146.631 57.0787 146.452 57.24 146.208C57.4129 146.463 57.3092 146.735 57.2458 147.002C57.24 147.019 56.7445 147.917 56.7388 147.929C56.249 148.792 55.3214 148.635 54.872 149.69C54.5667 148.902 55.1774 148.879 55.2523 148.468C55.3675 147.824 55.7708 148.137 56.1223 148.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66015 89.1882C7.06922 89.7907 7.70299 90.0398 7.80094 91.013C7.41491 91.5286 7.34577 91.5402 6.95399 91.152C6.712 90.9145 6.45273 90.7118 6.23381 90.4337C5.91692 90.0282 5.94573 89.7791 6.29717 89.4431C6.40664 89.3504 6.52763 89.2809 6.66015 89.1882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.578 26.3811C187.578 26.6186 187.555 26.8677 187.584 27.0995C187.642 27.5976 187.406 27.7483 187.152 27.8699C186.91 27.9858 186.455 27.6845 186.328 27.3254C186.213 27.0068 186.173 26.6708 186.409 26.4159C186.611 26.1958 186.818 25.9467 187.048 25.8018C187.423 25.5759 187.648 25.8192 187.578 26.3811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5973 248.836C75.1767 249.126 74.7215 249.178 74.2549 249.126C73.938 249.091 73.6384 249.08 73.5174 249.647C73.3618 249.375 73.2351 249.149 73.0449 248.819C73.2178 248.819 73.31 248.825 73.4021 248.819C73.5058 248.807 73.6153 248.778 73.7305 248.755C73.6672 248.234 73.6038 247.747 73.5519 247.342C73.7133 246.971 73.8573 246.635 74.0071 246.293C74.2606 246.415 74.2952 246.676 74.2952 246.959C74.2952 247.017 74.2606 247.075 74.2606 247.133C74.203 248.755 74.2894 249.074 75.4821 248.79C75.5166 248.79 75.557 248.825 75.5973 248.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.156 5.97266C135.689 6.58671 135.309 6.60409 134.935 6.03638C134.831 5.87997 134.733 5.71198 134.641 5.54398C134.462 5.23116 134.474 4.92414 134.664 4.63449C134.86 4.33905 135.113 4.33905 135.315 4.54759C135.661 4.90096 136.035 5.24275 136.156 5.97266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9922 230.171C23.0095 230.189 23.0325 230.223 23.0498 230.218C23.7527 229.94 24.4556 230.108 25.1701 230.183C26.0804 230.281 26.9907 230.27 27.9011 230.31C27.999 230.316 28.1027 230.334 28.2179 230.461C28.0163 230.519 27.8089 230.623 27.6072 230.623C26.2648 230.623 24.9166 230.606 23.5741 230.577C23.3436 230.577 23.0671 230.629 22.9922 230.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.559 230.449C110.373 230.212 112.188 230.305 114.084 230.322C113.733 230.728 113.733 230.722 112.269 230.704C111.641 230.699 111.019 230.722 110.391 230.722C109.78 230.722 109.169 230.699 108.559 230.687C108.559 230.612 108.559 230.531 108.559 230.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35026 230.177C7.60449 230.177 5.86451 230.177 4.11875 230.177C4.11299 230.102 4.10146 230.026 4.0957 229.951C4.2167 229.916 4.34345 229.847 4.47021 229.841C5.28835 229.812 6.10074 229.789 6.91886 229.766C7.56416 229.748 8.2037 230.061 8.85476 229.766C8.9988 229.702 9.20622 229.934 9.38482 230.032C9.3733 230.084 9.36178 230.131 9.35026 230.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.269 56.4756C205.336 58.3351 204.483 60.0267 203.619 61.7356C203.688 61.1795 203.74 60.6002 203.844 60.044C203.884 59.8239 204.045 59.6501 204.161 59.4705C204.576 58.8101 205.002 58.1555 205.411 57.4894C205.474 57.3793 205.509 57.2171 205.532 57.0723C205.618 56.5567 205.613 56.5567 206.269 56.4756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6523 212.769C26.7503 212.497 26.8137 212.323 26.831 212.277C27.4359 212.312 27.9717 212.346 28.5018 212.375C28.6055 212.381 28.7208 212.312 28.8187 212.341C29.2163 212.474 29.5562 212.439 29.6772 211.634C29.7117 211.692 29.7463 211.75 29.7866 211.808C29.7866 211.947 29.7866 212.086 29.7866 212.265C30.1323 212.514 30.4665 212.497 30.7373 212.074C31.0484 212.242 31.3192 212.387 31.5958 212.532C31.204 212.607 30.8929 213.059 30.3916 212.729C30.0171 212.485 29.4813 212.381 29.0376 212.821C28.9282 212.932 28.6862 212.949 28.5767 212.85C28.329 212.625 28.1043 212.659 27.8392 212.711C27.5972 212.758 27.3437 212.63 27.0902 212.619C26.9808 212.613 26.8713 212.688 26.6523 212.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73288 245.61C8.42751 246.392 7.94354 246.264 7.52294 246.403C7.53447 246.502 7.53447 246.583 7.54599 246.658C7.55751 246.733 7.5748 246.809 7.61513 247.012C7.38467 246.809 7.2291 246.67 7.03321 246.49C6.71632 246.826 6.38791 247.174 6.04797 247.539C5.87512 247.469 5.82903 247.29 5.94426 247.064C6.22082 246.537 6.52043 246.056 7.01016 245.911C7.41347 245.789 7.81102 245.639 8.21434 245.534C8.35261 245.5 8.50818 245.569 8.73288 245.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6704 166.246C54.7683 166.495 54.8605 166.744 54.9585 166.993C54.9239 167.051 54.8951 167.104 54.8605 167.161C54.6243 167.022 54.3881 166.889 54.1115 166.727C54.2152 167.156 54.3016 167.509 54.3823 167.851C54.002 168.135 53.6621 168.39 53.2012 168.731C53.2876 168.088 53.351 167.613 53.4143 167.144C53.4201 167.115 53.4028 167.057 53.4086 167.057C53.8407 166.883 54.0712 166.159 54.5724 166.182C54.6128 166.182 54.6473 166.24 54.6819 166.269L54.6704 166.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8867 147.199C100.97 146.88 104.888 146.979 105.556 147.361C103.563 147.408 101.725 147.292 99.8867 147.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.172 89.7561C222.46 90.1732 222.725 90.515 222.949 90.9089C223.099 91.1754 223.013 91.8879 222.84 92.0038C222.581 92.1776 222.356 92.1022 222.143 91.7894C221.665 91.0827 221.647 90.8336 222.172 89.7561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60259 210.672C4.15895 211.217 3.80173 211.709 3.40418 212.121C3.27166 212.26 3.02968 212.213 2.83955 212.207C2.7416 212.207 2.63789 212.115 2.5918 211.993C3.39842 211.767 3.61736 211.576 4.1071 210.533C3.82478 210.22 3.52517 209.89 3.20253 209.525C3.13339 209.63 3.0412 209.774 2.92021 209.966C2.87988 209.844 2.82802 209.751 2.83955 209.705C2.92021 209.438 2.98358 209.027 3.12186 208.958C3.27166 208.888 3.5367 209.079 3.68074 209.265C3.99186 209.659 4.25113 210.116 4.60259 210.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.294 19.001C210.862 20.1885 210.286 20.9764 209.451 21.3587C209.001 21.5615 208.834 21.4572 208.552 20.9532C208.367 20.623 208.154 20.3276 207.918 19.9568C208.223 19.8294 208.396 20.0495 208.529 20.3044C209.007 21.2139 209.427 20.988 209.929 20.4666C210.326 20.0495 210.684 19.5455 211.064 19.0879C211.098 19.0415 211.167 19.0473 211.294 19.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.166 161.693C127.826 161.838 127.792 161.496 127.711 161.27C127.59 160.917 127.394 160.859 127.169 160.969C126.939 161.079 126.933 161.351 126.985 161.647C127.048 162.017 127.1 162.394 127.164 162.817C126.789 162.631 126.443 161.855 126.484 161.397C126.524 160.922 126.933 160.262 127.244 160.256C127.406 160.256 127.578 160.36 127.722 160.488C127.959 160.696 128.051 160.998 128.166 161.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.116 129.293C157.053 129.223 156.995 129.194 156.99 129.148C156.88 128.192 156.373 128.013 155.82 127.914C155.664 127.885 155.509 127.81 155.342 127.752C155.44 126.953 156.177 127.787 156.091 126.802C156.379 127.092 156.465 127.428 156.782 127.306C157.007 127.219 157.128 127.688 157.099 128.412C157.237 128.523 157.381 128.638 157.543 128.766C157.376 128.974 157.243 129.137 157.116 129.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6855 137.438C97.8181 137.548 97.9794 137.629 98.0831 137.785C98.3942 138.255 98.7053 138.741 98.9819 139.251C99.2815 139.807 99.2642 140.288 98.9819 140.549C98.7687 140.746 98.4403 140.583 98.4922 140.282C98.6362 139.425 98.1638 138.996 97.9275 138.405C97.8181 138.127 97.6855 137.866 97.5703 137.6C97.6049 137.548 97.6452 137.496 97.6855 137.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0156 213.719C25.6321 214.067 26.6346 214.142 27.0207 213.621C27.9195 214.281 28.9105 213.847 29.8381 214.212C29.4693 214.252 29.1006 214.31 28.7319 214.328C28.3746 214.345 28.0232 214.142 27.666 214.484C27.568 214.583 27.3087 214.276 27.1186 214.258C26.6001 214.212 26.0758 214.235 25.5515 214.212C25.344 214.2 25.0963 214.252 25.0156 213.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.222 125.719C199.412 124.931 198.847 124.097 199.354 123.315C200.005 123.651 200.086 123.894 199.93 125.041C199.85 125.684 199.792 125.742 199.222 125.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3517 145.652C72.7558 145.687 71.1598 145.727 69.5639 145.751C69.4313 145.751 69.2988 145.635 69.1836 145.438C70.9063 145.438 72.629 145.438 74.3517 145.438C74.3517 145.513 74.3517 145.583 74.3517 145.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.483 200.645C254.275 200.743 254.05 200.963 253.855 200.917C253.549 200.842 253.232 200.656 252.973 200.401C252.754 200.187 252.852 199.648 253.1 199.602C253.388 199.55 253.711 199.515 253.976 199.643C254.189 199.747 254.333 200.112 254.511 200.361C254.506 200.454 254.494 200.552 254.483 200.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4924 117.736C42.9393 118.466 42.1845 118.472 41.5334 118.871C41.1935 119.08 40.8248 119.179 40.4906 119.393C40.2198 119.567 39.9778 119.845 39.6724 120.123C39.4938 120.047 39.2461 119.949 38.9004 119.804C40.312 119.132 41.6199 118.501 42.9335 117.892C43.1121 117.806 43.3138 117.8 43.5039 117.759L43.4924 117.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5036 117.753C43.6765 117.597 43.8378 117.388 44.0222 117.284C45.4914 116.514 46.9606 115.761 48.4298 115.007C48.4586 114.99 48.5047 115.036 48.5969 115.077C48.4355 115.459 48.1475 115.535 47.917 115.65C46.5515 116.351 45.1802 117.018 43.8032 117.69C43.7053 117.736 43.5958 117.719 43.4863 117.73L43.5036 117.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.768 141.748C213.079 142.182 213.275 142.449 213.493 142.744C213.666 142.611 213.903 142.443 214.087 142.97C213.793 143.19 213.528 143.439 213.24 143.59C212.894 143.764 212.491 143.254 212.526 142.698C212.537 142.449 212.647 142.211 212.768 141.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.317 116.305C257.207 116.502 257.098 116.798 256.925 116.983C256.844 117.07 256.585 117.012 256.521 116.896C256.372 116.63 256.279 116.288 256.193 115.958C256.176 115.894 256.302 115.726 256.383 115.651C256.452 115.593 256.602 115.639 256.625 115.581C256.712 115.338 256.775 114.967 257 115.152C257.138 115.268 257.167 115.656 257.242 115.929C257.265 116.021 257.276 116.114 257.317 116.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.114 112.806C72.7222 113.606 72.2383 112.963 71.7428 113.27C71.8695 112.708 71.5181 112.192 71.979 111.81C72.0654 111.943 72.1461 112.065 72.244 112.221C72.2671 112.03 72.2901 111.873 72.3132 111.694C72.8432 111.74 72.7971 112.505 73.114 112.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9048 230.461C90.2998 230.988 87.8569 230.965 87.252 230.519C87.4594 230.473 87.6034 230.438 87.7417 230.409C87.7359 230.252 87.7302 230.102 87.7186 229.714C88.1047 230.502 88.5598 230.473 89.015 230.467C89.6488 230.449 90.2768 230.461 90.9048 230.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0654 191.405C16.76 191.579 16.5008 191.77 16.2242 191.88C16.0571 191.95 15.8612 191.892 15.625 191.892C15.7172 191.382 15.7921 190.947 15.8727 190.501C16.4489 190.31 16.8004 190.756 17.0654 191.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2535 153.316C48.6255 153.699 47.9917 154.075 47.3579 154.452C47.1966 154.544 47.0065 154.568 46.874 154.707C46.246 155.361 45.4566 155.263 44.7998 155.744C44.7825 155.68 44.7652 155.622 44.7422 155.564C45.0994 155.326 45.4451 155.048 45.8081 154.863C46.7242 154.4 47.646 153.965 48.5736 153.536C48.7926 153.432 49.0346 153.403 49.265 153.334L49.2535 153.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.291 237.216C52.4869 237.187 52.7347 237.146 53.04 237.094C52.6598 237.639 52.896 238.067 53.1034 238.507C53.282 238.878 53.4491 239.261 53.6219 239.649C53.3511 239.875 53.1322 239.834 53.0112 239.533C52.8268 239.093 52.6886 238.612 52.5388 238.143C52.4466 237.835 52.3717 237.517 52.291 237.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.352 245.019C259.743 245.413 260.383 245.303 260.446 246.316C260.297 246.583 260.055 246.606 259.83 246.484C259.571 246.345 259.265 246.189 259.104 245.899C258.902 245.546 259.104 245.221 259.352 245.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.025 15.1311C212.625 14.9168 213.062 14.2274 213.817 14.4302C213.593 14.6793 213.454 14.882 213.281 15.0211C213.028 15.2354 212.705 15.3223 212.717 15.8958C212.717 15.9711 212.55 16.1333 212.475 16.1102C212.342 16.0696 212.181 15.9653 212.112 15.8147C212.043 15.6583 212.06 15.4092 212.025 15.1311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.377 234.157C124.581 233.508 124.973 232.604 124.904 231.811C125.129 232.014 125.359 232.222 125.624 232.465C125.549 232.981 125.474 233.473 125.377 234.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.561 248.969C108.155 248.969 106.755 248.969 105.229 248.969C105.776 248.686 109.043 248.587 109.561 248.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.317 180.294C110.68 180.972 110.731 181.725 110.449 182.212C110.369 182.356 110.178 182.478 110.069 182.443C109.965 182.414 109.844 182.165 109.827 181.991C109.752 181.319 109.977 180.804 110.317 180.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8167 212.555C94.9665 212.862 95.0702 213.088 95.2142 213.389C95.001 213.65 94.8167 213.905 94.6092 214.108C94.4133 214.299 94.1829 214.305 94.0158 214.026C93.8314 213.719 93.9467 213.418 94.1195 213.21C94.3154 212.978 94.5459 212.804 94.8167 212.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.296 84.0094C13.1347 84.2006 12.9964 84.3628 12.7948 84.6003C12.7256 84.2237 12.6853 83.9746 12.645 83.7429C12.3857 83.5054 12.138 83.2563 11.8787 83.0536C11.6194 82.8566 11.3429 82.706 11.0605 82.5264C11.798 82.3063 12.6392 82.8392 13.296 84.0094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49609 46.8592C3.7208 46.8592 3.85331 46.8592 4.0204 46.8592C4.03768 46.8012 4.07801 46.6912 4.10106 46.5811C4.1702 46.303 4.28543 45.996 4.49861 46.1235C4.68874 46.2451 4.89616 46.5348 4.95378 46.807C5.02291 47.143 4.77517 47.3226 4.56199 47.4095C4.01464 47.6296 3.7957 47.5311 3.49609 46.8592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.402 75.2851C160.039 75.2793 159.854 75.036 159.866 74.5842C159.877 74.2018 160.05 73.9875 160.332 74.0049C160.759 74.0281 161.047 74.3351 161.042 74.7464C161.042 75.1171 160.828 75.2967 160.402 75.2851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.877 230.571C34.3667 230.177 36.5619 230.079 37.1034 230.357C36.533 230.617 36.0087 230.646 35.4787 230.623C34.9486 230.6 34.4128 230.588 33.877 230.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.553 1.55843C110.565 1.84228 110.582 2.13193 110.6 2.3984C110.409 2.51426 110.237 2.61854 110.041 2.7344C109.81 2.31151 109.574 1.88283 109.332 1.43677C109.516 1.32671 109.66 1.24561 109.764 1.18188C109.879 1.47733 109.879 1.47733 110.553 1.55843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.449 257.479C250.616 257.856 250.783 258.238 250.962 258.638C250.852 258.812 250.789 259.014 250.685 259.067C250.495 259.165 250.253 259.287 250.086 259.194C249.832 259.055 249.924 258.667 249.988 258.383C250.057 258.076 250.172 257.792 250.27 257.497C250.328 257.485 250.385 257.479 250.449 257.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.973 175.973C258.402 177.05 258.402 177.05 258.874 178.4C258.315 177.988 257.313 176.743 256.973 175.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.691 109.609C257.835 109.446 257.956 109.284 258.095 109.151C258.21 109.041 258.4 108.832 258.452 108.884C258.596 109.023 258.705 109.267 258.792 109.493C258.832 109.609 258.815 109.8 258.786 109.939C258.74 110.13 258.688 110.396 258.59 110.454C258.492 110.512 258.314 110.385 258.204 110.269C258.026 110.084 257.87 109.84 257.691 109.609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.996 259.912C16.8231 259.889 16.6272 259.872 16.3968 259.843C16.3046 259.182 16.5927 258.337 15.9531 257.873C16.0338 257.67 16.1029 257.497 16.1778 257.311C16.27 257.363 16.3507 257.369 16.3795 257.433C16.4774 257.665 16.5754 257.896 16.633 258.151C16.7655 258.725 16.875 259.316 16.996 259.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8288 250.082C64.074 250.082 63.2097 250.082 62.3455 250.082C62.3397 250.012 62.3397 249.943 62.334 249.873C62.8929 249.752 63.446 249.63 64.0337 249.502C64.3102 249.699 64.6213 249.931 64.8288 250.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2633 246.235C12.9752 246.438 12.7217 246.461 12.5488 246.177C12.3702 245.882 12.2319 245.517 12.134 245.152C12.0706 244.903 12.2953 244.671 12.4739 244.816C12.8542 245.123 13.2517 245.43 13.2633 246.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12863 117.029C7.22406 118.437 6.50386 119.995 5.21328 120.586C5.18447 120.534 5.15566 120.482 5.12109 120.43C5.26513 120.291 5.39765 120.134 5.55321 120.018C6.29068 119.462 6.97631 118.848 7.3681 117.73C7.48909 117.371 7.67346 116.977 8.12863 117.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1382 106.324C92.2938 106.666 92.4551 106.915 92.5243 107.205C92.5588 107.355 92.4839 107.68 92.3917 107.755C92.1958 107.911 91.9596 107.969 91.7292 108.016C91.7004 108.021 91.5909 107.714 91.6024 107.564C91.637 107.123 91.7695 106.741 92.1382 106.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.588 65.4199C136.122 66.3931 135.47 66.4742 134.768 66.5321C134.998 65.8659 136.001 65.2519 136.588 65.4199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6007 107.314C22.6986 107.349 22.7966 107.384 22.9464 107.436C23.027 106.695 22.7966 105.884 23.1826 105.049C23.2287 106.376 23.269 107.529 23.3094 108.681C23.269 108.693 23.2229 108.71 23.1826 108.722C23.125 108.461 23.1135 108.154 23.004 107.946C22.9003 107.743 22.7044 107.639 22.5488 107.494C22.5661 107.43 22.5834 107.372 22.6007 107.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.434 89.4548C228.969 89.0378 229.332 89.5128 229.459 90.8046C229.367 90.8278 229.246 90.9205 229.188 90.8683C228.814 90.5265 228.52 90.0979 228.434 89.4548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.359 250.18C191.428 249.711 191.497 249.248 191.572 248.773C191.019 248.419 190.679 247.973 190.489 247.243C190.414 246.954 190.114 246.786 189.947 246.6C190.397 246.554 190.518 246.623 190.691 247.237C190.812 247.655 190.944 248.031 191.249 248.205C191.491 248.344 191.768 248.419 191.774 248.9C191.779 249.421 191.849 249.972 191.411 250.256C191.393 250.232 191.376 250.209 191.359 250.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.364 242.064C157.162 242.481 157.099 242.864 157.439 243.2C156.869 243.31 156.35 243.049 155.797 242.985C156.292 242.696 156.788 242.406 157.364 242.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7473 58.8506C56.0354 59.1171 56.2428 59.3024 56.4791 59.5226C56.1564 59.6616 55.8741 59.7311 55.6263 59.9165C55.3671 60.1077 55.1654 60.4958 54.7852 60.3046C54.9177 59.5284 55.442 59.3662 55.7473 58.8506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.622 229.198C204.397 229.215 204.189 229.314 204.028 229.227C203.826 229.111 203.625 228.879 203.498 228.625C203.371 228.37 203.59 228.057 203.844 228.086C204.172 228.132 204.403 228.439 204.622 229.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1154 80.8406C52.9022 81.4546 52.4413 80.9333 51.9746 81.1418C52.0207 80.7653 52.0208 80.4872 52.0957 80.2787C52.2455 79.8674 52.4874 79.8094 52.7352 80.1165C52.8735 80.296 52.9656 80.5509 53.1154 80.8406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0149 35.6616C98.2454 35.7832 98.4816 36.0729 98.6948 35.6442C98.7294 35.5805 98.9656 35.7195 99.0636 35.7542C99.0808 36.1134 99.0981 36.4031 99.1154 36.7043C99.1096 36.7043 99.0751 36.7217 99.0405 36.7448C98.8792 36.8317 98.7236 36.9186 98.5623 37.0055C98.5104 36.7854 98.4932 36.5363 98.401 36.3625C98.2915 36.1598 98.1186 36.0323 97.9746 35.8759C97.9861 35.8064 98.0034 35.7311 98.0149 35.6616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3574 94.4772C12.5764 94.1934 12.7953 93.9095 13.0258 93.6141C12.9451 93.3418 12.8702 93.0985 12.8126 92.8958C12.9278 92.5829 13.2101 92.6177 13.2908 92.9073C13.3657 93.1854 13.4176 93.4808 13.4867 93.8168C13.164 94.1412 12.9105 94.68 12.3574 94.4772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.211 121.959C247.608 121.05 247.954 121.084 248.415 122.017C248.052 122.602 247.781 122.596 247.211 121.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51367 111.7C3.75566 111.943 3.92274 112.117 4.09559 112.279C4.29725 112.464 4.43552 112.725 4.29725 113.026C4.22234 113.188 4.0034 113.293 3.8536 113.281C3.60009 113.258 3.4042 113.026 3.39844 112.638C3.39844 112.383 3.46181 112.117 3.51367 111.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.931 1.9812C22.9541 2.42726 22.9253 2.83277 23.0117 3.18614C23.0981 3.5453 23.294 3.85232 23.438 4.17673C23.1845 4.449 23.0405 4.27521 22.931 4.01453C22.8216 3.74805 22.7467 3.4584 22.6372 3.19772C22.2972 2.40409 22.3088 2.34616 22.931 1.9812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.852 229.922C126.949 230.212 127.053 230.507 127.163 230.832C127.042 230.982 126.961 231.133 126.852 231.214C126.65 231.37 126.391 231.428 126.275 231.11C126.218 230.942 126.333 230.623 126.402 230.391C126.46 230.2 126.569 230.044 126.656 229.87C126.725 229.882 126.788 229.905 126.852 229.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.453 31.4267C109.136 31.1313 109.009 30.8474 109.073 30.4999C109.124 30.2102 109.176 29.9901 108.969 29.7873C108.928 29.7468 108.923 29.5267 108.963 29.4687C109.026 29.3702 109.176 29.2544 109.222 29.2949C109.378 29.434 109.614 29.6309 109.62 29.8105C109.62 30.3203 109.522 30.8301 109.453 31.4267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.509 165.331C212.221 165.678 211.945 165.696 211.685 165.47C211.564 165.36 211.42 165.076 211.449 164.931C211.484 164.752 211.673 164.537 211.817 164.514C212.197 164.456 212.4 164.798 212.509 165.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4674 164.103C81.4443 164.41 81.2773 164.526 81.0583 164.526C80.7702 164.531 80.5686 164.23 80.5743 163.83C80.5801 163.471 80.6838 163.222 80.9488 163.211C81.1735 163.199 81.4731 163.709 81.4674 164.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9432 99.4361C34.7588 99.8474 34.5744 100.056 34.2863 99.7316C34.0905 99.5114 34.0213 98.9611 34.1481 98.6367C34.2633 98.3413 34.4707 98.3065 34.6148 98.6019C34.7357 98.851 34.8222 99.1291 34.9432 99.4361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5895 34.3638C24.3993 34.8388 24.0825 34.972 23.731 34.9662C23.6446 34.9662 23.5005 34.8504 23.4833 34.7519C23.4602 34.6013 23.4833 34.3812 23.5524 34.2653C23.8405 33.7845 24.2035 33.825 24.5895 34.3638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.998 242.661C20.1824 242.302 20.3265 242.018 20.4705 241.74C20.9372 241.89 20.9257 242.464 21.1446 242.945C20.7528 242.881 20.4014 243.09 19.998 242.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7013 138.747C64.3326 139.124 64.1021 139.703 63.5605 139.558C63.3185 139.245 63.5432 139.037 63.7334 138.817C64.2289 138.272 64.2461 138.266 64.7013 138.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7878 253.894C58.0067 254.119 58.2027 254.403 58.4447 254.548C58.6694 254.687 58.9402 254.681 59.188 254.844C58.8768 254.942 58.5945 254.936 58.3468 255.29C58.197 255.498 57.9894 255.278 57.9203 254.965C57.8512 254.652 57.782 254.345 57.7129 254.033C57.7417 253.98 57.7647 253.94 57.7878 253.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1968 100.566C63.0931 101.348 62.6725 101.568 62.3614 101.91C62.3038 101.973 62.1021 101.956 62.0791 101.886C62.0272 101.753 62.0099 101.533 62.056 101.4C62.1079 101.249 62.2289 101.128 62.3441 101.052C62.5919 100.89 62.8569 100.757 63.1968 100.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.072 204.972C234.766 205.488 234.495 205.592 234.265 205.325C234.081 205.111 234.069 204.677 234.242 204.427C234.467 204.103 234.628 204.202 235.072 204.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0273 86.3844C98.252 86.3091 98.471 86.1296 98.5689 86.2222C98.7706 86.4076 98.955 86.7089 99.0587 87.0217C99.1336 87.2534 98.955 87.404 98.7764 87.3577C98.4652 87.2708 98.2175 87.0391 98.0273 86.3844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60938 90.8276C9.90898 90.8276 10.0933 90.8276 10.2201 90.8276C10.2777 91.5112 10.3296 92.1774 10.393 92.9421C9.78798 92.4555 9.9954 91.5228 9.60938 90.8276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.986 148.96C190.118 149.25 190.331 149.51 190.326 149.765C190.32 149.985 190.089 150.229 189.928 150.397C189.749 150.576 189.588 150.449 189.548 150.153C189.49 149.713 189.53 149.302 189.986 148.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3247 183.185C53.8868 183.347 53.616 183.069 53.4086 182.652C53.3568 182.548 53.3337 182.316 53.3741 182.246C53.4432 182.13 53.593 182.026 53.6852 182.049C54.1058 182.148 54.2786 182.571 54.3247 183.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.256 257.607C120.4 257.914 120.515 258.093 120.578 258.314C120.665 258.615 120.572 258.87 120.371 258.98C120.25 259.043 120.014 259.067 119.973 258.98C119.898 258.806 119.887 258.534 119.927 258.331C119.973 258.111 120.106 257.931 120.256 257.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.953 9.8944C118.556 10.381 118.279 10.2883 117.997 10.045C117.818 9.8944 117.738 9.65689 117.864 9.43096C117.934 9.29773 118.147 9.16449 118.233 9.22242C118.469 9.37303 118.677 9.63372 118.953 9.8944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1348 170.881C84.4862 170.782 84.8377 170.689 85.2813 170.568C85.3965 170.684 85.5867 170.875 85.7768 171.072C85.7595 171.141 85.7365 171.217 85.7192 171.286C85.1834 171.367 84.6591 171.211 84.1348 171.066C84.1348 171.002 84.1348 170.939 84.1348 170.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.414 82.625C213.062 83.0479 212.791 83.0305 212.515 82.8914C212.342 82.8045 212.181 82.6713 212.273 82.3585C212.354 82.092 212.503 81.8429 212.728 81.982C212.953 82.1268 213.149 82.3701 213.414 82.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3721 172.329C52.2799 172.022 52.2338 171.888 52.1992 171.773C52.205 171.286 52.9194 171.286 52.5392 170.556C52.833 170.469 53.0923 170.284 53.3919 170.747C52.856 170.967 52.7408 171.692 52.3721 172.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70213 23.2878C5.41981 23.6064 5.18934 23.867 4.92431 24.1683C4.84941 23.8265 4.78603 23.5311 4.72266 23.2182C4.83213 23.1951 4.93583 23.1719 5.10292 23.1371C5.01074 22.8996 4.94736 22.7258 4.87822 22.5463C4.90127 22.5231 4.92431 22.4941 4.94736 22.4709C5.1663 22.72 5.39676 22.9633 5.70213 23.2878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.991 229.32C227.409 228.474 227.236 227.368 227.052 226.273C227.023 226.093 227.052 226.076 227.368 225.786C227.409 226.418 227.386 227.066 227.513 227.646C227.634 228.208 227.899 228.7 228.106 229.221C228.066 229.256 228.031 229.285 227.991 229.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.467 230.374C143.594 230.641 143.703 230.861 143.807 231.069C143.387 231.759 143.26 231.764 142.689 231.087C142.949 230.849 143.185 230.629 143.467 230.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4238 101.997C26.121 101.695 26.121 101.695 26.6568 102.645C26.5473 102.697 26.3975 102.808 26.3745 102.773C26.1556 102.361 25.8617 102.414 25.5506 102.547C25.4987 102.327 25.4642 102.165 25.4238 101.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.91 171.002C71.5125 171.118 71.1149 171.332 70.7174 171.321C70.2968 171.309 69.8819 171.083 69.4844 170.956C69.9165 170.678 70.0721 170.718 70.4927 170.828C70.8614 170.921 71.2474 170.851 71.6277 170.857C71.7199 170.857 71.8121 170.875 71.9042 170.88C71.9042 170.921 71.9042 170.962 71.91 171.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8086 170.898C77.0942 171.066 76.3798 171.327 75.5098 170.973C75.6999 170.759 75.8382 170.544 75.867 170.573C76.374 171.008 76.9271 170.788 77.4629 170.84C77.5782 170.851 77.6934 170.88 77.8086 170.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8777 250.302C68.1863 250.377 67.4949 250.481 66.8496 249.96C67.4027 250.006 67.9789 249.508 68.5205 250.14C68.6127 250.25 68.7625 250.25 68.8892 250.308L68.8777 250.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.121 170.95C229.663 170.516 230.245 170.504 230.919 170.875C230.314 171.489 229.709 170.927 229.121 170.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1428 170.811C82.3189 171.193 81.109 171.118 80.5098 170.678C81.472 170.689 82.3074 170.782 83.1428 170.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.848 57.7095C235.026 57.4256 235.205 57.1418 235.378 56.8579C235.631 56.8521 235.867 56.9448 235.844 57.3214C235.833 57.5067 235.614 57.7269 235.458 57.8195C235.291 57.918 235.09 57.8833 234.905 57.9122C234.888 57.8427 234.865 57.779 234.848 57.7095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.75 173.673C73.1821 173.539 73.3492 173.91 73.5048 174.223C73.6315 174.484 73.5739 174.756 73.3607 174.912C73.136 175.075 72.9113 174.953 72.8537 174.611C72.7961 174.327 72.7846 174.026 72.75 173.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.217 170.724C231.816 170.724 232.409 170.724 233.112 170.724C232.64 171.101 231.874 171.118 231.217 170.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.852 163.854C56.192 164.317 56.192 164.317 56.3014 165.174C56.1977 165.244 56.0883 165.314 56.0537 165.337C55.829 164.954 55.6389 164.636 55.4199 164.265C55.5006 164.051 55.587 163.784 55.8636 163.859L55.852 163.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.375 239.591C179.588 240.124 179.796 240.657 180.032 241.253C179.513 241.247 179.173 240.471 179.231 239.678C179.277 239.643 179.329 239.62 179.375 239.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8938 123.871C27.3662 124.328 27.3662 124.328 27.1934 125.139C26.8822 125.22 26.7267 124.948 26.6287 124.583C26.525 124.212 26.6633 124.004 26.8938 123.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.088 212.903C214.266 212.798 214.422 212.677 214.583 212.63C214.791 212.572 215.004 212.885 214.992 213.198C214.975 213.546 214.791 213.551 214.612 213.546C214.364 213.528 214.128 213.47 214.088 212.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6704 138.081C68.3477 138.005 68.0885 137.988 67.8522 137.872C67.7543 137.82 67.6679 137.554 67.6621 137.38C67.6621 137.287 67.8407 137.131 67.956 137.108C68.1864 137.05 68.5552 137.525 68.6704 138.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1827 126.211C52.1308 127.312 51.9983 127.422 51.3242 127.028C51.7102 126.327 51.7102 126.327 52.1827 126.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8086 256.645C41.2695 255.944 41.2695 255.944 41.863 256.987C41.137 257.074 41.137 257.074 40.8086 256.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.216 170.545C115.686 171.037 114.989 171.095 114.229 170.724C114.891 170.66 115.554 170.602 116.216 170.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.94 33.0313C24.6634 32.6258 24.4618 32.2609 24.2083 31.9828C23.949 31.6932 23.5227 31.7627 23.3613 31.2297C24.2601 31.4557 24.819 32.0523 24.94 33.0313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5617 149.591C54.6654 149.84 54.7634 150.078 54.8844 150.356C54.5271 150.663 54.2909 151.138 53.8242 151.074C54.072 150.582 54.3024 150.124 54.5617 149.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92969 221.638C9.20624 221.036 9.40214 220.584 9.88611 220.601C10.0186 221.146 9.71903 221.412 9.52889 221.673C9.44247 221.789 9.19472 221.662 8.92969 221.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.27 70.5582C245.558 70.1932 245.748 69.9963 245.903 69.7588C246.295 69.1795 246.376 69.1679 246.877 69.724C246.387 69.9789 245.898 70.2338 245.27 70.5582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92219 223.023C6.11808 223.312 6.42341 223.533 6.14113 223.996C5.99132 224.239 5.58225 224.193 5.51887 223.927C5.39788 223.434 5.65715 223.237 5.92219 223.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05873 47.8672C8.61185 48.3306 8.70403 48.7303 8.41019 49.049C8.32377 49.1416 8.16244 49.1706 8.05873 49.1243C7.99536 49.0953 7.92622 48.8752 7.93198 48.7477C7.9435 48.487 8.00112 48.2321 8.05873 47.8672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.864 212.091C195.651 212.022 195.374 212.039 195.247 211.854C195.08 211.611 195.103 211.217 195.449 210.916C195.622 211.194 195.8 211.489 195.979 211.784C195.939 211.889 195.904 211.987 195.864 212.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.343 170.765C239.686 171.054 239.024 171.054 238.229 170.765C239.029 170.765 239.686 170.765 240.343 170.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.862 253.673C231.88 254.565 231.632 254.867 231.16 254.49C231.073 254.421 231.01 254.218 230.998 254.073C230.992 253.998 231.136 253.865 231.223 253.836C231.436 253.754 231.649 253.72 231.862 253.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.462 67.7659C101.748 67.9745 101.748 67.9745 101.379 67.1635C102.082 66.897 102.232 66.9839 102.462 67.7659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.061 174.101C120.883 174.119 120.698 174.177 120.52 174.136C120.318 174.09 120.163 173.91 120.249 173.557C120.33 173.238 120.514 173.122 120.704 173.267C120.871 173.395 120.992 173.65 121.136 173.847C121.113 173.933 121.09 174.015 121.061 174.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9805 128.065C50.1706 127.665 50.3204 127.352 50.4932 126.993C50.7122 127.289 50.8793 127.515 51.0464 127.735C50.764 128.03 50.764 128.03 49.9805 128.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.824 86.7727C234.513 86.8827 234.23 87.184 234.034 86.6684C233.925 86.3845 234.017 86.0717 234.242 85.9964C234.599 85.8863 234.737 86.2281 234.824 86.7727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.192 221.667C111.67 222.096 111.134 222.733 111.44 223.214C110.783 223.04 110.725 222.525 111.192 221.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3952 179.97C61.3779 180.167 61.1763 180.213 60.9804 180.207C60.7153 180.196 60.6981 179.9 60.7096 179.61C60.7211 179.327 60.8248 179.164 61.0438 179.182C61.2857 179.205 61.4355 179.466 61.3952 179.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.257 40.7417C207.71 41.2515 207.698 41.2515 207.174 40.9677C207.6 40.2436 207.819 40.1914 208.257 40.7417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.2 188.097C141.682 188.34 141.307 188.097 141.278 187.657C141.261 187.385 141.451 187.182 141.63 187.338C141.82 187.506 141.964 187.773 142.2 188.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4385 98.6423C65.1101 99.1463 64.7932 99.6735 64.2344 99.7835C64.3669 98.7408 65.0122 98.9262 65.4385 98.6423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.318 2.39819C109.635 2.67626 109.958 2.95432 110.292 3.24976C110.119 3.39458 109.952 3.5394 109.722 3.73057C109.549 3.33665 109.376 2.94273 109.197 2.54881C109.238 2.49667 109.278 2.44454 109.318 2.39819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4905 232.529C60.404 232.755 60.358 232.883 60.3061 233.016C59.5225 232.883 59.511 232.871 59.6838 232.1C59.9374 232.234 60.1909 232.373 60.4905 232.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.379 230.218C160.932 230.218 161.485 230.218 162.038 230.218C162.038 230.276 162.038 230.328 162.038 230.386C161.485 230.386 160.932 230.386 160.379 230.386C160.379 230.328 160.379 230.27 160.379 230.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6518 118.738C50.972 119.729 50.9662 119.729 50.5859 118.489C50.9489 118.576 51.2716 118.651 51.6518 118.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5026 76.635C95.7158 76.8725 95.8138 76.942 95.8599 77.0521C95.8944 77.1332 95.8944 77.3302 95.8541 77.3765C95.6352 77.6546 95.9232 78.257 95.4277 78.4772C95.4565 77.8863 95.4738 77.3765 95.5026 76.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.363 43.6267C140.721 44.067 140.663 44.542 140.479 45.1039C140.098 44.6173 140.139 44.1365 140.363 43.6267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.931 122.556C192.637 122.718 192.395 122.857 192.141 123.002C191.922 122.446 192.176 122.191 192.366 122.04C192.625 121.826 192.792 122.092 192.931 122.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4724 130.979C51.4494 130.365 51.6625 130.301 51.9276 130.307C52.2041 130.313 52.3136 130.498 52.2733 130.979C52.0198 130.979 51.7663 130.979 51.4724 130.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.879 108.415C143.294 108.027 143.703 107.639 144.112 107.257C143.858 108.218 143.328 108.647 142.879 108.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.502 241.925C223.502 241.259 223.594 240.952 223.957 241.108C224.176 241.201 224.378 241.473 224.268 241.786C224.061 242.342 223.79 241.711 223.502 241.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.502 137.82C111.755 138.202 112.257 137.837 112.337 138.567C111.848 138.915 111.577 138.695 111.502 137.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4743 145.675C76.852 145.675 76.2932 145.675 75.7285 145.675C75.7458 145.571 75.7573 145.473 75.7688 145.473C76.2989 145.438 76.829 145.415 77.359 145.397C77.3763 145.403 77.3936 145.496 77.4743 145.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4657 100.803C69.6328 101.267 70.0995 101.157 70.0534 101.817C69.7768 101.782 69.506 101.747 69.1719 101.707C69.2698 101.394 69.3447 101.162 69.4657 100.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8105 216.338C36.5974 216.193 36.3842 216.054 36.1191 215.874C36.2517 215.619 36.3438 215.44 36.4936 215.139C36.6838 215.515 36.8278 215.799 36.9719 216.083C36.9142 216.17 36.8624 216.257 36.8105 216.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.436 132.091C187.257 132.299 187.131 132.514 187.09 132.485C186.894 132.334 186.721 132.126 186.537 131.934C186.629 131.795 186.756 131.523 186.808 131.546C187.01 131.656 187.182 131.859 187.436 132.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.632 63.989C229.84 64.2207 230.007 64.4003 230.174 64.5857C230.041 65.1244 229.811 65.0549 229.569 64.8464C229.281 64.5915 229.39 64.325 229.632 63.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3613 251.837C71.5342 251.42 71.563 250.962 71.9202 251.096C72.2774 251.229 72.0412 251.64 72.0815 252.005C71.8626 251.953 71.6609 251.907 71.3613 251.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.508 76.6813C207.312 76.8725 207.208 77.0463 207.087 77.0752C206.857 77.1274 206.713 76.9014 206.73 76.5944C206.741 76.4264 206.868 76.2758 206.943 76.1194C207.11 76.2758 207.272 76.438 207.508 76.6813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9746 122.747C63.7787 122.822 63.5828 122.944 63.3869 122.95C63.2774 122.95 63.1622 122.758 63.0527 122.648C63.1737 122.509 63.2947 122.272 63.4215 122.266C63.6001 122.254 63.7787 122.422 63.9573 122.509C63.9631 122.59 63.9688 122.666 63.9746 122.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.463 114.139C134.25 113.588 134.422 113.125 134.578 112.667C134.607 112.586 134.751 112.58 134.889 112.517C134.929 113.212 134.676 113.652 134.463 114.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.102 58.422C196.601 58.2482 196.538 58.1613 196.348 57.4314C196.849 57.5067 196.958 57.6457 197.102 58.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.486 170.73C172.899 170.73 172.853 170.608 173.095 169.82C173.532 169.82 173.509 170.232 173.486 170.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.32 108.797C114.164 109.203 114.032 109.522 113.709 109.261C113.536 109.122 113.473 108.878 113.617 108.641C113.859 108.241 114.066 108.49 114.32 108.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7369 217.925C37.8925 218.215 38.0366 218.493 38.1979 218.794C37.9386 219.118 37.7312 219.118 37.5526 218.811C37.3567 218.481 37.4431 218.203 37.7369 217.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7168 255.469C79.9012 255.017 79.9991 254.762 80.1374 254.432C80.3333 254.803 80.4831 255.081 80.6905 255.469C80.3506 255.469 80.1086 255.469 79.7168 255.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8663 259.466C4.97001 259.646 5.11405 259.802 5.16014 260.011C5.212 260.219 5.22352 260.526 5.15438 260.7C5.02187 261.03 4.80869 261.019 4.58398 260.694C4.68193 260.538 4.83173 260.393 4.86054 260.219C4.88935 260.005 4.80869 259.762 4.77988 259.53C4.80869 259.507 4.83749 259.484 4.8663 259.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.671 250.528C125.81 250.725 125.959 250.899 126.063 251.113C126.103 251.194 126.069 251.42 126.011 251.501C125.954 251.582 125.81 251.628 125.735 251.582C125.441 251.414 125.412 251.049 125.671 250.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0537 78.7843C67.7714 78.9697 67.6216 79.1145 67.4603 79.1434C67.3911 79.155 67.2183 78.8596 67.2356 78.8306C67.3278 78.6221 67.4372 78.3846 67.5813 78.2919C67.6504 78.2513 67.8175 78.5236 68.0537 78.7843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.022 195.321C251.809 195.53 251.711 195.703 251.59 195.732C251.348 195.796 251.227 195.524 251.233 195.234C251.238 195.101 251.429 194.852 251.509 194.869C251.659 194.915 251.791 195.107 252.022 195.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6728 103.717C23.2868 104.18 23.2868 104.18 22.9238 103.52C23.0218 103.352 23.1255 103.172 23.258 102.941C23.402 103.207 23.5288 103.439 23.6728 103.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.352 40.9155C170.208 40.9271 170.07 40.9445 169.926 40.9445C169.799 40.9445 169.672 40.9271 169.453 40.9097C169.505 40.707 169.517 40.4347 169.591 40.3942C169.908 40.2088 170.15 40.4347 170.352 40.9155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39724 44.9823C5.11492 45.3299 4.89598 45.637 4.654 45.2546C4.40625 44.8665 4.70585 44.6869 4.91903 44.4436C5.06307 44.6058 5.20711 44.768 5.39724 44.9823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4198 123.297C46.1317 123.181 45.8436 123.071 45.4922 122.932C45.9474 122.712 45.4115 122.057 45.8552 121.808C46.0914 122.266 45.9819 123.002 46.4083 123.32L46.4198 123.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3145 189.14C11.6602 189.233 11.8619 189.435 11.954 189.858C11.3145 190.09 11.205 189.974 11.3145 189.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6991 77.0925C47.8546 77.33 47.9987 77.5502 48.1773 77.8224C47.8892 78.1295 47.6587 78.2511 47.4744 77.9383C47.2842 77.6139 47.4974 77.3822 47.6991 77.0925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.266 55.3401C198.525 54.448 198.611 54.4306 198.986 55.1258C198.744 55.595 198.744 55.595 198.266 55.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6664 130.191C43.8277 130.463 43.9833 130.735 44.1619 131.037C43.9142 131.106 43.7414 131.158 43.5167 131.216C43.4994 130.915 43.4763 130.614 43.459 130.313C43.5224 130.278 43.5915 130.231 43.6664 130.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87132 122.579C9.24582 123.135 8.72728 123.801 9.12483 124.259C8.64662 124.01 8.57172 123.523 8.87132 122.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8711 146.023C27.3724 145.461 27.8851 145.948 28.3922 145.913C27.8909 146.405 27.3781 145.861 26.8711 146.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.43 230.241C128.568 230.502 128.701 230.762 128.885 231.104C128.407 231.22 128.228 230.768 127.986 230.519C128.038 230.003 128.269 230.235 128.43 230.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.932 180.757C237.053 181.128 237.266 181.412 236.955 181.673C236.869 181.742 236.615 181.673 236.581 181.568C236.448 181.186 236.633 180.972 236.932 180.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.681 257.248C129.808 257.468 129.923 257.665 130.055 257.891C129.837 258.186 129.612 258.372 129.422 258.064C129.203 257.711 129.433 257.485 129.681 257.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.444 256.419C19.3691 256.935 19.179 257.12 18.8851 256.935C18.8102 256.888 18.7411 256.547 18.7814 256.425C18.9658 255.909 19.1963 256.292 19.444 256.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.588 191.556C259.738 191.249 259.841 191.034 260.02 190.652C260.153 191.04 260.343 191.353 260.291 191.515C260.176 191.915 259.922 191.816 259.588 191.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9176 198.107C33.4913 198.107 33.0592 198.107 32.6328 198.107C33.0534 197.835 33.4798 197.806 33.9119 197.893C33.9119 197.963 33.9119 198.038 33.9176 198.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.347 2.16079C139.284 2.25348 138.852 2.34617 138.552 2.35196C138.506 2.13762 138.466 1.92328 138.414 1.6626C138.731 1.83059 139.013 1.987 139.347 2.16079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.967 58.7928C236.535 59.3431 236.523 59.3431 236.172 58.7174C236.592 58.3004 236.627 58.3061 236.967 58.7928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74226 225.786C2.37352 225.89 2.11425 226.047 2.05087 225.415C2.02783 225.195 1.90683 225.004 1.82617 224.784C2.35048 224.604 2.362 224.622 2.22372 225.334C2.35624 225.45 2.5118 225.583 2.74226 225.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48631 255.701C8.24433 256.338 8.24433 256.338 7.79492 256.153C8.0081 255.452 8.05419 255.423 8.48631 255.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5762 249.827C36.0947 249.827 36.6133 249.827 37.1318 249.827C37.1318 249.891 37.1318 249.954 37.1376 250.018C36.619 249.972 36.1178 250.366 35.5762 249.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1191 175.642C61.4533 175.498 61.7644 175.364 62.1217 175.208C62.1505 175.272 62.2023 175.393 62.2369 175.469C62.1793 175.874 61.4879 175.926 61.1191 175.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9043 159.092C38.1002 157.997 38.2327 157.875 38.6764 158.2C38.4171 158.501 38.1578 158.796 37.9043 159.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97507 83.6329C1.83679 83.3664 1.68699 83.1173 1.57176 82.8335C1.53143 82.735 1.58328 82.5612 1.5948 82.428C1.70427 82.4743 1.87136 82.4743 1.91169 82.5728C2.02116 82.874 2.08454 83.2158 2.1652 83.5402C2.10182 83.5692 2.03845 83.5982 1.97507 83.6329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.721 149.864C241.842 149.493 241.974 149.383 242.159 149.591C242.36 149.811 242.504 150.061 242.245 150.536C242.055 150.292 241.876 150.072 241.721 149.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.539 115.025C258.344 114.759 258.223 114.591 258.102 114.428C258.217 114.283 258.338 114.017 258.447 114.023C258.562 114.034 258.707 114.278 258.764 114.463C258.787 114.567 258.649 114.764 258.539 115.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.58 54.0366C176.223 54.8418 176.154 54.8708 175.785 54.4131C176.108 53.9613 176.108 53.9613 176.58 54.0366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1202 101.481C38.5325 101.435 37.9506 101.388 37.3398 101.342C37.7547 101.052 38.0428 101.058 39.1202 101.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.989 75.8819C176.868 75.1172 177.104 74.5785 177.53 74.1614C177.346 74.7349 177.167 75.3084 176.989 75.8819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.745 248.014C136.992 248.234 137.206 248.425 137.482 248.674C136.843 248.987 136.664 248.825 136.745 248.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1973 143.798C51.3471 143.613 51.4738 143.468 51.6006 143.318C51.8599 143.526 51.9693 143.833 51.7792 144.077C51.566 144.343 51.3586 144.134 51.1973 143.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.289 115.054C56.2256 115.042 56.1622 115.048 56.1046 115.013C56.0297 114.967 55.9605 114.892 55.8223 114.776C56.047 114.463 56.2429 114.185 56.4388 113.913C56.4676 113.936 56.5021 113.965 56.5309 113.988C56.4503 114.335 56.3696 114.689 56.289 115.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6836 30.3551C92.0235 29.9728 92.2713 30.2566 92.5305 30.5289C92.1849 31.0271 92.1157 31.0155 91.6836 30.3551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.464 242.192C146.378 242.03 146.303 241.891 146.199 241.694C146.482 241.572 146.718 241.468 147.006 241.34C146.977 241.769 146.827 242.03 146.464 242.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.335 59.4067C214.295 60.2873 214.22 60.519 213.857 61.0172C213.632 60.1946 214.33 60.0324 214.335 59.4067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5479 112.435C76.208 112.181 75.9891 111.798 75.5742 112.337C75.6606 111.92 75.6952 111.746 75.7528 111.451C76.0121 111.821 76.5249 111.474 76.5479 112.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.372 230.374C152.945 230.374 152.519 230.38 152.093 230.368C152.047 230.368 152.001 230.281 151.805 230.084C152.335 230.084 152.715 230.079 153.09 230.084C153.193 230.09 153.291 230.131 153.395 230.154C153.389 230.229 153.383 230.305 153.372 230.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9805 110.402C66.136 110.524 66.2916 110.645 66.4875 110.796C66.3838 111.022 66.3146 111.173 66.2455 111.317C66.1764 111.468 66.1015 111.619 65.992 111.856C65.9401 111.671 65.8537 111.48 65.8825 111.445C66.0957 111.138 65.9632 110.842 65.8652 110.535C65.9056 110.495 65.9401 110.448 65.9805 110.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.601 29.382C136.382 29.5674 136.255 29.7354 136.117 29.7643C136.042 29.7817 135.944 29.55 135.857 29.4283C135.967 29.2661 136.059 29.046 136.192 28.9707C136.261 28.9359 136.405 29.1735 136.601 29.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.346 108.919C60.0176 109.029 59.7468 109.133 59.5566 108.699C59.8793 108.131 59.9139 108.137 60.346 108.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7057 59.6037C61.5271 59.6616 61.3485 59.7659 61.1699 59.7543C61.0893 59.7485 61.0144 59.5226 60.9395 59.3952C61.0432 59.2793 61.1584 59.0592 61.2563 59.0708C61.4119 59.0881 61.5559 59.2619 61.7057 59.3662C61.7057 59.4473 61.7057 59.5284 61.7057 59.6037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42498 94.0196C6.88915 94.0312 6.88915 94.0312 6.3418 94.8885C6.44551 94.2513 6.62411 93.8574 6.96405 93.7299C7.0908 93.6836 7.26941 93.9153 7.42498 94.0196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7104 84.189C95.9927 84.3917 96.108 84.6524 95.9294 85.0116C95.8833 85.1043 95.6528 85.139 95.6067 85.0695C95.4108 84.7856 95.4108 84.4786 95.7104 84.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3789 248.547C39.9723 248.547 40.416 248.547 40.9633 248.547C40.6522 248.819 39.7476 248.819 39.3789 248.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6241 3.0066C19.4686 2.81543 19.313 2.63005 19.1171 2.39254C18.9961 2.57792 18.8809 2.76329 18.7426 2.98342C18.7138 2.86177 18.6619 2.75171 18.6792 2.72274C18.8117 2.49682 18.9558 2.28827 19.0883 2.09131C19.4628 2.22455 19.555 2.60109 19.6645 2.96025L19.6241 3.0066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.853 210.539C257.346 210.556 257.22 210.023 256.926 209.711C257.456 209.67 257.542 209.745 257.853 210.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.558 100.566C188.143 100.566 187.837 100.566 187.469 100.566C187.509 100.398 187.521 100.154 187.584 100.125C187.768 100.033 187.982 99.969 188.172 100.01C188.281 100.033 188.368 100.282 188.558 100.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1523 64.7131C36.2733 64.5509 36.3598 64.4292 36.4692 64.2844C36.6478 64.5219 36.8149 64.7305 36.9878 64.9564C36.5845 65.3329 36.5845 65.3329 36.1523 64.7131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8865 43.0649C78.7655 43.6616 78.6388 43.9397 78.3392 43.7369C78.2585 43.679 78.2354 43.4589 78.1836 43.314C78.3852 43.2387 78.5869 43.1692 78.8865 43.0649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.504 200.314C164.17 200.558 163.928 200.61 163.784 200.164C163.755 200.071 163.87 199.781 163.957 199.741C164.268 199.585 164.366 199.926 164.504 200.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.935 133.302C191.917 133.029 191.906 132.78 191.877 132.317C192.125 132.502 192.355 132.566 192.39 132.717C192.488 133.192 192.205 133.209 191.935 133.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.689 230.108C150.07 230.108 150.45 230.108 150.824 230.108C150.444 230.444 150.064 230.56 149.689 230.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.665 230.322C148.21 230.374 147.829 230.415 147.328 230.473C147.449 230.299 147.518 230.131 147.622 230.079C147.973 229.888 148.302 230.021 148.665 230.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34561 92.7046C5.34561 92.9363 5.34561 93.1739 5.34561 93.4751C5.23614 93.4345 5.09786 93.4345 5.02296 93.3361C4.93077 93.2144 4.81554 92.9711 4.84435 92.8552C4.92501 92.5366 5.12667 92.5424 5.34561 92.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22388 236.173C1.68229 235.68 1.69381 235.478 2.3103 234.887C2.22388 235.205 2.14321 235.391 2.13169 235.588C2.12593 235.779 2.18931 235.976 2.22388 236.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0018 65.2923C44.564 65.6283 44.5351 65.6167 44.1895 64.9853C44.5697 64.5277 44.7195 65.2865 45.0018 65.2923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4668 108.276C17.6166 108.079 17.7318 107.934 17.8413 107.795C17.9047 107.957 17.9738 108.114 18.0257 108.282C18.066 108.432 18.0775 108.595 18.1236 108.855C17.8932 108.653 17.7203 108.502 17.4668 108.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.775 114.48C247.545 114.857 247.349 114.903 247.187 114.515C247.141 114.405 247.176 114.098 247.233 114.063C247.539 113.866 247.619 114.231 247.775 114.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.287 117.655C250.834 117.365 250.852 117.383 250.984 118.066C250.685 118.246 250.506 118.014 250.287 117.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7656 127.88C28.4545 128.169 28.2413 128.117 28.0742 127.735C28.4257 127.179 28.4545 127.184 28.7656 127.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1902 199.521C65.1672 199.388 65.1384 199.307 65.1557 199.278C65.2651 199.081 65.3861 198.895 65.5014 198.704C65.5705 198.808 65.7145 198.924 65.703 199.011C65.6684 199.382 65.5359 199.637 65.1902 199.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0798 136.986C23.2584 136.986 23.4543 136.928 23.6156 137.009C23.702 137.05 23.7308 137.322 23.7885 137.49C23.6732 137.513 23.5465 137.606 23.4543 137.554C23.3102 137.472 23.1893 137.293 23.0625 137.154C23.0683 137.102 23.074 137.044 23.0798 136.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6758 108.038C73.0215 107.616 73.3672 107.199 73.7129 106.776C73.5631 107.523 73.0733 107.714 72.768 108.206C72.7334 108.149 72.7046 108.096 72.6758 108.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7551 157.064C99.7551 156.891 99.7436 156.844 99.7551 156.833C99.9453 156.601 100.135 156.369 100.377 156.085C100.435 156.271 100.55 156.456 100.516 156.537C100.36 156.937 100.089 157.059 99.7551 157.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.916 157.406C40.2848 157.087 40.7687 157.435 40.9069 156.537C40.9761 157.487 40.6362 157.742 39.916 157.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6986 139.998C17.6468 139.558 17.8254 139.396 17.9752 139.448C18.1134 139.494 18.2056 139.766 18.3209 139.94C18.2978 139.992 18.2748 140.05 18.2517 140.102C18.0616 140.068 17.8715 140.033 17.6986 139.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4556 180.427C67.2252 180.671 67.0005 180.804 66.7988 180.375C67.0869 179.952 67.0869 179.952 67.4556 180.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.875 193.502C69.996 193.114 70.1343 192.957 70.3417 193.183C70.3993 193.247 70.4512 193.485 70.4166 193.554C70.238 193.936 70.0709 193.722 69.875 193.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.911 0.973283C253.548 0.892182 253.116 0.973283 253.162 0.0695801C253.455 0.428743 253.686 0.701015 253.911 0.973283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1567 178.046C45.2835 178.197 45.4102 178.342 45.5427 178.492C45.4563 178.603 45.3641 178.817 45.2835 178.811C45.0299 178.794 45.0127 178.51 45.0184 178.243C45.0645 178.18 45.1106 178.116 45.1567 178.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.275 244.022C182.74 244.022 182.204 244.022 181.662 244.022C181.662 243.982 181.662 243.935 181.662 243.895C182.198 243.895 182.734 243.895 183.275 243.895C183.275 243.935 183.275 243.976 183.275 244.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.086 233.23C221.804 232.958 221.551 232.662 221.539 232.095C221.965 232.384 221.965 232.384 222.086 233.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41032 57.0258C3.10495 56.9099 2.94363 56.7361 3.09919 56.3654C3.14528 56.2553 3.3527 56.1395 3.41032 56.1916C3.65807 56.4175 3.51979 56.6956 3.41032 57.0258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.094 112.824C110.892 112.835 110.685 112.852 110.483 112.864C110.46 112.795 110.431 112.719 110.408 112.65C110.506 112.493 110.604 112.209 110.696 112.209C110.852 112.209 111.002 112.401 111.151 112.516C111.134 112.621 111.117 112.725 111.094 112.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95898 126.46C5.34501 126.084 5.50634 126.362 5.69647 126.79C5.31045 127.08 5.10302 126.987 4.95898 126.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4563 129.919C72.0127 129.809 71.7131 129.739 71.3789 129.658C71.5978 129.455 71.7822 129.287 72.0069 129.084C72.1222 129.293 72.2374 129.513 72.4563 129.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.635 230.154C154.975 230.154 155.309 230.154 155.649 230.154C155.326 230.519 154.98 230.339 154.641 230.276C154.635 230.27 154.635 230.189 154.635 230.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0709 242.082C60.7021 242.082 60.4717 242.082 60.27 242.082C60.247 241.856 60.2239 241.595 60.1836 241.207C60.4832 241.502 60.7309 241.746 61.0709 242.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.754 170.707C189.059 170.707 189.359 170.707 189.739 170.707C189.393 171.188 189.071 170.973 188.765 170.933C188.76 170.857 188.754 170.782 188.754 170.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.292 115.575C251.993 115.668 251.797 115.732 251.555 115.807C251.802 114.95 251.866 114.921 252.292 115.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7018 238.814C16.2985 238.913 16.143 238.652 16.0508 238.166C16.4253 238.038 16.6039 238.27 16.7018 238.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.723 86.0021C146.562 86.1933 146.464 86.3844 146.343 86.4192C146.268 86.4424 146.158 86.2396 146.061 86.1353C146.153 85.9847 146.228 85.782 146.349 85.7125C146.418 85.6719 146.55 85.8573 146.723 86.0021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84766 105.414C3.9456 104.366 3.96289 104.343 4.4411 104.742C4.24521 104.963 4.0666 105.165 3.84766 105.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2092 151.561C54.0594 151.648 53.9096 151.735 53.7367 151.833C53.6157 151.613 53.5005 151.41 53.2988 151.051C53.6849 151.196 53.9384 151.289 54.1976 151.381C54.2034 151.445 54.2034 151.503 54.2092 151.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.968 9.17603C178.078 9.43671 178.164 9.61629 178.222 9.81904C178.227 9.84222 178.014 10.0566 177.985 10.0276C177.864 9.90014 177.772 9.71477 177.692 9.53519C177.686 9.51202 177.83 9.35561 177.968 9.17603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.466 241.578C145.53 241.85 145.576 242.047 145.633 242.284C145.374 242.435 145.121 242.783 144.982 242.07C145.121 241.931 145.276 241.775 145.466 241.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3998 101.933C70.3249 101.724 70.25 101.516 70.1348 101.191C70.3652 101.168 70.5323 101.151 70.8089 101.122C70.7052 101.493 70.6418 101.719 70.5784 101.95C70.515 101.939 70.4574 101.939 70.3998 101.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3203 95.9602C52.6545 96.0065 52.8273 96.0355 53.0175 96.0587C52.9714 96.4874 52.8389 96.6901 52.6257 96.609C52.5335 96.5743 52.4759 96.302 52.3203 95.9602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.6 9.56422C253.726 9.58739 253.865 9.6627 253.98 9.62215C254.107 9.5758 254.21 9.4136 254.383 9.24561C254.135 10.0508 253.986 10.1261 253.6 9.56422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.717 249.578C147.034 249.375 147.339 249.352 147.742 249.798C147.322 249.798 147.016 249.798 146.711 249.798C146.711 249.728 146.717 249.653 146.717 249.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.456 122.614C259.491 122.741 259.508 122.77 259.508 122.793C259.462 123.071 259.525 123.453 259.214 123.477C259.157 123.482 259.041 123.355 259.036 123.274C259.012 122.886 259.162 122.671 259.456 122.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3549 106.839C82.3492 107.372 82.1187 107.842 81.8825 107.847C81.8306 107.847 81.7384 107.778 81.7327 107.726C81.7211 107.621 81.7327 107.465 81.7788 107.407C81.9401 107.222 82.1245 107.065 82.3549 106.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0701 41.4775C41.8281 41.7614 41.6265 41.8135 41.4709 41.4312C41.4363 41.3443 41.4824 41.0894 41.54 41.0489C41.8512 40.8229 41.9203 41.2111 42.0701 41.4775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.967 119.259C120.065 119.091 120.145 118.906 120.255 118.773C120.301 118.721 120.428 118.744 120.485 118.796C120.543 118.854 120.595 119.005 120.578 119.097C120.531 119.41 120.272 119.485 119.967 119.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.584 103.057C70.8375 102.912 71.0852 102.773 71.3503 102.622C71.3215 103.022 71.0392 103.259 70.6358 103.265C70.6186 103.196 70.6013 103.126 70.584 103.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.864 143.202C260.124 143.457 260.302 143.642 260.533 143.868C259.933 144.1 259.853 144.03 259.864 143.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.901 91.5054C103.178 91.7545 103.201 92.0847 102.895 92.5191C102.838 92.2121 102.774 91.9051 102.717 91.5981C102.774 91.5633 102.838 91.5343 102.901 91.5054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7559 161.896C70.8653 161.363 71.0324 161.224 71.7353 161.276C71.3493 161.519 71.0555 161.705 70.7559 161.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9689 260.712C63.75 261.644 63.3755 261.21 63.0586 261.088C63.3179 260.978 63.5771 260.874 63.9689 260.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4509 143.167C47.6007 143.497 47.7851 143.74 47.5489 144.024C47.5086 144.076 47.3702 144.042 47.3241 143.984C47.1225 143.694 47.2204 143.457 47.4509 143.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8555 81.0028C13.9246 80.7363 13.9995 80.4698 14.0975 80.1165C14.2703 80.2729 14.3855 80.3771 14.5699 80.5451C14.3337 80.7826 14.1608 80.9564 13.9822 81.136C13.9361 81.0955 13.8958 81.0491 13.8555 81.0028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.101 133.684C51.9281 133.875 51.7668 134.147 51.5594 133.817C51.519 133.748 51.5824 133.417 51.6631 133.342C51.8935 133.139 52.003 133.417 52.101 133.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3789 258.876C71.5575 258.534 71.6785 258.308 71.811 258.047C71.9896 258.337 71.9666 258.632 71.8053 258.858C71.7419 258.951 71.5633 258.876 71.3789 258.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.604 219.321C166.047 219.205 166.076 219.75 166.22 220.109C166.192 220.161 166.157 220.219 166.128 220.271C165.921 220.028 165.713 219.79 165.506 219.547C165.54 219.472 165.569 219.396 165.604 219.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.512 60.125C202.759 60.4494 203.001 60.7796 203.29 61.1561C202.754 61.0171 202.535 60.7738 202.512 60.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5738 129.988C73.257 130.411 73.0726 130.567 72.894 130.22C72.8536 130.15 72.9343 129.838 72.9516 129.843C73.1129 129.855 73.2742 129.907 73.5738 129.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8184 253.882C68.0892 254.189 68.2966 254.426 68.6135 254.791C68.118 254.745 67.8299 254.652 67.8184 253.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3378 145.125C64.7008 144.673 65.1329 144.465 65.6111 144.453C65.2078 144.772 64.8391 145.206 64.332 145.108L64.3378 145.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.825 170.417C167.004 170.591 166.987 170.84 166.82 170.915C166.601 171.014 166.37 171.471 166.088 171.008C166.336 170.811 166.56 170.631 166.825 170.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4746 5.74081C43.7454 5.70026 44.0047 5.69446 44.0853 6.19845C43.6993 6.47072 43.6071 6.03045 43.4746 5.74081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9602 133.962C32.7067 133.887 32.361 134.078 32.2285 133.527C32.6203 133.244 32.7067 133.916 32.9602 133.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6337 117.134C60.8065 117.255 60.9909 117.388 61.1983 117.533C61.0658 117.916 60.9045 117.916 60.7143 117.777C60.53 117.638 60.4493 117.464 60.6337 117.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2747 13.8626C34.0846 14.0422 33.8945 14.0885 33.7792 13.7004C33.7504 13.6077 33.8368 13.4397 33.8714 13.3123C34.027 13.4107 34.1768 13.5034 34.3323 13.5961C34.3093 13.683 34.292 13.7699 34.2747 13.8626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.827 217.323C256.925 217.508 256.989 217.635 257.058 217.769C256.948 217.879 256.85 218.035 256.735 218.07C256.683 218.082 256.539 217.821 256.545 217.699C256.551 217.578 256.701 217.479 256.827 217.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3906 99.9228C53.2004 100.044 53.0794 100.189 52.993 100.16C52.9008 100.12 52.8144 99.9286 52.7798 99.7722C52.7683 99.7142 52.9469 99.4941 52.993 99.5115C53.114 99.5752 53.2177 99.7374 53.3906 99.9228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6277 217.786C16.524 217.763 16.4145 217.769 16.3224 217.717C16.2532 217.676 16.2014 217.566 16.0977 217.427C16.2302 217.305 16.3685 217.108 16.4203 217.149C16.5528 217.247 16.6392 217.45 16.7487 217.606C16.7084 217.664 16.6681 217.728 16.6277 217.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4424 108.624C71.4942 108.867 71.5346 109.029 71.5979 109.336C71.3329 109.313 71.137 109.29 70.9353 109.272C70.9296 109.214 70.9238 109.162 70.9238 109.104C71.0852 108.954 71.2407 108.809 71.4424 108.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.246 212.503C166.895 212.729 166.636 212.503 166.342 212.26C166.664 212.115 166.935 212.19 167.246 212.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0098 111.126C41.2345 111.144 41.3785 111.155 41.5225 111.173C41.6378 111.184 41.7531 111.213 41.949 111.242C41.4419 111.549 41.1711 111.52 41.0098 111.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1988 260.341C34.3601 260.758 34.4581 261.007 34.5676 261.303C33.9856 261.274 33.9856 261.274 34.1988 260.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8184 258.771C70.141 258.823 70.3484 258.858 70.5616 258.893C70.3772 259.495 70.3772 259.495 69.8184 258.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7657 245.54C14.6504 245.308 14.5467 245.169 14.5064 245.001C14.4949 244.949 14.6677 244.717 14.7081 244.741C14.8291 244.804 14.927 244.955 15.0365 245.071C14.9616 245.192 14.8924 245.326 14.7657 245.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.704 207.446C150.669 207.48 150.635 207.527 150.594 207.538C150.41 207.573 150.197 207.66 150.122 207.301C150.105 207.226 150.174 207.069 150.231 207.017C150.416 206.866 150.531 206.982 150.704 207.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35545 239.092C9.04433 239.069 8.87148 239.058 8.66406 239.046C8.92333 238.339 8.92333 238.339 9.35545 239.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.406 242.719C50.3254 243.101 50.2793 243.339 50.2044 243.686C50.0546 243.46 49.9566 243.316 49.8184 243.107C50.0027 242.991 50.1525 242.887 50.406 242.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2072 189.14C51.2821 189.372 51.3512 189.603 51.4722 189.986C51.259 189.922 51.0516 189.928 51.0286 189.841C50.9767 189.638 51.0113 189.389 51.0113 189.151C51.0747 189.151 51.1438 189.146 51.2072 189.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7336 173.418C52.6299 173.922 52.5435 174.345 52.457 174.773C52.457 173.557 52.457 173.557 52.7336 173.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.367 160.001C226.575 160.233 226.73 160.436 226.534 160.714C226.483 160.783 226.275 160.749 226.206 160.662C225.958 160.355 226.189 160.21 226.367 160.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2679 95.5084C45.0086 95.8676 44.8128 95.995 44.6745 95.6359C44.6399 95.549 44.7206 95.3752 44.7494 95.2419C44.9222 95.3288 45.0951 95.4157 45.2679 95.5084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2383 88.2324C17.486 88.4004 17.607 88.4931 17.7683 88.6032C17.6877 88.8001 17.6128 88.9623 17.4572 89.3389C17.365 88.8812 17.3189 88.6379 17.2383 88.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.36 232.442C203.193 232.442 203.02 232.442 202.83 232.442C203.014 231.909 203.014 231.909 203.36 232.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.246 103.485C158.079 103.381 157.918 103.282 157.693 103.143C158.102 102.831 158.102 102.831 158.327 103.323C158.304 103.375 158.275 103.427 158.246 103.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.556 139.668C253.32 140.01 253.159 139.871 253.043 139.616C253.015 139.558 253.066 139.349 253.118 139.309C253.36 139.135 253.476 139.344 253.556 139.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.733 61.8746C177.669 62.1816 177.623 62.4365 177.537 62.871C177.416 62.5929 177.272 62.4075 177.278 62.2337C177.283 61.9151 177.456 61.7819 177.733 61.8746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5269 215.596C77.2965 215.66 77.1467 215.701 76.9277 215.764C76.9738 215.521 76.9681 215.347 77.0257 215.26C77.2331 214.965 77.3483 215.191 77.5269 215.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2393 257.949C66.3602 258.209 66.4524 258.406 66.5965 258.713C66.3602 258.765 66.1874 258.8 65.9512 258.847C66.0664 258.505 66.1413 258.267 66.2393 257.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6523 164.821C49.7791 164.491 49.8137 164.126 50.1248 164.311C50.1824 164.346 50.2458 164.531 50.2285 164.601C50.1248 165.018 49.9116 164.867 49.6523 164.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6872 166.275C54.6872 165.968 54.6872 165.661 54.6872 165.36C55.1136 165.661 55.1136 165.818 54.6699 166.246L54.6872 166.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7305 168.233C85.9782 168.129 86.1165 168.042 86.249 168.03C86.2836 168.03 86.3873 168.32 86.3585 168.384C86.2202 168.685 86.0474 168.61 85.7305 168.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46718 237.98C1.32314 237.98 1.17334 237.98 1.0293 237.98C1.05234 237.777 1.07539 237.569 1.12148 237.181C1.31738 237.476 1.40956 237.621 1.50175 237.76C1.49022 237.835 1.4787 237.905 1.46718 237.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16513 44.9822C2.18818 45.2371 2.40136 45.5036 2.11328 45.7237C2.05566 45.77 1.96347 45.7237 1.88281 45.7179C1.91738 45.463 1.95195 45.2023 1.98652 44.9417C2.04414 44.9648 2.10175 44.9706 2.16513 44.9822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.647 106.544C129.537 106.729 129.468 106.834 129.405 106.944C129.319 106.799 129.203 106.671 129.151 106.503C129.128 106.428 129.244 106.277 129.295 106.162C129.399 106.277 129.509 106.393 129.647 106.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9855 81.8081C68.0201 82.2889 67.9048 82.538 67.5937 82.706C67.5015 82.1846 67.6455 81.9587 67.9855 81.8081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.998 223.787C30.1133 223.469 30.24 223.318 30.4244 223.544C30.4878 223.619 30.5339 223.869 30.4935 223.932C30.3092 224.234 30.1594 224.06 29.998 223.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6406 224.321C26.8596 223.811 27.0036 223.637 27.211 223.846C27.2686 223.903 27.2456 224.112 27.2629 224.245C27.1016 224.268 26.9345 224.286 26.6406 224.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09466 31.1024C3.86996 31.4268 3.67983 31.4847 3.50122 31.224C3.46089 31.1661 3.4897 30.9112 3.54732 30.8475C3.76049 30.5984 3.91605 30.7838 4.09466 31.1024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.25 240.917C126.933 241.317 126.754 241.253 126.633 240.998C126.598 240.929 126.685 240.744 126.719 240.616C126.869 240.697 127.025 240.784 127.25 240.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.682 129.843C216.889 129.658 217.079 129.623 217.171 129.93C217.2 130.023 217.056 130.359 216.975 130.365C216.728 130.399 216.699 130.11 216.682 129.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9979 6.95731C63.7617 7.17165 63.6061 7.53081 63.3008 7.14848C63.4852 6.73718 63.681 6.64449 63.9979 6.95731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9423 129.137C43.7291 128.94 43.5159 128.743 43.3027 128.534C43.5908 128.152 43.7118 128.239 43.9423 129.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.963 99.1463C160.395 98.9262 160.395 98.9262 160.902 99.4244C160.833 99.4476 160.764 99.4939 160.712 99.4765C160.476 99.3838 160.245 99.268 159.963 99.1463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.718 7.0327C162.447 7.13118 162.28 7.20069 162.072 7.28179C162.239 6.49974 162.239 6.49974 162.718 7.0327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.088 48.5045C166.238 48.1106 166.341 47.8441 166.566 48.099C166.629 48.1685 166.606 48.4118 166.618 48.574C166.462 48.5508 166.301 48.5277 166.088 48.5045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0792 109.776C84.9524 109.574 84.8199 109.365 84.6816 109.139C85.1368 108.931 85.1829 108.989 85.0792 109.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.907 91.129C242.867 91.0016 242.826 90.9321 242.838 90.8973C242.901 90.7061 242.976 90.515 243.045 90.3296C243.109 90.3933 243.224 90.4512 243.23 90.5208C243.247 90.8567 243.132 91.0479 242.907 91.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3549 226.603C71.0208 226.684 70.8479 226.591 70.8018 226.226C70.7903 226.151 70.8767 225.983 70.9343 225.977C71.1994 225.931 71.2685 226.203 71.3549 226.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2823 135.208C21.023 135.208 20.8502 135.208 20.6543 135.208C20.8156 134.594 20.8156 134.594 21.2823 135.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.58 108.311C110.627 108.537 110.684 108.768 110.707 109C110.713 109.081 110.627 109.186 110.586 109.272C110.511 109.197 110.373 109.122 110.367 109.041C110.356 108.792 110.396 108.537 110.419 108.288C110.471 108.293 110.523 108.299 110.58 108.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.772 163.228C111.582 163.529 111.409 163.587 111.248 163.269C111.219 163.211 111.248 163.014 111.294 162.962C111.547 162.695 111.651 162.973 111.772 163.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9983 184.517C91.0905 184.813 91.1711 185.009 91.2114 185.212C91.223 185.264 91.1077 185.369 91.0501 185.45C90.9579 185.264 90.8542 185.091 90.7851 184.888C90.7678 184.853 90.8715 184.726 90.9983 184.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3164 145.959C30.7024 145.959 31.0942 145.959 31.4802 145.959C31.4802 146.017 31.4745 146.075 31.4745 146.127C31.0942 146.098 30.7197 146.063 30.3395 146.035C30.3337 146.011 30.3222 145.988 30.3164 145.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7531 170.73C66.6206 170.73 66.4708 170.678 66.3556 170.741C66.2576 170.794 66.1885 170.979 66.1021 171.118C65.9638 170.458 66.0387 170.394 66.7531 170.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9512 142.373C73.3142 142.553 73.6714 142.732 74.0343 142.918C73.5734 143.121 73.2565 142.756 72.9512 142.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.488 198.577C197.886 197.893 197.886 197.887 198.157 198.577C197.955 198.577 197.776 198.577 197.488 198.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.361 9.79008C256.257 10.1492 256.09 10.2999 255.854 10.0913C255.796 10.045 255.756 9.79008 255.79 9.72057C255.998 9.30927 256.176 9.6105 256.361 9.79008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1021 18.6128C89.2001 18.804 89.2692 18.9372 89.3441 19.0704C89.2462 19.1573 89.1367 19.3311 89.0503 19.3079C88.9696 19.2848 88.8832 19.0704 88.8659 18.9198C88.8544 18.8561 88.9927 18.746 89.1021 18.6128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0114 261.54C38.8731 261.592 38.7349 261.65 38.5851 261.708C38.5274 261.494 38.4756 261.303 38.418 261.106C38.7521 260.81 38.8098 261.372 39.0114 261.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74803 51.8817C7.32744 51.9512 7.14306 51.7832 7.05664 51.285C7.37929 51.2329 7.5579 51.4067 7.74803 51.8817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.365 140.12C66.4918 140.34 66.5897 140.514 66.7453 140.78C66.5724 140.815 66.463 140.89 66.3881 140.85C66.0769 140.67 66.1691 140.433 66.365 140.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.34 71.8558C257.495 71.3345 257.495 71.3345 257.968 71.5199C257.795 71.8385 257.582 71.8211 257.34 71.8558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93581 101.197C6.66502 101.099 6.52098 100.954 6.59588 100.618C6.61316 100.554 6.75144 100.473 6.79753 100.508C6.99343 100.635 7.05681 100.85 6.93581 101.197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5391 103.387C57.879 102.976 58.0403 103.074 58.1613 103.323C58.1901 103.381 58.0979 103.63 58.0922 103.63C57.9366 103.584 57.7868 103.503 57.5391 103.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.168 106.399C74.3005 105.774 74.6692 105.779 74.9112 105.38C74.7211 106.028 74.7211 106.028 74.168 106.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6257 113.188C80.3376 113.229 80.1763 113.252 79.9746 113.287C79.9861 113.159 79.9804 113.067 80.0034 113.009C80.2224 112.47 80.3606 112.881 80.6257 113.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89258 113.901C10.2959 113.351 10.2959 113.351 10.5955 114.226C10.3477 114.115 10.1634 114.029 9.89258 113.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1415 1.49454C76.9802 1.63357 76.888 1.76101 76.7843 1.77839C76.7267 1.78418 76.5999 1.59881 76.6057 1.51192C76.6114 1.39606 76.7209 1.1933 76.7785 1.1991C76.8822 1.21068 76.9744 1.34971 77.1415 1.49454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4913 115.343C10.3472 115.587 10.1974 115.83 9.97273 116.212C9.90935 115.54 10.111 115.338 10.3472 115.17C10.3933 115.222 10.4452 115.28 10.4913 115.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.457 117.052C239.376 116.514 239.376 116.514 239.612 116.236C239.704 116.722 239.704 116.722 239.457 117.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0527 117.087C63.289 117.006 63.4503 116.618 63.7902 116.948C63.5598 117.058 63.3351 117.174 63.1046 117.284C63.0873 117.22 63.07 117.157 63.0527 117.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8474 119.85C95.7033 119.984 95.6111 120.123 95.5132 120.134C95.4498 120.14 95.3173 119.914 95.3288 119.845C95.3576 119.694 95.4671 119.578 95.542 119.451C95.6342 119.561 95.7149 119.671 95.8474 119.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5977 128.297C46.9722 128.198 46.9722 128.198 47.0586 129.096C46.8742 128.777 46.7475 128.551 46.5977 128.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.239 141.591C179.997 141.406 179.859 141.296 179.721 141.186C179.778 141.076 179.83 140.902 179.899 140.879C180.141 140.809 180.251 140.989 180.239 141.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.135 249.723C141.383 249.259 141.676 249.705 141.959 249.786C141.694 249.844 141.434 249.896 141.175 249.954C141.158 249.879 141.146 249.798 141.135 249.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.787 150.327C116.92 150.2 117.058 150.072 117.208 149.922C117.294 150.513 117.294 150.513 116.908 150.547C116.868 150.478 116.827 150.402 116.787 150.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.23 43.5746C191.392 42.949 191.392 42.949 191.784 43.256C191.691 43.5978 191.524 43.6615 191.23 43.5746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.367 152.76C228.837 152.332 228.837 152.332 229.015 151.723C229.125 152.048 229.24 152.384 229.367 152.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2725 153.339C49.5145 152.876 49.8832 152.899 50.2058 152.737C50.2231 152.812 50.2405 152.888 50.2578 152.969C49.9236 153.085 49.5951 153.2 49.2609 153.316C49.2552 153.316 49.2725 153.339 49.2725 153.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58036 25.5702C9.0042 25.8888 9.09062 25.3326 9.02148 25.0024C9.17705 25.1646 9.33837 25.3326 9.58036 25.5702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.352 44.5536C168.697 44.4088 168.87 44.4957 168.997 44.8954C168.686 45.1966 168.524 45.0229 168.352 44.5536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.576 170.591C152.789 170.353 153.003 170.197 153.262 170.591C152.991 170.591 152.784 170.591 152.576 170.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8613 46.1815C25.9766 46.0598 26.063 45.9092 26.1725 45.8571C26.2474 45.8223 26.3626 45.9092 26.449 45.9729C26.4721 45.9903 26.4721 46.1699 26.4432 46.2104C26.3856 46.2799 26.2992 46.3437 26.2301 46.3321C26.1091 46.3147 25.9938 46.2394 25.8613 46.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.225 25.6165C250.115 25.7672 250.04 25.912 249.948 25.9757C249.919 25.9931 249.758 25.7787 249.764 25.7034C249.781 25.5644 249.873 25.4196 249.96 25.3443C249.994 25.3153 250.11 25.4891 250.225 25.6165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.938 170.655C154.174 170.776 154.237 171.008 154.116 171.286C154.082 171.367 153.892 171.425 153.851 171.367C153.627 171.083 153.736 170.852 153.938 170.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.241 178.782C172.12 178.817 171.981 178.921 171.889 178.863C171.797 178.811 171.751 178.591 171.688 178.452C171.722 178.4 171.757 178.348 171.791 178.29C171.941 178.382 172.091 178.481 172.246 178.574C172.246 178.643 172.241 178.713 172.241 178.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.668 188.456C74.8466 187.976 74.9157 187.628 75.2845 187.779C75.2384 188.207 75.0309 188.288 74.668 188.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.235 215.834C213.12 215.996 213.051 216.158 212.953 216.199C212.895 216.222 212.792 216.06 212.711 215.984C212.792 215.84 212.861 215.677 212.964 215.561C212.982 215.538 213.108 215.706 213.235 215.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.311 220.329C199.489 220.329 199.662 220.329 199.887 220.329C199.547 220.711 199.547 220.711 199.311 220.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4259 233.572C46.0744 233.207 46.3395 232.952 46.4144 232.668C46.6218 233.01 46.6218 233.01 46.4259 233.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.333 257.873C221.952 258.041 221.791 257.966 221.791 257.607C221.791 257.514 221.981 257.335 221.993 257.352C222.102 257.479 222.189 257.636 222.333 257.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12695 51.256C1.36318 51.1169 1.5994 50.9779 1.82987 50.8389C1.70311 51.3544 1.46689 51.4935 1.12695 51.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7433 261.488C74.5474 261.349 74.3458 261.21 74.1211 261.054C74.1902 260.938 74.2709 260.805 74.3804 260.631C74.5763 260.886 74.8182 261.036 74.7433 261.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.794 57.6109C110.707 57.4313 110.598 57.298 110.615 57.2169C110.644 57.0779 110.753 56.9678 110.834 56.8462C110.915 56.9563 111.07 57.0837 111.059 57.1706C111.036 57.3154 110.909 57.4313 110.794 57.6109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1276 71.3924C18.9951 71.4967 18.8914 71.6299 18.8395 71.601C18.7416 71.5488 18.6725 71.3924 18.5918 71.2824C18.6609 71.1955 18.7531 71.0217 18.7992 71.0391C18.9087 71.0854 18.9893 71.2302 19.1276 71.3924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92851 109.162C2.07255 109.284 2.22235 109.411 2.36639 109.539C2.36063 109.603 2.34911 109.666 2.34335 109.736C2.22235 109.753 2.08984 109.829 1.99189 109.776C1.81904 109.678 1.73262 109.475 1.92851 109.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.648 43.1575C182.515 42.8563 182.429 42.6883 182.365 42.4971C182.36 42.4739 182.492 42.2944 182.538 42.3117C182.74 42.3986 182.798 42.6072 182.648 43.1575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.508 222.768C241.45 222.293 241.663 222.189 241.905 222.102C241.911 222.542 241.911 222.542 241.508 222.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70703 90.1905C10.047 89.8024 10.047 89.8024 10.3235 90.4512C10.1161 90.3585 9.95478 90.2948 9.70703 90.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.811 71.8906C39.5402 71.9891 39.3731 72.047 39.1484 72.1281C39.4135 71.4561 39.4135 71.4561 39.811 71.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5332 43.2733C22.5735 42.8736 22.7233 42.6361 23.1958 42.6013C22.9653 42.9837 22.8155 43.2212 22.6715 43.4587C22.6254 43.4007 22.5793 43.337 22.5332 43.2733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.974 240.552C241.726 240.523 241.472 240.494 241.225 240.465C241.23 240.384 241.23 240.303 241.236 240.222C241.49 240.251 241.737 240.274 241.991 240.303C241.985 240.39 241.979 240.471 241.974 240.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.375 99.6562C104.213 99.7315 104.046 99.8068 103.787 99.9227C103.914 99.3376 104.081 99.2623 104.323 99.3839C104.334 99.4824 104.358 99.5693 104.375 99.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57422 170.191C4.68945 170.035 4.78164 169.849 4.82773 169.867C4.93144 169.907 5.0121 170.052 5.10429 170.156C5.04667 170.261 4.98329 170.452 4.93144 170.446C4.82197 170.434 4.72978 170.313 4.57422 170.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.496 249.63C145.727 249.601 145.963 249.566 146.291 249.52C145.945 249.844 145.945 249.844 145.496 249.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3039 228.7C1.95245 229.019 1.80841 228.914 1.71622 228.671C1.69317 228.613 1.79688 228.387 1.80841 228.393C1.94668 228.457 2.0792 228.549 2.3039 228.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0841 227.495C18.1763 227.64 18.2915 227.744 18.2915 227.843C18.2915 227.953 18.1878 228.063 18.1244 228.179C18.038 228.08 17.9458 227.976 17.8594 227.877C17.9228 227.767 17.9861 227.657 18.0841 227.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5384 128.082C70.5327 128.279 70.5269 128.476 70.5096 128.667C70.5096 128.685 70.3713 128.708 70.3368 128.667C70.1754 128.453 70.2215 128.25 70.5384 128.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.786 146.006C29.5152 146.006 29.2444 146.006 28.916 146.006C29.2848 145.751 29.302 145.751 29.786 146.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.541 171.06C103.921 171.06 104.302 171.06 104.676 171.06C104.676 171.101 104.676 171.141 104.676 171.176C104.296 171.176 103.916 171.176 103.541 171.176C103.541 171.135 103.541 171.095 103.541 171.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.676 162.365C237.843 162.017 238.01 161.687 238.171 161.357C238.206 161.392 238.24 161.421 238.281 161.455C238.125 161.78 237.975 162.11 237.82 162.429C237.808 162.434 237.751 162.394 237.676 162.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4778 75.766C76.207 75.7602 76.0342 75.7602 75.8613 75.7602C75.8671 75.6733 75.8498 75.5458 75.8786 75.5111C76.1321 75.233 76.2358 75.5748 76.4778 75.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9062 259.408C29.6988 259.472 29.5951 259.559 29.5144 259.518C29.4222 259.466 29.2782 259.298 29.2897 259.211C29.3243 258.939 29.4798 258.933 29.6239 259.055C29.693 259.113 29.7449 259.206 29.9062 259.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9551 7.30497C77.2547 7.18911 77.4045 7.29918 77.4563 7.612C77.4679 7.6873 77.3872 7.8553 77.3411 7.87268C77.053 7.9364 76.9954 7.66413 76.9551 7.30497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78125 238.206C5.01748 237.702 5.18456 237.957 5.43231 238.357C5.15575 238.507 4.97714 238.513 4.78125 238.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0757 197.244C30.1275 197.383 30.1967 197.563 30.2831 197.8C30.1333 197.91 30.0008 198.003 29.8164 198.136C29.9259 197.771 30.0008 197.505 30.0757 197.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.84 8.54459C144.673 8.84003 144.523 8.96168 144.345 8.701C144.31 8.64886 144.322 8.44611 144.362 8.38239C144.552 8.09274 144.69 8.24915 144.84 8.54459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0977 64.823C19.3108 64.5739 19.4779 64.5566 19.6047 64.852C19.6335 64.9215 19.6047 65.1243 19.5643 65.1532C19.3569 65.2981 19.2014 65.1996 19.0977 64.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2351 258.192C25.3733 258.215 25.5059 258.238 25.7248 258.273C25.6153 258.482 25.5231 258.731 25.4886 258.719C25.3676 258.667 25.2696 258.516 25.1602 258.406C25.1832 258.331 25.212 258.261 25.2351 258.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.727 257.062C207.6 257.022 207.468 257.01 207.352 256.935C207.306 256.906 207.306 256.738 207.283 256.634C207.375 256.605 207.485 256.518 207.548 256.564C207.646 256.634 207.704 256.802 207.779 256.923C207.761 256.97 207.744 257.016 207.727 257.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2192 98.9553C50.9945 99.1754 50.8274 99.1928 50.7122 98.88C50.6949 98.8278 50.7237 98.683 50.7583 98.654C50.9715 98.4687 51.104 98.6135 51.2192 98.9553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6128 230.571C31.3305 230.536 31.0539 230.496 30.7773 230.461C30.7773 230.415 30.7831 230.363 30.7831 230.316C31.0654 230.316 31.3477 230.316 31.6301 230.316C31.6243 230.403 31.6185 230.484 31.6128 230.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7266 12.0029C81.9397 12.084 82.2221 12.0956 82.1068 12.6112C81.8015 12.617 81.7611 12.31 81.7266 12.0029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.465 176.801C169.465 177.114 169.465 177.316 169.465 177.513C169.367 177.502 169.217 177.542 169.183 177.473C169.045 177.172 169.16 176.998 169.465 176.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24023 136.864C2.28057 136.627 2.31514 136.412 2.35547 136.169C2.45341 136.216 2.5456 136.221 2.55712 136.268C2.63202 136.609 2.68388 136.945 2.24023 136.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7949 126.234C23.7834 126.906 23.7834 126.906 23.2188 126.715C23.4492 126.518 23.599 126.396 23.7949 126.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2363 84.0788C46.3343 84.0267 46.4495 83.9108 46.5359 83.9456C46.6396 83.9804 46.7376 84.1252 46.801 84.2584C46.8183 84.2932 46.6857 84.5597 46.6396 84.5481C46.5359 84.5307 46.4437 84.409 46.34 84.3279C46.3055 84.241 46.2709 84.1599 46.2363 84.0788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1682 60.0498C9.92048 60.0614 9.79949 59.9513 9.84558 59.6385C9.85711 59.5748 9.93201 59.4705 9.9781 59.4763C10.197 59.5111 10.2143 59.7312 10.1682 60.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1992 116.514C89.5392 116.218 89.7062 116.456 89.9597 116.601C89.6717 116.867 89.4815 116.722 89.1992 116.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92821 258.418C1.72079 258.273 1.51913 258.122 1.26562 257.943C1.65165 257.67 1.78993 258.099 2.00887 258.232C1.98006 258.29 1.95125 258.354 1.92821 258.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0226 257.213C77.9074 256.836 77.7922 256.466 77.6769 256.089C77.6251 256.164 77.5675 256.234 77.5156 256.309C77.7979 256.257 77.7979 256.257 78.1609 257.033C78.1206 257.097 78.0687 257.155 78.0226 257.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0842 64.6726C71.3377 64.7247 71.4875 64.8464 71.3953 65.2056C71.3722 65.2809 71.2397 65.3678 71.1879 65.3388C70.9286 65.1882 71.0381 64.9333 71.0842 64.6726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8628 163.859C55.9493 163.744 56.0299 163.628 56.1164 163.518C56.2258 163.384 56.2316 163.384 56.56 163.622C56.3929 164.155 56.1106 163.929 55.8571 163.854C55.8513 163.854 55.8628 163.859 55.8628 163.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5471 256.425C39.3684 256.46 39.1898 256.5 39.0112 256.529C38.9594 256.541 38.8845 256.558 38.8557 256.524C38.8096 256.471 38.7923 256.367 38.752 256.245C39.0688 255.938 39.3108 256.153 39.5471 256.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.619 67.3547C256.89 67.6502 256.948 67.934 256.619 68.1773C256.619 67.8761 256.619 67.6154 256.619 67.3547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.918 68.2467C228.785 68.5943 228.624 68.6986 228.342 68.5016C228.492 68.1309 228.63 67.9397 228.918 68.2467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8798 68.6582C59.995 68.8262 60.1102 68.9884 60.2255 69.1564C60.1679 69.2317 60.0699 69.3823 60.0642 69.3765C59.9374 69.2317 59.8222 69.0695 59.7012 68.9073C59.7645 68.8204 59.8222 68.7393 59.8798 68.6582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.437 230.241C128.42 230.183 128.408 230.119 128.379 230.079C128.247 229.893 128.132 229.702 128.276 229.441C128.362 229.291 128.454 229.378 128.673 229.789C128.592 229.94 128.512 230.084 128.437 230.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.619 52.3162C104.78 51.9513 104.878 51.5979 105.293 51.7427C105.12 52.1077 104.994 52.3973 104.619 52.3162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.825 145.2C241.698 145.316 241.594 145.467 241.543 145.444C241.445 145.391 241.37 145.235 241.289 145.125C241.358 145.032 241.45 144.841 241.496 144.859C241.606 144.893 241.687 145.044 241.825 145.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.695 191.173C185.447 191.202 185.332 191.214 185.223 191.225C185.223 191.028 185.223 190.826 185.223 190.629C185.263 190.617 185.303 190.6 185.344 190.588C185.43 190.727 185.516 190.872 185.695 191.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7634 242.893C50.8729 243.072 50.9824 243.258 51.1264 243.495C50.6597 243.733 50.654 243.362 50.7634 242.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0065 106.08C55.874 106.196 55.7761 106.347 55.7242 106.318C55.6263 106.272 55.5571 106.115 55.4707 106.005C55.5398 105.918 55.6205 105.739 55.6724 105.756C55.7761 105.797 55.8624 105.93 56.0065 106.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.708 236.08C190.564 235.993 190.414 235.912 190.276 235.814C190.27 235.808 190.328 235.628 190.356 235.53C190.5 235.634 190.645 235.738 190.789 235.843C190.76 235.924 190.737 235.999 190.708 236.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1504 90.2832C42.3463 90.0631 42.3866 89.4954 42.7726 89.675C42.5825 90.2079 42.5825 90.2079 42.1504 90.2832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.37 186.353C118.226 186.446 118.134 186.562 118.059 186.539C117.978 186.516 117.915 186.359 117.846 186.255C117.938 186.157 118.024 186.012 118.122 185.989C118.174 185.977 118.255 186.174 118.37 186.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.287 25.8424C106.42 25.5586 106.546 25.35 106.765 25.576C106.806 25.6165 106.806 25.8309 106.765 25.9062C106.627 26.1784 106.477 26.0742 106.287 25.8424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9843 170.979C78.7135 170.996 78.4427 171.02 78.1719 171.043C78.4311 170.741 78.7019 170.643 78.9785 170.753C78.9785 170.828 78.9785 170.904 78.9843 170.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.692 110.808C35.5537 110.779 35.4097 110.75 35.2656 110.721C35.2829 110.611 35.2944 110.408 35.306 110.408C35.4442 110.408 35.5883 110.443 35.7266 110.466C35.7208 110.582 35.7093 110.698 35.692 110.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.871 143.364C221.549 143.497 221.433 143.341 221.422 142.999C221.422 142.935 221.491 142.808 221.531 142.808C221.785 142.779 221.848 143.016 221.871 143.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0725 250.198C65.8536 250.18 65.6692 250.169 65.3984 250.151C65.7153 249.879 65.7153 249.879 66.0725 250.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1985 257.381C57.0026 257.271 56.8586 257.196 56.6973 257.109C56.9623 256.726 56.9623 256.726 57.1985 257.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0566 258.499C21.1603 258.209 21.2122 258.059 21.2986 257.821C21.3966 258.076 21.4715 258.261 21.5867 258.557C21.3851 258.539 21.2641 258.522 21.0566 258.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.035 258.383C107.632 258.551 107.632 258.551 107.355 258.342C107.563 257.781 107.765 258.221 108.035 258.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.889 260.764C157.78 260.868 157.688 260.996 157.659 260.973C157.567 260.891 157.486 260.764 157.423 260.631C157.411 260.608 157.555 260.399 157.567 260.411C157.676 260.492 157.762 260.613 157.889 260.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5107 3.52224C66.0671 3.80609 66.0268 3.37741 65.877 2.82129C66.1593 3.13411 66.3264 3.31948 66.5107 3.52224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9848 4.52422C53.7658 4.52422 53.5411 4.52422 53.3222 4.52422C53.3222 4.47787 53.3222 4.43153 53.3164 4.37939C53.5353 4.37939 53.7543 4.37939 53.9732 4.37939C53.979 4.43153 53.979 4.47787 53.9848 4.52422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9219 212.636C21.9737 212.329 22.089 212.173 22.4347 212.375C22.2618 212.561 22.1466 212.688 22.0256 212.816C21.9853 212.758 21.9564 212.694 21.9219 212.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.413 248.425C117.212 248.396 117.021 248.384 117.021 248.008C117.021 247.95 117.102 247.834 117.148 247.84C117.396 247.84 117.471 248.048 117.413 248.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.084 11.1978C82.3375 11.1341 82.4931 11.0993 82.6774 11.053C82.3778 11.499 82.3778 11.499 82.084 11.1978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.223 132.27C64.1077 132.16 63.9867 132.056 63.8773 131.94C63.8715 131.934 63.9464 131.737 63.9579 131.743C64.0904 131.807 64.2172 131.894 64.3497 131.975C64.3036 132.073 64.2633 132.172 64.223 132.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9082 81.4026C35.202 81.4547 35.3979 81.4837 35.7206 81.5416C35.2712 81.8139 35.2712 81.8139 34.9082 81.4026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.087 13.99C121.937 14.5114 121.788 14.6214 121.586 14.0421C121.793 14.019 121.937 14.0016 122.087 13.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1758 122.538C61.5157 122.324 61.6482 122.492 61.7231 122.88C61.4293 122.909 61.4293 122.909 61.1758 122.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1132 127.271C26.6811 127.457 26.7041 127.097 26.756 126.698C26.8712 126.889 26.9922 127.08 27.1132 127.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24707 87.6707C4.94747 87.856 4.83224 87.688 4.75734 87.4505C4.74005 87.3984 4.79191 87.242 4.82648 87.2246C5.09151 87.1087 5.1376 87.4042 5.24707 87.6707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.26 227.304C101.967 226.916 101.967 226.916 102.376 226.557C102.335 226.835 102.301 227.043 102.26 227.304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.616 29.3587C168.495 28.8084 168.61 28.6578 168.795 28.623C168.841 28.6114 168.962 28.8258 168.956 28.8374C168.87 28.9938 168.772 29.1386 168.616 29.3587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5477 240.57C72.4383 240.888 72.3518 241.137 72.2596 241.392C72.058 240.94 72.058 240.94 72.5477 240.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4822 240.39C94.223 240.581 94.0674 240.529 93.9925 240.187C93.981 240.147 94.0156 240.048 94.0444 240.031C94.3036 239.88 94.3555 240.176 94.4822 240.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3926 95.6533C17.4387 95.3926 17.479 95.1377 17.5251 94.8828C17.721 95.1956 17.8305 95.4853 17.6058 95.717C17.5309 95.6938 17.4617 95.6764 17.3926 95.6533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.19 215.202C249.741 215.156 249.793 214.803 249.793 214.397C250.115 214.49 250.144 214.791 250.19 215.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.648 42.5204C219.51 42.6421 219.418 42.729 219.32 42.8158C219.274 42.7 219.17 42.5552 219.187 42.4799C219.222 42.3466 219.337 42.2597 219.418 42.1497C219.487 42.2597 219.55 42.364 219.648 42.5204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.119 115.639C109.964 115.297 109.883 115.118 109.779 114.892C110.217 114.921 110.217 114.921 110.119 115.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61717 234.447C1.46161 234.412 1.30605 234.371 1.04102 234.313C1.17353 234.111 1.29452 233.862 1.32909 233.885C1.46161 233.966 1.57108 234.145 1.68631 234.284C1.66327 234.337 1.64022 234.394 1.61717 234.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.537 233.89C198.773 233.23 198.929 233.328 199.159 233.763C198.958 233.803 198.808 233.832 198.537 233.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1861 47.311C61.3071 47.3748 61.4281 47.4385 61.5433 47.5022C61.5145 47.6065 61.4857 47.705 61.4569 47.8092C61.3417 47.7397 61.2207 47.6702 61.1055 47.6007C61.1343 47.5022 61.1631 47.4037 61.1861 47.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.947 129.368C160.12 129.409 160.298 129.455 160.557 129.519C160.258 129.89 160.091 129.675 159.912 129.548C159.924 129.49 159.935 129.432 159.947 129.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.68 51.3545C218.95 51.4993 219.112 51.5804 219.365 51.7194C219.002 52.0381 218.812 52.0149 218.68 51.3545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4272 137.791C65.2486 137.884 65.07 137.977 64.8223 138.104C65.0066 137.675 65.0066 137.675 65.4272 137.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.705 114.747C93.5264 114.845 93.4342 114.955 93.3535 114.932C93.2671 114.909 93.1979 114.764 93.123 114.672C93.1979 114.579 93.2786 114.393 93.342 114.405C93.4457 114.428 93.5379 114.579 93.705 114.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8549 99.0072C61.7166 99.1057 61.5783 99.2042 61.3594 99.3664C61.3882 98.7581 61.561 98.7234 61.7685 98.7755C61.7973 98.8508 61.8261 98.9261 61.8549 99.0072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9812 128.951C49.6643 129.293 49.5145 129.264 49.4223 128.986C49.3993 128.916 49.4742 128.772 49.503 128.667C49.6355 128.743 49.768 128.824 49.9812 128.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0879 149.956C47.3644 149.504 47.497 149.742 47.6352 150.101C47.4336 150.35 47.2895 150.234 47.0879 149.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.441 143.103C75.1587 143.52 75.0204 143.497 74.8994 143.248C74.8764 143.196 74.9052 143.097 74.911 143.016C75.055 143.04 75.199 143.063 75.441 143.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.877 171.066C107.194 171.066 107.505 171.066 107.822 171.066C107.822 171.106 107.822 171.153 107.822 171.193C107.505 171.193 107.194 171.193 106.877 171.193C106.877 171.153 106.877 171.106 106.877 171.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.146 100.664C156.973 100.763 156.806 100.861 156.547 101.006C156.783 100.322 156.783 100.322 157.146 100.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6582 230.386C29.8887 230.316 30.1191 230.252 30.4821 230.148C30.2171 230.809 29.9117 230.449 29.7043 230.641C29.687 230.554 29.6697 230.467 29.6582 230.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.708 208.147C238.581 208.28 238.507 208.413 238.432 208.413C238.351 208.413 238.276 208.28 238.201 208.204C238.265 208.112 238.328 207.95 238.403 207.932C238.478 207.915 238.564 208.036 238.708 208.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.871 153.971C177.658 154.272 177.491 154.278 177.295 153.849C177.531 153.641 177.698 153.618 177.871 153.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9861 135.827C74.819 136.198 74.6519 136.239 74.3984 136.082C74.5252 135.654 74.6808 135.549 74.9861 135.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5683 135.619C52.4531 135.995 52.3033 136.042 52.1304 135.88C52.0844 135.833 52.0498 135.619 52.0844 135.573C52.2226 135.358 52.3782 135.422 52.5683 135.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.895 134.958C105.746 135.063 105.648 135.179 105.573 135.161C105.498 135.138 105.44 134.976 105.377 134.877C105.458 134.796 105.538 134.651 105.613 134.657C105.694 134.657 105.769 134.808 105.895 134.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5072 250.939C74.6513 251.24 74.7377 251.431 74.8241 251.617C74.8068 251.669 74.7838 251.721 74.7665 251.773C74.6282 251.715 74.4957 251.657 74.3574 251.599C74.3978 251.42 74.4381 251.246 74.5072 250.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0169 252.503C21.184 252.602 21.3281 252.689 21.4663 252.77C21.4433 252.868 21.4433 252.961 21.426 252.967C21.184 253.065 20.9593 253.111 21.0169 252.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4336 253.048C13.6237 252.972 13.7562 252.92 13.9637 252.839C13.7562 253.343 13.7562 253.343 13.4336 253.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4213 255.73C49.2945 255.863 49.2254 255.996 49.1447 256.002C49.0756 256.008 49.0007 255.869 48.9258 255.794C48.9892 255.689 49.0468 255.521 49.1217 255.504C49.1908 255.487 49.283 255.62 49.4213 255.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0251 172.618C69.9041 172.601 69.7773 172.589 69.6621 172.543C69.6506 172.537 69.6678 172.346 69.6736 172.242C69.8004 172.265 69.9329 172.288 70.0596 172.311C70.0481 172.416 70.0366 172.52 70.0251 172.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.783 71.966C193.668 71.8849 193.547 71.8096 193.432 71.7285C193.466 71.63 193.53 71.4504 193.541 71.4562C193.662 71.5257 193.777 71.6242 193.887 71.7111C193.852 71.798 193.823 71.8791 193.783 71.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5312 74.9435C15.295 75.0188 15.1452 75.0651 14.9551 75.1172C14.9724 74.9724 14.9666 74.8855 14.9896 74.8276C15.1394 74.5148 15.295 74.4511 15.5312 74.9435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.166 249.792C143.901 249.792 143.63 249.792 143.365 249.792C143.365 249.734 143.371 249.676 143.371 249.613C143.636 249.636 143.907 249.659 144.172 249.682C144.166 249.717 144.166 249.757 144.166 249.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.268 187.211C225.957 187.332 225.819 187.228 225.882 186.626C226.061 186.892 226.165 187.054 226.268 187.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0637 28.9243C10.2538 29.1387 10.2192 29.3646 9.99453 29.7064C9.9542 29.3935 9.92539 29.1792 9.90234 28.9649C9.9542 28.9533 10.0118 28.9417 10.0637 28.9243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.691 120.424C229.553 120.511 229.461 120.592 229.374 120.598C229.34 120.598 229.253 120.372 229.265 120.343C229.322 120.244 229.409 120.152 229.495 120.14C229.541 120.134 229.599 120.285 229.691 120.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.251 152.673C118.118 152.801 118.038 152.94 117.957 152.94C117.882 152.94 117.807 152.789 117.727 152.702C117.796 152.604 117.865 152.441 117.946 152.424C118.02 152.413 118.113 152.557 118.251 152.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.504 167.138C251.59 167.364 251.654 167.503 251.694 167.654C251.7 167.677 251.539 167.828 251.516 167.805C251.441 167.718 251.366 167.596 251.337 167.469C251.325 167.405 251.418 167.301 251.504 167.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9931 230.171C22.8549 230.316 22.7224 230.455 22.5265 230.664C22.4631 230.554 22.3939 230.438 22.2441 230.171C22.561 230.171 22.78 230.171 22.9931 230.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5506 194.817C66.4065 194.487 66.3144 194.29 66.1934 194.006C66.3316 194.029 66.4238 194.006 66.4814 194.058C66.6831 194.238 66.6773 194.249 66.5506 194.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5312 170.863C72.8078 170.84 73.0844 170.817 73.3667 170.794C73.3667 170.857 73.3724 170.921 73.3724 170.985C73.0959 171.008 72.8193 171.031 72.5428 171.048C72.537 170.991 72.5312 170.927 72.5312 170.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.165 104.557C108.108 104.181 108.067 103.92 108.016 103.595C108.298 103.839 108.298 103.839 108.165 104.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3094 213.401C64.0213 213.32 63.8427 213.267 63.6641 213.215C63.906 212.827 64.0789 212.891 64.3094 213.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.117 230.814C99.8343 230.814 99.5519 230.814 99.2754 230.814C99.2754 230.768 99.2754 230.727 99.2754 230.681C99.5577 230.681 99.8343 230.681 100.117 230.681C100.117 230.722 100.117 230.768 100.117 230.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19892 195.014C3.99726 194.95 3.86474 194.904 3.7207 194.858C3.74375 194.776 3.74375 194.713 3.7668 194.69C3.95693 194.452 4.10097 194.469 4.19892 195.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2598 27.8003C37.0755 27.7366 36.9833 27.7366 36.9257 27.6786C36.845 27.5975 36.7816 27.4759 36.6895 27.3311C37.0006 27.1283 37.1216 27.3137 37.2598 27.8003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3535 155.355C52.3881 155.037 52.4976 154.834 52.9124 154.765C52.7165 155.112 52.607 155.315 52.4918 155.512C52.4399 155.465 52.3996 155.408 52.3535 155.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6441 227.785C37.5692 227.559 37.4943 227.333 37.3906 227.032C37.7248 227.24 37.7248 227.24 37.6441 227.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20009 243.901C7.07333 243.901 6.94658 243.901 6.79102 243.901C6.96386 243.524 6.96386 243.524 7.20009 243.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0117 170.88C46.0578 170.718 46.1097 170.562 46.2019 170.249C46.2883 170.533 46.3401 170.695 46.392 170.857C46.2883 170.915 46.1903 170.979 46.0866 171.037C46.0636 170.985 46.0405 170.933 46.0117 170.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4699 86.8364C38.5332 87.0566 38.6024 87.2767 38.7119 87.6474C38.3662 87.4389 38.2221 87.2593 38.2625 86.9465C38.3316 86.9117 38.4007 86.877 38.4699 86.8364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6152 135.41C64.9494 135.196 64.9494 135.196 65.2202 135.654C64.9609 135.555 64.7881 135.48 64.6152 135.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.411 225.606C145.278 225.641 145.146 225.682 144.979 225.728C145.128 225.334 145.128 225.334 145.411 225.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2879 127.862C23.092 127.642 22.9825 127.509 22.873 127.387C22.9364 127.289 22.9652 127.207 22.9883 127.207C23.1899 127.202 23.2994 127.341 23.2879 127.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.208 20.2058C109.324 20.2406 109.445 20.2637 109.56 20.3217C109.577 20.3275 109.56 20.4723 109.56 20.5534C109.433 20.5186 109.301 20.4839 109.174 20.4491C109.185 20.368 109.197 20.2869 109.208 20.2058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1726 191.886C65.0574 191.834 64.9421 191.787 64.8327 191.724C64.8269 191.718 64.8615 191.509 64.8788 191.509C64.994 191.509 65.1092 191.544 65.2302 191.567C65.2072 191.677 65.1899 191.782 65.1726 191.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.904 250.435C104.002 250.615 104.105 250.731 104.094 250.817C104.082 250.922 103.973 251.026 103.892 251.072C103.869 251.09 103.742 250.922 103.748 250.846C103.754 250.73 103.829 250.62 103.904 250.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5118 222.646C39.3851 222.594 39.2583 222.542 39.1431 222.473C39.1373 222.467 39.1834 222.281 39.2064 222.177C39.3274 222.241 39.4484 222.31 39.5637 222.374C39.5464 222.461 39.5291 222.554 39.5118 222.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.063 184.587C180.983 184.65 180.896 184.749 180.816 184.755C180.764 184.76 180.706 184.621 180.654 184.546C180.741 184.453 180.821 184.326 180.919 184.285C180.988 184.256 181.081 184.338 181.161 184.372C181.127 184.442 181.092 184.511 181.063 184.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2949 252.092C58.6752 251.976 58.8423 252.179 58.9345 252.584C58.7501 252.439 58.56 252.3 58.2949 252.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.575 230.473C190.361 230.49 190.142 230.507 189.791 230.536C190.119 229.986 190.35 230.368 190.557 230.281C190.563 230.345 190.569 230.409 190.575 230.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91488 110.738C8.11654 110.842 8.23177 110.981 8.12806 111.265C8.10502 111.329 7.95522 111.381 7.91488 111.341C7.73051 111.149 7.81694 110.952 7.91488 110.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4149 253.482C58.6108 253.569 58.801 253.656 58.9969 253.743C58.9738 253.83 58.9565 253.911 58.9335 253.998C58.7376 253.893 58.5475 253.795 58.3516 253.691C58.3746 253.621 58.3977 253.552 58.4149 253.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.517 254.403C46.3211 254.403 46.177 254.403 46.0215 254.403C46.2116 254.056 46.2116 254.056 46.517 254.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.949 67.9224C201.868 67.9572 201.77 68.0499 201.707 68.0151C201.609 67.963 201.522 67.8355 201.459 67.7139C201.442 67.6849 201.557 67.4532 201.574 67.4648C201.678 67.5227 201.77 67.6154 201.862 67.6965C201.891 67.7776 201.92 67.8471 201.949 67.9224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9023 115.94C65.081 116.178 65.1962 116.334 65.3575 116.548C64.9196 116.618 64.9196 116.618 64.9023 115.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6623 254.635C46.6738 255 46.6854 255.203 46.6911 255.4C46.6335 255.4 46.5528 255.44 46.5183 255.4C46.3627 255.22 46.3281 255.017 46.6623 254.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8613 239.776C42.0803 239.284 42.0803 239.284 42.426 239.573C42.2243 239.643 42.063 239.701 41.8613 239.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.82 243.808C187.999 243.767 188.178 243.733 188.362 243.692C188.368 243.75 188.379 243.802 188.391 243.86C188.206 243.93 188.028 243.999 187.843 244.069C187.838 243.976 187.826 243.895 187.82 243.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.231 17.5701C74.1964 17.2283 74.1733 17.0198 74.1445 16.7417C74.5306 17.1124 74.5306 17.1124 74.231 17.5701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.092 16.9097C154.201 16.8286 154.305 16.7243 154.42 16.6722C154.443 16.6606 154.507 16.8402 154.553 16.9271C154.432 17.0197 154.305 17.1124 154.184 17.2051C154.155 17.1066 154.126 17.0082 154.092 16.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.457 135.161C253.572 135.265 253.687 135.37 253.82 135.486C253.52 135.746 253.52 135.746 253.457 135.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10547 225.67C1.28408 225.85 1.46269 226.035 1.65858 226.232C1.34169 226.261 1.34169 226.261 1.10547 225.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8601 64.3654C86.7276 64.4002 86.5951 64.4349 86.4453 64.4755C86.5605 64.0294 86.5605 64.0294 86.8601 64.3654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5627 16.5564C25.7355 16.7012 25.9314 16.8287 25.8392 17.379C25.6779 17.0836 25.5685 16.8866 25.459 16.6896C25.4936 16.6433 25.5281 16.6027 25.5627 16.5564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3708 258.273C58.1288 258.128 57.973 258.041 57.7656 257.914C58.1113 257.769 58.1113 257.769 58.3708 258.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.114 168.511C172.028 168.569 171.93 168.697 171.866 168.668C171.792 168.633 171.705 168.465 171.705 168.349C171.705 168.25 171.82 168.059 171.878 168.065C171.999 168.077 172.114 168.187 172.229 168.256C172.189 168.343 172.154 168.424 172.114 168.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9938 244.208C43.6885 244.208 43.5041 244.208 43.2852 244.208C43.4811 243.872 43.6597 243.82 43.9938 244.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6055 209.12C42.7437 209.016 42.8359 208.882 42.9051 208.905C42.98 208.929 43.0376 209.097 43.101 209.201C43.0261 209.282 42.9512 209.421 42.8763 209.415C42.7956 209.404 42.7265 209.259 42.6055 209.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.249 59.5747C109.122 59.6906 109.048 59.8007 108.967 59.8122C108.915 59.818 108.8 59.65 108.811 59.6037C108.834 59.482 108.909 59.3198 108.978 59.3083C109.042 59.2909 109.128 59.4415 109.249 59.5747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.933 151.138C229.742 151.26 229.558 151.387 229.368 151.509C229.345 151.439 229.322 151.37 229.299 151.3C229.489 151.173 229.673 151.051 229.863 150.924C229.886 150.999 229.91 151.069 229.933 151.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4968 259.686C12.2893 259.461 12.1626 259.31 11.9609 259.09C12.4334 258.841 12.5141 259.072 12.4968 259.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5375 248.859C65.2206 249.439 65.0535 249.062 64.8691 248.929C65.0477 248.912 65.2206 248.888 65.5375 248.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.512 58.1091C197.759 57.86 197.909 57.9526 198.076 58.2771C197.834 58.503 197.679 58.4508 197.512 58.1091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.463 260.19C219.227 260.411 219.072 260.353 218.974 260.04C218.956 259.994 219.02 259.854 219.066 259.82C219.342 259.652 219.371 259.965 219.463 260.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.746 182.316C102.556 182.362 102.4 182.339 102.395 181.997C102.395 181.933 102.464 181.812 102.51 181.812C102.74 181.8 102.792 181.997 102.746 182.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21005 57.0027C2.59032 57.4545 2.44628 57.6341 2.04297 57.889C2.11211 57.5125 2.15244 57.2923 2.21005 57.0027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.82 54.0831C164.884 53.8166 164.982 53.6486 165.183 53.8224C165.218 53.8572 165.252 54.002 165.229 54.0483C165.12 54.3032 164.976 54.3148 164.82 54.0831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54501 261.616C4.35487 261.563 4.16474 261.505 3.97461 261.453C3.98037 261.395 3.98613 261.343 3.98613 261.285C4.15898 261.262 4.33183 261.245 4.55077 261.216C4.53925 261.378 4.52772 261.511 4.52196 261.644L4.54501 261.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2318 178.539C67.0993 178.684 67.0302 178.805 66.9495 178.829C66.8919 178.846 66.8112 178.742 66.7363 178.695C66.7882 178.574 66.8228 178.394 66.8977 178.353C66.9668 178.319 67.0705 178.44 67.2318 178.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8352 52.1018C53.6854 52.1481 53.5299 52.2003 53.334 52.264C53.5068 51.8179 53.5068 51.8179 53.8352 52.1018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8863 194.881C69.7711 194.805 69.6559 194.736 69.5522 194.637C69.5406 194.626 69.604 194.452 69.6328 194.348C69.7481 194.429 69.8633 194.516 69.9785 194.603C69.9497 194.695 69.9209 194.788 69.8863 194.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.547 256.425C39.6046 256.634 39.6564 256.836 39.7429 257.143C39.5527 257.08 39.4144 257.028 39.207 256.958C39.3568 256.726 39.449 256.576 39.547 256.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.23 154.55C225.547 154.851 225.559 155.095 225.23 155.35C225.23 155.043 225.23 154.793 225.23 154.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.403 209.375C149.299 209.183 149.184 209.062 149.201 208.981C149.218 208.865 149.333 208.784 149.408 208.685C149.46 208.766 149.558 208.853 149.558 208.934C149.552 209.05 149.478 209.166 149.403 209.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.914 160.453C182.023 160.407 182.127 160.355 182.237 160.303C182.254 160.343 182.271 160.384 182.294 160.424C182.237 160.523 182.196 160.656 182.121 160.697C182.07 160.731 181.983 160.639 181.908 160.604C181.914 160.552 181.914 160.5 181.914 160.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71875 161.965C7.90312 162.243 7.99531 162.376 8.09901 162.539C7.76484 162.637 7.76484 162.637 7.71875 161.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.962 113.409C186.749 113.409 186.599 113.409 186.455 113.409C186.455 113.322 186.438 113.241 186.455 113.218C186.639 113.003 186.783 113.061 186.962 113.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.017 169.119C109.907 169.061 109.804 168.998 109.7 168.928C109.694 168.922 109.723 168.772 109.729 168.778C109.844 168.801 109.959 168.836 110.074 168.876C110.057 168.951 110.034 169.038 110.017 169.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2207 168.876C88.3878 168.708 88.5318 168.708 88.6298 168.986C88.6471 169.033 88.5952 169.172 88.5549 169.195C88.3475 169.305 88.2265 169.206 88.2207 168.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.261 169.409C127.094 169.247 127.031 169.061 127.163 168.83C127.186 168.783 127.307 168.772 127.33 168.807C127.474 169.027 127.428 169.224 127.261 169.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.127 111.897C65.4669 112.076 65.5706 112.244 65.392 112.783C65.294 112.441 65.2307 112.239 65.127 111.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5768 142.327C21.3982 142.304 21.2196 142.275 21.041 142.252C21.0525 142.194 21.0583 142.13 21.0698 142.072C21.1447 142.113 21.2139 142.165 21.2945 142.182C21.3925 142.211 21.4904 142.211 21.5884 142.223C21.5768 142.263 21.5768 142.292 21.5768 142.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.741 128.493C240.648 128.389 240.591 128.32 240.527 128.256C240.608 128.14 240.677 128.013 240.769 127.92C240.781 127.908 240.936 128.082 240.925 128.134C240.902 128.256 240.821 128.349 240.741 128.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5141 127.149C24.4335 127.485 24.3989 127.648 24.3471 127.856C24.2261 127.758 24.1396 127.682 23.9668 127.538C24.1569 127.404 24.2837 127.317 24.5141 127.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.92 170.736C113.116 170.794 113.306 170.857 113.502 170.915C113.502 170.95 113.496 170.979 113.49 171.014C113.294 170.991 113.098 170.967 112.902 170.95C112.908 170.881 112.914 170.805 112.92 170.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8727 197.372C50.7114 197.302 50.5559 197.233 50.3945 197.163C50.4118 197.088 50.4291 197.007 50.4464 196.926C50.6077 197.001 50.7633 197.07 50.9246 197.146C50.9016 197.227 50.8843 197.296 50.8727 197.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6576 112.071C51.7382 112.227 51.8304 112.343 51.8189 112.389C51.7843 112.505 51.7037 112.615 51.623 112.679C51.6 112.696 51.4559 112.522 51.4675 112.47C51.4847 112.349 51.5654 112.25 51.6576 112.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.547 117C124.679 116.873 124.818 116.745 125.054 116.52C124.858 116.989 124.858 116.989 124.547 117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30859 126.692C4.42958 126.425 4.51601 126.223 4.60819 126.014C4.637 126.049 4.6831 126.078 4.6831 126.113C4.71191 126.454 4.70038 126.75 4.30859 126.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9004 197.968C15.9811 197.795 16.056 197.621 16.1712 197.366C16.3383 197.835 16.2634 198.02 16.0502 198.107C16.0041 198.061 15.9522 198.015 15.9004 197.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.767 110.275C111.652 110.373 111.56 110.501 111.525 110.472C111.444 110.414 111.375 110.292 111.346 110.17C111.335 110.13 111.473 109.944 111.513 109.962C111.588 110.002 111.652 110.13 111.767 110.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.229 98.4048C229.102 98.7524 229.039 98.9377 228.935 99.2216C228.797 98.7755 228.889 98.6075 229.229 98.4048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.813 219.061C204.692 219.171 204.611 219.292 204.53 219.292C204.467 219.292 204.346 219.124 204.352 219.061C204.369 218.95 204.461 218.782 204.525 218.782C204.611 218.788 204.686 218.927 204.813 219.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7012 218.956C11.851 218.933 12.0008 218.91 12.2024 218.881C12.0872 219.501 11.8971 219.315 11.7185 219.228C11.7127 219.136 11.7069 219.049 11.7012 218.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7083 145.646C65.4317 145.629 65.2935 145.617 65.0918 145.606C65.2762 145.177 65.4202 145.27 65.7083 145.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28729 105.843C5.20087 105.976 5.12021 106.139 5.10292 106.127C5.00498 106.052 4.92431 105.936 4.83789 105.837C4.88974 105.762 4.95312 105.611 4.99921 105.623C5.0914 105.64 5.17206 105.745 5.28729 105.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8736 105.258C41.695 105.478 41.6374 105.548 41.5798 105.617C41.528 105.519 41.4588 105.426 41.4358 105.31C41.43 105.27 41.5395 105.142 41.6029 105.131C41.672 105.119 41.7526 105.194 41.8736 105.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5431 104.453C70.6295 104.621 70.716 104.713 70.716 104.806C70.716 104.881 70.618 104.962 70.5604 105.044C70.5085 104.962 70.4221 104.887 70.4164 104.794C70.4106 104.713 70.4797 104.609 70.5431 104.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.843 226.823C38.6874 226.875 38.5318 226.933 38.382 226.985C38.3647 226.916 38.3532 226.84 38.3359 226.771C38.4857 226.701 38.6413 226.638 38.7911 226.568C38.8084 226.655 38.8257 226.736 38.843 226.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5675 227.472C82.6194 227.628 82.6655 227.744 82.6885 227.871C82.6943 227.895 82.5675 228.005 82.556 227.993C82.4926 227.895 82.435 227.779 82.3889 227.663C82.3832 227.646 82.4754 227.564 82.5675 227.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.413 228.468C261.297 228.393 261.188 228.323 261.079 228.231C261.073 228.219 261.13 228.011 261.136 228.011C261.257 228.051 261.372 228.109 261.488 228.167C261.465 228.266 261.442 228.364 261.413 228.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7909 229.407C19.6238 229.308 19.451 229.21 19.209 229.065C19.572 228.694 19.6757 229.158 19.86 229.227C19.837 229.291 19.814 229.349 19.7909 229.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4207 104.209C19.0519 104.024 19.1095 103.74 19.2536 103.422C19.2997 103.653 19.3515 103.891 19.4207 104.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5645 103.265C69.7027 103.242 69.8352 103.213 69.9735 103.184C69.9793 103.259 69.9908 103.335 70.0023 103.41C69.8698 103.451 69.7431 103.485 69.6163 103.526C69.5933 103.439 69.5817 103.352 69.5645 103.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7858 100.068C61.6821 100.183 61.6015 100.328 61.5727 100.305C61.492 100.259 61.4344 100.137 61.3652 100.044C61.4286 99.9807 61.4862 99.8764 61.5554 99.8706C61.613 99.8648 61.6764 99.9691 61.7858 100.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63544 99.7604C4.50868 99.7256 4.38193 99.6908 4.21484 99.6387C4.41074 99.2332 4.54325 99.3722 4.63544 99.7604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5511 97.982C52.1881 98.2659 52.0383 98.1732 51.877 97.6924C52.1305 97.8024 52.2803 97.8662 52.5511 97.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9219 96.0529C47.0198 95.8791 47.0947 95.7343 47.1984 95.5374C47.256 95.6764 47.3021 95.7459 47.3079 95.8096C47.331 96.2499 47.1696 96.2035 46.9219 96.0529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.132 95.7574C250.017 95.8675 249.947 95.9775 249.867 96.0007C249.821 96.0123 249.705 95.8327 249.711 95.8096C249.757 95.6879 249.821 95.5663 249.901 95.4967C249.919 95.4794 250.017 95.63 250.132 95.7574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.096 236.874C123.189 237.013 123.252 237.111 123.315 237.204C123.258 237.279 123.189 237.424 123.143 237.413C123.056 237.389 122.987 237.274 122.912 237.192C122.958 237.106 123.01 237.019 123.096 236.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8881 238.009C42.8017 237.922 42.7152 237.83 42.623 237.743C42.6749 237.662 42.7268 237.581 42.7728 237.5C42.8478 237.61 42.9169 237.72 42.9918 237.835C42.9572 237.893 42.9226 237.951 42.8881 238.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6047 237.407C39.6277 237.783 39.6335 237.934 39.6508 238.16C39.524 238.032 39.4261 237.934 39.3281 237.841C39.3915 237.737 39.4606 237.633 39.6047 237.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9551 237.766C54.0991 237.882 54.2374 237.992 54.4794 238.189C54.1106 238.339 53.9666 238.229 53.9551 237.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7637 92.4497C61.3892 92.6466 61.2624 92.5308 61.1875 92.1658C61.4237 91.9573 61.5159 92.2353 61.7637 92.4497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24258 88.1572C3.39814 88.2209 3.55946 88.2905 3.74383 88.3658C3.69774 88.4527 3.65165 88.5743 3.6286 88.5685C3.46728 88.5106 3.30595 88.4237 3.15039 88.3484C3.1792 88.2847 3.20801 88.2209 3.24258 88.1572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.293 242.151C44.5753 241.838 44.7251 241.78 44.9152 242.151C44.702 242.151 44.5465 242.151 44.293 242.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08755 85.7821C0.972323 85.7531 0.85133 85.73 0.74186 85.6778C0.724575 85.672 0.74186 85.4461 0.747621 85.4461C0.868614 85.4287 0.989608 85.4345 1.1106 85.4345C1.10484 85.5504 1.09332 85.6662 1.08755 85.7821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8638 245.494C23.7082 245.407 23.5526 245.32 23.3164 245.193C23.6448 245.14 23.6448 245.14 23.8638 245.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2137 75.3547C19.329 75.5401 19.4154 75.627 19.4557 75.7487C19.4672 75.7834 19.3405 75.9746 19.3117 75.963C19.231 75.9282 19.1446 75.8298 19.11 75.7255C19.087 75.6618 19.1561 75.5401 19.2137 75.3547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7695 250.14C70.6427 250.116 70.5217 250.099 70.395 250.07C70.3892 250.07 70.395 249.908 70.4007 249.908C70.5275 249.879 70.6542 249.862 70.781 249.844C70.7752 249.943 70.7752 250.041 70.7695 250.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.148 251.055C169.13 250.835 169.119 250.62 169.102 250.4C169.136 250.395 169.176 250.383 169.217 250.371C169.251 250.591 169.286 250.812 169.315 251.038C169.263 251.043 169.205 251.049 169.148 251.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6978 173.088C65.7554 173.36 65.7957 173.539 65.8648 173.829C65.7035 173.621 65.6056 173.487 65.4961 173.343C65.5479 173.279 65.5883 173.221 65.6978 173.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8192 0.347656C83.8768 0.851645 83.7501 0.921161 83.4102 0.921161C83.5772 0.68365 83.6694 0.556203 83.8192 0.347656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2631 197.65C61.1594 197.771 61.0557 197.893 60.9519 198.015C60.9289 197.986 60.9059 197.951 60.8828 197.922C60.9692 197.777 61.0557 197.632 61.1363 197.488C61.1824 197.545 61.2227 197.598 61.2631 197.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2319 175.086C83.1455 174.97 83.0533 174.86 82.9727 174.733C82.9727 174.727 83.0648 174.559 83.0764 174.571C83.1801 174.646 83.278 174.744 83.376 174.837C83.3299 174.924 83.2838 175.005 83.2319 175.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4709 124.299C43.5804 124.398 43.6898 124.502 43.7993 124.601C43.7878 124.647 43.782 124.687 43.7705 124.734C43.6841 124.722 43.5919 124.745 43.517 124.699C43.4536 124.658 43.4133 124.548 43.3672 124.467C43.4018 124.415 43.4363 124.357 43.4709 124.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.664 4.65186C246.802 4.80247 246.912 4.91254 247.062 5.07474C246.704 5.08053 246.704 5.08053 246.664 4.65186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.103 7.25269C259.195 7.42647 259.299 7.53654 259.305 7.6524C259.305 7.7335 259.178 7.86094 259.092 7.88412C259.046 7.9015 258.919 7.7335 258.93 7.66978C258.942 7.54233 259.023 7.43227 259.103 7.25269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.918 175.909C174.143 176.123 174.264 176.239 174.465 176.436C174.062 176.673 173.958 176.511 173.918 175.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8037 116.224C93.8959 116.398 93.9651 116.496 93.9996 116.612C94.0111 116.647 93.919 116.803 93.9017 116.798C93.821 116.745 93.7288 116.688 93.677 116.589C93.6654 116.543 93.7403 116.409 93.8037 116.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4181 143.462C50.2568 143.509 50.0897 143.555 49.8535 143.625C50.0725 143.219 50.0725 143.219 50.4181 143.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.796 122.938C104.94 122.984 105.078 123.036 105.222 123.083C105.211 123.158 105.199 123.239 105.194 123.315C105.05 123.28 104.9 123.251 104.75 123.216C104.767 123.123 104.785 123.031 104.796 122.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3035 20.5129C48.1594 20.6056 48.0788 20.704 47.9923 20.704C47.9347 20.704 47.8253 20.5245 47.8368 20.4897C47.8771 20.368 47.952 20.2058 48.0269 20.1885C48.0961 20.1711 48.1767 20.3449 48.3035 20.5129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.386 24.3362C106.242 24.4636 106.104 24.5968 105.902 24.7764C105.914 24.2377 106.116 24.2029 106.288 24.1218C106.317 24.1913 106.352 24.2609 106.386 24.3362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7049 25.3732C49.532 25.4253 49.3937 25.4659 49.2324 25.5122C49.2497 25.35 49.2382 25.2689 49.267 25.2342C49.4053 25.0372 49.5493 24.9793 49.7049 25.3732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.049 65.0143C240.164 64.9158 240.274 64.8173 240.389 64.7246C240.423 64.8231 240.492 64.9969 240.481 65.0085C240.383 65.1127 240.262 65.188 240.153 65.2749C240.118 65.188 240.083 65.1012 240.049 65.0143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.701 181.511C231.58 181.511 231.459 181.511 231.344 181.511C231.35 181.435 231.35 181.285 231.361 181.285C231.476 181.267 231.592 181.273 231.707 181.273C231.701 181.354 231.701 181.429 231.701 181.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5172 27.4644C46.4192 27.5802 46.3559 27.7135 46.2982 27.7077C46.2061 27.6961 46.1254 27.5918 46.0332 27.5223C46.0966 27.4238 46.1542 27.2443 46.2176 27.2385C46.304 27.2327 46.3904 27.3659 46.5172 27.4644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0639 256.599C64.8852 256.813 64.7758 256.946 64.6375 257.109C64.6145 257.033 64.5684 256.958 64.5684 256.888C64.5799 256.483 64.7182 256.379 65.0639 256.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7793 116.137C47.8715 116.091 47.9579 116.01 48.0443 116.021C48.1019 116.027 48.148 116.172 48.2575 116.346C48.0501 116.346 47.9291 116.346 47.8023 116.346C47.7966 116.276 47.7851 116.207 47.7793 116.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81035 122.347C4.77578 122.104 4.73545 121.861 4.68359 121.501C5.02929 121.785 4.95439 122.058 4.97167 122.307C4.91982 122.324 4.8622 122.336 4.81035 122.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09961 246.664C1.18603 246.583 1.27246 246.507 1.35888 246.426C1.38769 246.496 1.42226 246.571 1.45683 246.641C1.35888 246.704 1.25517 246.762 1.15723 246.826C1.13418 246.768 1.11689 246.716 1.09961 246.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.446 36.6173C104.325 36.8954 104.192 36.907 104.048 36.6695C104.019 36.6231 104.025 36.4725 104.054 36.4378C104.233 36.2524 104.359 36.3451 104.446 36.6173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.132 37.5557C237.982 37.8395 237.901 37.9843 237.757 38.2566C237.688 37.77 237.786 37.6368 238.132 37.5557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3945 38.8708C77.5847 38.952 77.7748 39.0331 77.9649 39.1142C77.7057 39.369 77.4982 39.3517 77.3945 38.8708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1484 44.6636C18.5633 44.8953 18.3904 45.1386 18.183 45.5615C18.1657 45.1734 18.16 44.9532 18.1484 44.6636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0364 205.401C49.1977 205.592 49.3129 205.719 49.4339 205.87C49.359 205.928 49.3187 205.986 49.2956 205.974C49.1516 205.893 48.8578 205.992 49.0364 205.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54102 206.044C3.7081 206.044 3.86943 206.044 4.11141 206.044C3.88095 206.426 3.69082 206.241 3.54102 206.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.493 259.09C146.136 259.345 146.096 259.026 145.992 258.87C146.015 258.812 146.038 258.76 146.061 258.702C146.182 258.812 146.303 258.922 146.493 259.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5079 258.789C56.6 258.962 56.6519 259.067 56.7037 259.171C56.6404 259.229 56.577 259.333 56.5194 259.327C56.4618 259.322 56.3811 259.206 56.3753 259.125C56.3696 259.049 56.4387 258.951 56.5079 258.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.209 146.029C33.2954 146.029 33.3818 146.029 33.4683 146.029C33.4683 146.058 33.4683 146.087 33.4683 146.11C33.3818 146.11 33.3012 146.11 33.2147 146.11C33.2147 146.087 33.209 146.058 33.209 146.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.828 146.782C238.949 146.851 239.07 146.927 239.254 147.031C238.978 147.355 238.857 147.251 238.828 146.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5078 136.795C42.8881 136.43 42.9745 136.65 43.0724 137.038C42.8881 136.957 42.7556 136.899 42.5078 136.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5149 259.35C61.6475 259.385 61.7857 259.42 61.9586 259.461C61.9067 259.576 61.8722 259.692 61.8491 259.686C61.7224 259.669 61.6014 259.623 61.4746 259.582C61.4861 259.507 61.4977 259.432 61.5149 259.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.662 260.202C117.316 260.051 117.38 259.831 117.564 259.408C117.61 259.791 117.639 259.999 117.662 260.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79111 150.032C1.67587 149.956 1.5664 149.875 1.45117 149.8C1.4915 149.701 1.55488 149.516 1.5664 149.522C1.68164 149.586 1.78534 149.684 1.88905 149.771C1.85448 149.858 1.82568 149.945 1.79111 150.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27938 119.856C2.08925 120.239 1.91064 120.244 1.70898 119.926C1.88183 119.903 2.05468 119.879 2.27938 119.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44414 57.6168C5.35195 57.4777 5.25977 57.3966 5.25977 57.3155C5.25977 57.2287 5.34619 57.1418 5.39228 57.0491C5.45566 57.1186 5.55361 57.1765 5.57089 57.2634C5.58818 57.3445 5.50751 57.4546 5.44414 57.6168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7678 143.711C33.6064 143.7 33.4682 143.682 33.3184 143.671C33.3472 143.561 33.3529 143.48 33.376 143.468C33.6007 143.352 33.6007 143.352 33.7678 143.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.298 56.012C16.396 56.1684 16.4766 56.2553 16.5112 56.3711C16.5227 56.4175 16.4017 56.6028 16.3787 56.5913C16.2923 56.5391 16.2058 56.4464 16.154 56.3422C16.1309 56.3074 16.2231 56.1684 16.298 56.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.631 138.816C222.919 138.857 223.069 138.984 223.126 139.384C222.792 139.448 222.694 139.233 222.631 138.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8062 150.721C37.4893 150.976 37.3337 150.964 37.2531 150.663C37.2416 150.611 37.3222 150.449 37.3395 150.454C37.4605 150.507 37.5815 150.588 37.8062 150.721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.875 136.053C251.008 136.169 251.146 136.285 251.279 136.401C251.256 136.47 251.227 136.54 251.204 136.609C251.06 136.517 250.921 136.418 250.777 136.325C250.812 136.233 250.846 136.146 250.875 136.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1465 261.841C15.2617 261.702 15.3827 261.558 15.4979 261.419C15.5267 261.471 15.5613 261.529 15.5901 261.581C15.4691 261.714 15.3424 261.847 15.2214 261.98C15.1983 261.934 15.1753 261.888 15.1465 261.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7383 261.494C75.0436 261.32 75.3087 261.523 75.5795 261.679C75.5852 261.679 75.591 261.668 75.5968 261.668C75.2856 261.899 75.0033 261.778 74.7383 261.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.819 152.442C171.618 152.389 171.485 152.349 171.301 152.303C171.577 151.967 171.577 151.967 171.819 152.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.883 120.088C33.7332 120.001 33.5834 119.92 33.4336 119.833C33.4509 119.769 33.4682 119.706 33.4854 119.642C33.6352 119.717 33.7851 119.798 33.9349 119.874C33.9233 119.949 33.906 120.018 33.883 120.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.276 189.754C186.386 189.945 186.46 190.038 186.501 190.159C186.512 190.2 186.42 190.368 186.409 190.356C186.322 190.304 186.224 190.246 186.167 190.148C186.144 190.107 186.213 189.957 186.276 189.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.604 135.602C158.674 135.752 158.772 135.897 158.754 135.926C158.702 136.03 158.616 136.123 158.535 136.146C158.495 136.158 158.374 135.972 158.386 135.949C158.432 135.839 158.507 135.746 158.604 135.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3356 121.716C65.3932 121.861 65.4738 121.977 65.4565 122.034C65.4335 122.116 65.3355 122.202 65.2722 122.202C65.2203 122.197 65.1281 122.046 65.1397 121.994C65.1569 121.901 65.2434 121.843 65.3356 121.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.688 242.939C143.792 243.026 143.89 243.119 143.994 243.205C143.976 243.246 143.965 243.292 143.947 243.333C143.838 243.269 143.723 243.2 143.613 243.13C143.636 243.066 143.665 243.003 143.688 242.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9381 23.0792C16.8286 23.1893 16.771 23.2994 16.7076 23.3051C16.6442 23.3109 16.5809 23.2067 16.5117 23.1487C16.5751 23.0503 16.627 22.9228 16.7019 22.8707C16.7422 22.8475 16.8286 22.975 16.9381 23.0792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.043 22.2392C36.1812 22.2102 36.3138 22.1812 36.4924 22.1465C36.3887 22.6447 36.2446 22.6736 36.043 22.2392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0137 145.247C48.91 145.084 48.8466 144.986 48.7832 144.893C48.8466 144.824 48.9157 144.691 48.9676 144.702C49.031 144.714 49.1174 144.83 49.1404 144.928C49.1577 144.98 49.077 145.084 49.0137 145.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.682 14.436C169.544 14.7373 169.475 14.8879 169.371 15.1196C169.21 14.633 169.342 14.5519 169.682 14.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0684 126.727C48.2758 126.802 48.4314 126.854 48.5927 126.912C48.5581 126.993 48.5466 127.068 48.5178 127.08C48.3276 127.161 48.149 127.196 48.0684 126.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.473 14.581C143.34 14.6794 143.248 14.7953 143.208 14.7663C143.127 14.7142 143.075 14.581 143.018 14.4825C143.075 14.4246 143.144 14.3029 143.196 14.3145C143.271 14.3377 143.34 14.4477 143.473 14.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5787 198.49C50.4347 198.391 50.2964 198.293 50.1523 198.2C50.1696 198.142 50.1869 198.084 50.2042 198.026C50.354 198.119 50.498 198.206 50.6478 198.299C50.6248 198.362 50.6017 198.426 50.5787 198.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93323 127.694C5.91019 127.908 5.8929 128.123 5.86409 128.384C5.76615 128.32 5.66244 128.262 5.6682 128.25C5.70853 128.042 5.76615 127.839 5.818 127.636C5.85257 127.654 5.8929 127.677 5.93323 127.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8472 81.4546C10.778 81.2924 10.7146 81.1881 10.6858 81.0723C10.6801 81.0375 10.7607 80.9564 10.8068 80.9043C10.8702 81.0086 10.9336 81.1013 10.9797 81.2171C10.9912 81.2403 10.9163 81.3272 10.8472 81.4546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1134 246.032C93.9866 246.171 93.929 246.282 93.8714 246.282C93.8022 246.282 93.7331 246.189 93.6582 246.137C93.6928 246.044 93.7273 245.876 93.7677 245.87C93.8541 245.876 93.9405 245.951 94.1134 246.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9377 111.346C58.0357 111.468 58.0933 111.543 58.151 111.613C58.099 111.694 58.0472 111.827 57.9896 111.839C57.932 111.85 57.8283 111.752 57.811 111.671C57.7937 111.601 57.8743 111.491 57.9377 111.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4645 246.757C70.5739 246.791 70.6834 246.82 70.7871 246.855C70.7813 246.896 70.7813 246.936 70.7756 246.977C70.6661 246.977 70.5509 246.977 70.4414 246.977C70.4472 246.901 70.4587 246.826 70.4645 246.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.683 7.9422C254.591 7.83213 254.493 7.7742 254.487 7.6931C254.476 7.612 254.557 7.50773 254.597 7.41504C254.678 7.48455 254.758 7.55407 254.839 7.62359C254.793 7.71048 254.747 7.80317 254.683 7.9422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.117 248.39C259.985 248.298 259.846 248.205 259.65 248.077C259.962 247.794 260.071 248.002 260.117 248.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.462 79.2708C113.399 79.3751 113.347 79.4968 113.33 79.491C113.243 79.4446 113.169 79.3635 113.088 79.294C113.128 79.2361 113.174 79.126 113.215 79.1318C113.29 79.1376 113.364 79.2071 113.462 79.2708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7432 77.6604C46.8757 77.7299 47.0081 77.7936 47.1407 77.8632C47.1291 77.9269 47.1118 77.9964 47.1003 78.0601C46.962 78.0138 46.8238 77.9674 46.6855 77.9211C46.6971 77.8342 46.7201 77.7473 46.7432 77.6604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2138 7.7569C75.8162 7.86696 75.8566 7.62366 75.9315 7.22974C76.0582 7.46145 76.1389 7.61207 76.2138 7.7569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6267 76.6293C73.4827 76.7046 73.402 76.7973 73.3502 76.7683C73.2695 76.722 73.2177 76.5945 73.1543 76.5019C73.2177 76.4381 73.2926 76.3107 73.3444 76.3223C73.4193 76.357 73.4885 76.4787 73.6267 76.6293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.519 6.5576C234.422 6.67346 234.37 6.78932 234.312 6.79511C234.26 6.8009 234.156 6.68504 234.151 6.61553C234.145 6.53443 234.22 6.38381 234.272 6.37222C234.335 6.36064 234.404 6.46491 234.519 6.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1699 104.354C72.314 104.331 72.458 104.308 72.7 104.267C72.4926 104.725 72.3312 104.574 72.1699 104.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.746 4.76187C256.671 4.61704 256.579 4.51856 256.591 4.44905C256.602 4.35636 256.695 4.28105 256.752 4.19995C256.81 4.28105 256.896 4.35636 256.908 4.45484C256.913 4.51856 256.827 4.61704 256.746 4.76187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6117 4.34471C67.5311 4.44319 67.4446 4.54167 67.364 4.64594C67.3409 4.60539 67.3121 4.57063 67.2891 4.53008C67.3697 4.42002 67.4561 4.30995 67.5426 4.19409C67.5656 4.24044 67.5887 4.29257 67.6117 4.34471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6576 2.96021C19.8017 3.13399 19.9227 3.31937 19.8766 3.67274C19.5654 3.55688 19.6749 3.22089 19.623 3.00655L19.6576 2.96021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.435 3.05284C242.372 2.85588 242.314 2.73423 242.297 2.60678C242.291 2.57202 242.412 2.45037 242.424 2.46196C242.499 2.53726 242.579 2.63575 242.62 2.74581C242.631 2.78636 242.528 2.90222 242.435 3.05284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2012 125.267C46.3279 125.168 46.3971 125.081 46.4201 125.105C46.5181 125.18 46.6102 125.296 46.6563 125.51C46.5296 125.441 46.3971 125.371 46.2012 125.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4997 125C48.5688 125.11 48.6437 125.226 48.7129 125.336C48.6668 125.388 48.5919 125.498 48.5861 125.493C48.5055 125.388 48.4363 125.273 48.3672 125.157C48.4133 125.105 48.4536 125.052 48.4997 125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.531 161.345C159.277 161.299 159.11 161.235 159.133 160.778C159.398 160.783 159.513 160.917 159.531 161.345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5996 249.804C26.7436 249.821 26.8819 249.833 27.0663 249.856C26.8877 250.325 26.7321 250.111 26.5996 249.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3965 170.452C39.5405 170.429 39.6846 170.411 39.8286 170.388C39.8344 170.446 39.8401 170.51 39.8459 170.568C39.7018 170.603 39.5578 170.643 39.408 170.684C39.408 170.603 39.4022 170.527 39.3965 170.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7401 228.978C41.8323 229.105 41.9187 229.233 42.0109 229.36C41.9648 229.424 41.9187 229.482 41.8726 229.546C41.7862 229.413 41.6998 229.279 41.6191 229.146C41.6595 229.094 41.6998 229.036 41.7401 228.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.511 209.299C231.333 209.155 231.223 209.062 231.039 208.911C231.367 208.691 231.465 208.807 231.511 209.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0635 68.5769C51.0865 68.7217 51.1153 68.8666 51.1384 69.0056C51.098 69.0172 51.0347 69.0519 51.0289 69.0345C50.977 68.9071 50.9367 68.7739 50.8906 68.6406C50.9482 68.6232 51.0059 68.6001 51.0635 68.5769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7461 104.134C70.8498 104.134 70.9535 104.123 71.0572 104.146C71.0745 104.152 71.0745 104.291 71.086 104.366C70.9708 104.366 70.8613 104.366 70.7519 104.366C70.7461 104.291 70.7461 104.21 70.7461 104.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3632 153.681C53.2479 153.646 53.127 153.612 53.0117 153.577C53.0232 153.519 53.029 153.455 53.0405 153.397C53.1558 153.438 53.271 153.478 53.392 153.519C53.3805 153.571 53.3689 153.623 53.3632 153.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7609 251.831C56.7436 251.97 56.7321 252.115 56.7148 252.254C56.6745 252.243 56.5996 252.231 56.5996 252.225C56.6054 252.086 56.6227 251.941 56.6342 251.802C56.6803 251.814 56.7206 251.82 56.7609 251.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43672 223.463C2.36758 223.324 2.30996 223.22 2.26387 223.104C2.25811 223.092 2.3791 222.953 2.39063 222.965C2.46553 223.046 2.5289 223.156 2.59228 223.26C2.55195 223.312 2.51162 223.365 2.43672 223.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8276 117.018C34.891 117.151 34.9486 117.284 35.012 117.423C34.9601 117.464 34.868 117.551 34.8622 117.545C34.7931 117.423 34.7412 117.29 34.6836 117.157C34.7297 117.104 34.7815 117.064 34.8276 117.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.126 252.845C39.0165 252.914 38.9128 252.99 38.7976 253.048C38.7918 253.048 38.7457 252.909 38.7227 252.828C38.8321 252.752 38.9417 252.677 39.0511 252.607C39.0799 252.683 39.1029 252.764 39.126 252.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2853 153.814C56.882 153.646 57.0261 153.421 57.2162 153.015C57.245 153.374 57.2623 153.571 57.2853 153.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.637 101.18C157.735 101.11 157.833 101.029 157.931 100.977C157.948 100.971 157.994 101.104 158.029 101.174C157.931 101.261 157.827 101.348 157.729 101.435C157.7 101.348 157.671 101.267 157.637 101.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5583 67.9514C44.6447 68.0904 44.7023 68.1715 44.7542 68.2584C44.685 68.3453 44.6159 68.438 44.5468 68.5249C44.4949 68.438 44.4085 68.3569 44.4085 68.2642C44.4027 68.1773 44.4891 68.0904 44.5583 67.9514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4408 208.06C20.2622 208.06 20.1239 208.06 19.9453 208.06C20.1239 207.701 20.2564 207.643 20.4408 208.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3158 152.986C53.264 152.835 53.2179 152.685 53.166 152.534C53.2409 152.499 53.3101 152.465 53.385 152.43C53.4138 152.586 53.4426 152.749 53.4714 152.905C53.4138 152.934 53.3619 152.957 53.3158 152.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1383 223.44C60.023 223.399 59.9078 223.365 59.7926 223.313C59.7868 223.307 59.7983 223.156 59.8041 223.156C59.9251 223.145 60.0461 223.15 60.1671 223.15C60.1556 223.243 60.1498 223.342 60.1383 223.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.442 151.532C62.2115 151.746 62.1424 151.845 62.1193 151.827C62.0387 151.758 61.9753 151.654 61.9004 151.561C61.958 151.486 62.0156 151.352 62.0675 151.358C62.1712 151.358 62.2691 151.445 62.442 151.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.498 255.197C59.5787 255.012 59.6536 254.855 59.7458 254.652C59.9071 255.232 59.9071 255.232 59.498 255.197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5683 66.729C66.4761 66.7927 66.3896 66.8622 66.2975 66.9144C66.2917 66.9202 66.2456 66.7869 66.2168 66.7174C66.3147 66.6537 66.4069 66.5842 66.5049 66.5146C66.5279 66.5842 66.551 66.6595 66.5683 66.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6532 220.625C29.6302 220.445 29.6129 220.26 29.5898 220.074C29.6244 220.063 29.6647 220.045 29.6993 220.028C29.7454 220.213 29.7915 220.399 29.8376 220.584C29.78 220.601 29.7166 220.613 29.6532 220.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.428 65.8717C100.318 65.7617 100.203 65.6458 100.094 65.5357C100.117 65.4836 100.14 65.4257 100.163 65.3735C100.284 65.4778 100.399 65.5879 100.52 65.6921C100.491 65.7501 100.457 65.808 100.428 65.8717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0719 148.821C35.9278 148.919 35.7838 149.012 35.6397 149.11C35.6225 149.064 35.6052 149.012 35.5879 148.966C35.7262 148.861 35.8702 148.757 36.0085 148.653C36.0315 148.711 36.0546 148.769 36.0719 148.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.903 138.376C122.047 138.845 121.95 138.956 121.621 138.979C121.736 138.741 121.8 138.602 121.903 138.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.151 47.5428C154.042 47.6703 153.984 47.7861 153.915 47.8035C153.863 47.8151 153.8 47.6992 153.742 47.6413C153.788 47.5544 153.829 47.4154 153.892 47.398C153.95 47.369 154.03 47.4617 154.151 47.5428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8887 99.1754C60.6236 99.1233 60.4969 99.1001 60.3125 99.0653C60.5026 98.6193 60.6409 98.7062 60.8887 99.1754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7334 46.0425C33.624 46.1757 33.5721 46.2452 33.5145 46.3089C33.4684 46.2278 33.405 46.1583 33.382 46.0656C33.3705 46.0251 33.4511 45.8918 33.4914 45.8918C33.5548 45.8918 33.6182 45.9672 33.7334 46.0425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1758 256.871C84.1988 256.721 84.2219 256.576 84.2507 256.425C84.291 256.437 84.3314 256.442 84.3717 256.454C84.3602 256.605 84.3429 256.755 84.3313 256.906C84.2795 256.894 84.2276 256.883 84.1758 256.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34677 218.8C1.20849 218.736 1.07597 218.672 0.949219 218.614C0.995311 218.284 1.0875 218.313 1.34677 218.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.7 111.23C176.562 111.213 176.418 111.19 176.176 111.161C176.452 110.75 176.579 110.958 176.7 111.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.087 81.0897C134.03 80.9101 133.966 80.8058 133.978 80.7189C133.989 80.6436 134.082 80.5857 134.139 80.522C134.185 80.6089 134.266 80.6958 134.272 80.7827C134.266 80.8638 134.18 80.9449 134.087 81.0897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9121 230.71C96.0965 230.693 96.2808 230.681 96.4652 230.67C96.4652 230.727 96.4652 230.785 96.4652 230.843C96.2808 230.826 96.0965 230.809 95.9121 230.791C95.9121 230.762 95.9121 230.733 95.9121 230.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6074 139.349C22.7342 139.286 22.8609 139.222 23.0741 139.118C22.9646 139.633 22.8033 139.564 22.6074 139.349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.051 61.1852C202.022 61.0288 201.994 60.8724 201.965 60.716C202.011 60.6986 202.063 60.6812 202.109 60.6638C202.132 60.826 202.161 60.9824 202.19 61.1388C202.143 61.1562 202.097 61.1678 202.051 61.1852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.4 44.0264C208.521 43.9685 208.648 43.9163 208.769 43.8584C208.792 43.9163 208.809 43.9743 208.833 44.0322C208.763 44.1133 208.706 44.2234 208.625 44.2581C208.567 44.2871 208.481 44.2118 208.412 44.1886C208.406 44.1365 208.406 44.0843 208.4 44.0264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.131 194.689C127.999 194.788 127.929 194.881 127.872 194.869C127.803 194.852 127.745 194.747 127.688 194.684C127.734 194.597 127.791 194.44 127.826 194.446C127.912 194.464 127.987 194.562 128.131 194.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.672 129.588C247.546 129.646 247.471 129.722 247.407 129.704C247.344 129.681 247.298 129.565 247.246 129.49C247.321 129.42 247.39 129.316 247.471 129.299C247.517 129.287 247.574 129.438 247.672 129.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5545 139.558C40.4335 139.506 40.3183 139.448 40.1973 139.39C40.2088 139.326 40.2203 139.262 40.2318 139.199C40.3586 139.233 40.4853 139.274 40.6063 139.315C40.5948 139.396 40.5775 139.477 40.5545 139.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.499 43.6384C192.568 43.789 192.608 43.8817 192.649 43.9686C192.585 44.0208 192.516 44.1308 192.453 44.1192C192.395 44.1077 192.309 43.9744 192.309 43.8991C192.314 43.8238 192.407 43.7543 192.499 43.6384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7568 258.163C70.8778 258.313 70.9988 258.464 71.2005 258.719C70.8317 258.754 70.7453 258.539 70.7568 258.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.311 43.1922C225.144 43.2385 225.069 43.2965 225.011 43.2617C224.948 43.2212 224.907 43.1053 224.855 43.0184C224.913 42.9547 224.994 42.8157 225.028 42.833C225.115 42.8852 225.172 43.0068 225.311 43.1922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4629 258.006C79.5839 258.035 79.7106 258.064 79.8835 258.105C79.6876 258.429 79.5608 258.447 79.4629 258.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.209 234.551C100.301 234.643 100.393 234.736 100.486 234.823C100.463 234.881 100.44 234.939 100.416 234.997C100.313 234.916 100.203 234.835 100.1 234.754C100.14 234.684 100.175 234.62 100.209 234.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.466 258.406C144.35 258.47 144.229 258.534 144.114 258.597C144.091 258.539 144.074 258.482 144.051 258.418C144.166 258.337 144.275 258.256 144.385 258.169C144.414 258.25 144.443 258.325 144.466 258.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1107 95.3172C14.984 95.2998 14.8572 95.2882 14.7305 95.2708C14.7305 95.2245 14.7305 95.1839 14.7305 95.1434C14.8572 95.126 14.9897 95.1028 15.1165 95.0854C15.1107 95.1608 15.1107 95.2419 15.1107 95.3172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5371 201.879C24.6811 201.826 24.8194 201.774 24.9635 201.722C24.975 201.769 24.9808 201.821 24.9923 201.873C24.854 201.931 24.7157 201.994 24.5717 202.052C24.5602 201.994 24.5486 201.937 24.5371 201.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.915 116.253C71.8344 116.172 71.7883 116.126 71.7422 116.079C71.7998 115.969 71.8517 115.865 71.9093 115.755C71.9496 115.813 72.036 115.877 72.0303 115.923C72.0187 116.027 71.9611 116.12 71.915 116.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4211 259.559C14.3347 259.379 14.2598 259.293 14.2598 259.206C14.2598 259.125 14.3404 259.044 14.3865 258.962C14.4384 259.038 14.519 259.107 14.5306 259.188C14.5421 259.275 14.4787 259.374 14.4211 259.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4726 226.168C37.3573 226.14 37.2363 226.116 37.1211 226.087C37.1269 226.035 37.1269 225.983 37.1326 225.925C37.2536 225.925 37.3688 225.925 37.4898 225.925C37.4841 226.006 37.4783 226.082 37.4726 226.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2246 258.968C78.3859 259.142 78.5415 259.31 78.7028 259.478C78.3571 259.652 78.3168 259.258 78.2246 258.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9063 106.365C72.987 106.469 73.0734 106.567 73.1541 106.672C73.1368 106.712 73.1138 106.753 73.0965 106.793C72.9985 106.706 72.8948 106.614 72.7969 106.527C72.8314 106.475 72.866 106.417 72.9063 106.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8452 238.113C2.63779 237.998 2.50527 237.928 2.35547 237.847C2.59746 237.673 2.59746 237.673 2.8452 238.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.313 222.357C129.163 222.223 129.019 222.09 128.869 221.963C128.886 221.911 128.904 221.864 128.927 221.818C129.088 221.934 129.249 222.055 129.411 222.171C129.376 222.235 129.342 222.299 129.313 222.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7402 227.026C96.8209 226.858 96.89 226.719 96.9649 226.557C97.1493 227.014 97.1493 227.014 96.7402 227.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8516 260.457C54.0071 260.44 54.1684 260.422 54.324 260.411C54.3298 260.469 54.3298 260.532 54.3355 260.596C54.1857 260.631 54.0302 260.666 53.8804 260.7C53.8688 260.613 53.8573 260.532 53.8516 260.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9856 260.312C63.1297 260.376 63.2795 260.445 63.4235 260.509C63.412 260.561 63.4062 260.613 63.3947 260.666C63.2449 260.613 63.0951 260.567 62.9453 260.515C62.9626 260.451 62.9741 260.382 62.9856 260.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28652 201.149C4.23467 200.998 4.18857 200.847 4.13672 200.703C4.19433 200.685 4.29804 200.633 4.3038 200.656C4.35566 200.789 4.37871 200.94 4.41328 201.079C4.37294 201.102 4.33261 201.125 4.28652 201.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9121 94.3441C72.9812 94.1935 73.0446 94.0429 73.1138 93.8865C73.1541 93.9154 73.1944 93.9444 73.2348 93.9734C73.2117 94.0776 73.2002 94.1877 73.1656 94.2804C73.1368 94.3499 73.0792 94.3962 73.0389 94.4484C72.9985 94.4136 72.9582 94.3789 72.9121 94.3441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3857 121.722C53.2878 121.669 53.1898 121.623 53.0977 121.571C53.1207 121.49 53.1438 121.415 53.1668 121.333C53.259 121.409 53.3569 121.484 53.4491 121.565C53.4261 121.617 53.4088 121.669 53.3857 121.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.101 239.77C241.951 239.811 241.807 239.851 241.657 239.892C241.64 239.828 241.629 239.764 241.611 239.701C241.686 239.631 241.761 239.527 241.848 239.51C241.928 239.492 242.015 239.562 242.101 239.591C242.101 239.649 242.101 239.712 242.101 239.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.76 33.9352C165.691 33.9758 165.588 34.0627 165.57 34.0395C165.507 33.9468 165.467 33.8136 165.438 33.6803C165.432 33.6629 165.536 33.5471 165.57 33.5587C165.668 33.5876 165.76 33.6629 165.853 33.7209C165.824 33.7962 165.789 33.8657 165.76 33.9352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0261 260.781C93.1528 260.874 93.2796 260.973 93.4063 261.071C93.4006 261.094 93.3948 261.117 93.3948 261.146C93.3142 261.123 93.2335 261.1 93.1586 261.065C93.0895 261.036 93.0203 260.984 92.9512 260.944C92.98 260.886 93.003 260.834 93.0261 260.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0352 116.282C26.4154 115.998 26.4615 116.265 26.5767 116.63C26.3809 116.502 26.2656 116.427 26.0352 116.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7758 261.453C20.5914 261.534 20.4647 261.587 20.3321 261.644C20.3149 261.546 20.286 261.459 20.2976 261.447C20.4243 261.326 20.5568 261.042 20.7758 261.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1825 53.0693C78.0846 53.162 78.0269 53.2663 77.9693 53.2605C77.9002 53.2547 77.8426 53.162 77.7734 53.1041C77.8311 53.0056 77.8829 52.8839 77.9578 52.8318C77.9866 52.8144 78.073 52.9535 78.1825 53.0693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9909 181.325C52.0485 181.441 52.1176 181.522 52.1061 181.557C52.0773 181.644 52.0197 181.713 51.9678 181.794C51.9275 181.736 51.8411 181.667 51.8526 181.626C51.8699 181.534 51.9275 181.453 51.9909 181.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7483 92.4207C55.6389 92.3802 55.5294 92.3454 55.4199 92.3049C55.443 92.1948 55.4603 92.0905 55.4833 91.9805C55.587 92.0384 55.6907 92.0963 55.7944 92.1543C55.7829 92.2469 55.7656 92.3338 55.7483 92.4207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1306 262.172C12.8367 262.038 12.6984 261.98 12.5371 261.911C12.7791 261.633 12.7791 261.633 13.1306 262.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9414 262.23C47.9529 262.056 47.9645 261.888 47.9933 261.546C48.1027 261.789 48.1834 261.888 48.1892 262.004C48.1949 262.091 48.1085 262.189 48.0625 262.282C48.0221 262.259 47.9817 262.247 47.9414 262.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.361 29.8279C189.441 29.9553 189.545 30.0654 189.533 30.1117C189.505 30.2276 189.43 30.3377 189.355 30.4014C189.332 30.4246 189.182 30.2624 189.188 30.2218C189.216 30.1001 189.286 29.9959 189.361 29.8279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29922 121.646C3.3914 121.745 3.48935 121.843 3.58153 121.942C3.5412 122.005 3.47783 122.133 3.47206 122.127C3.37988 122.046 3.29346 121.942 3.20703 121.843C3.23584 121.779 3.27041 121.71 3.29922 121.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7894 129.809C39.68 129.699 39.5878 129.6 39.4668 129.478C39.7837 129.345 39.7837 129.345 39.7894 129.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2911 161.635C20.1874 161.479 20.124 161.386 20.0664 161.293C20.1298 161.229 20.1932 161.114 20.2508 161.119C20.3142 161.125 20.3948 161.235 20.4236 161.328C20.4351 161.374 20.3545 161.484 20.2911 161.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6674 24.145C53.7423 24.2783 53.8288 24.3652 53.8288 24.4463C53.8288 24.5216 53.725 24.649 53.6674 24.6432C53.6098 24.6374 53.5176 24.5158 53.5061 24.4289C53.5003 24.3652 53.5983 24.2725 53.6674 24.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.877 242.661C145.975 242.881 146.038 242.98 146.067 243.095C146.078 243.148 146.021 243.229 145.998 243.298C145.923 243.223 145.831 243.159 145.784 243.061C145.761 243.014 145.819 242.881 145.877 242.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68359 242.951C2.81035 242.962 2.93134 242.974 3.0581 242.985C3.0581 243.049 3.0581 243.113 3.06386 243.177C2.94287 243.188 2.82187 243.206 2.69512 243.217C2.69512 243.13 2.68936 243.038 2.68359 242.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5973 185.456C45.482 185.525 45.4129 185.589 45.3495 185.595C45.3092 185.595 45.2688 185.496 45.2285 185.444C45.2861 185.38 45.338 185.288 45.4071 185.264C45.4359 185.247 45.4935 185.346 45.5973 185.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4315 185.948C23.3163 185.878 23.1953 185.809 23.0801 185.739C23.0916 185.687 23.1031 185.629 23.1204 185.577C23.2472 185.635 23.3682 185.699 23.4949 185.757C23.4719 185.821 23.4488 185.884 23.4315 185.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.756 94.2224C56.6466 94.263 56.5775 94.3093 56.5141 94.3035C56.4795 94.2977 56.4507 94.1876 56.4219 94.1239C56.4853 94.0776 56.5487 94.0023 56.6178 93.9907C56.6466 93.9849 56.6869 94.1007 56.756 94.2224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3008 186.168C15.4275 186.168 15.5543 186.168 15.681 186.168C15.6868 186.22 15.6868 186.272 15.6926 186.325C15.5716 186.336 15.4448 186.348 15.3181 186.359C15.3123 186.296 15.3065 186.232 15.3008 186.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2556 145.027C61.1346 145.119 61.077 145.195 61.0079 145.206C60.9675 145.212 60.8754 145.085 60.8811 145.056C60.9042 144.963 60.956 144.83 61.0079 144.818C61.0712 144.812 61.1346 144.922 61.2556 145.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.493 119.178C52.4065 119.115 52.3201 119.057 52.1934 118.97C52.4065 118.674 52.493 118.779 52.493 119.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.448 118.489C76.5517 118.57 76.6611 118.651 76.7648 118.732C76.7533 118.779 76.736 118.831 76.7245 118.877C76.6093 118.825 76.494 118.773 76.373 118.721C76.4019 118.64 76.4249 118.564 76.448 118.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41047 92.0848C6.35285 92.1948 6.31252 92.3223 6.28948 92.3165C6.21455 92.3049 6.15117 92.2354 6.08203 92.189C6.1166 92.1021 6.15117 91.9631 6.19726 91.9457C6.24912 91.9284 6.32405 92.021 6.41047 92.0848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62236 91.3664C3.57051 91.2737 3.51865 91.1868 3.4668 91.0941C3.50713 91.0478 3.54746 91.0014 3.59355 90.9551C3.63388 91.0651 3.67421 91.1752 3.71455 91.2853C3.67998 91.3142 3.65117 91.3432 3.62236 91.3664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51758 191.399C7.62705 191.37 7.73652 191.335 7.84599 191.306C7.85751 191.347 7.86327 191.393 7.8748 191.434C7.77109 191.498 7.66162 191.555 7.55791 191.619C7.54062 191.544 7.5291 191.474 7.51758 191.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.994 192.581C199.937 192.448 199.879 192.361 199.862 192.268C199.856 192.222 199.931 192.152 199.971 192.094C200.029 192.17 200.092 192.239 200.127 192.332C200.144 192.361 200.063 192.459 199.994 192.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6551 193.317C16.632 193.166 16.609 193.015 16.5859 192.865C16.6608 192.876 16.7415 192.888 16.8164 192.9C16.7991 193.044 16.7761 193.189 16.7588 193.328C16.7242 193.322 16.6896 193.322 16.6551 193.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2443 117.776C17.1867 117.701 17.1175 117.655 17.1118 117.603C17.106 117.545 17.1579 117.435 17.1982 117.423C17.2385 117.411 17.3192 117.487 17.3249 117.539C17.3307 117.597 17.2789 117.678 17.2443 117.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.385 88.5279C108.333 88.3831 108.281 88.3019 108.27 88.2035C108.264 88.1571 108.339 88.0934 108.379 88.0413C108.425 88.1224 108.489 88.1919 108.512 88.2846C108.523 88.3193 108.454 88.4004 108.385 88.5279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3512 242.742C55.3051 242.864 55.2648 242.985 55.2187 243.113C55.1726 243.061 55.0804 242.98 55.0862 242.962C55.1265 242.841 55.1841 242.736 55.2418 242.626C55.2763 242.667 55.3109 242.707 55.3512 242.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.78 197.07C141.676 197.041 141.567 197.013 141.463 196.984C141.486 196.902 141.521 196.752 141.526 196.758C141.624 196.792 141.716 196.856 141.814 196.908C141.803 196.96 141.791 197.018 141.78 197.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3831 198.061C70.2736 197.992 70.1642 197.922 70.0547 197.852C70.0662 197.806 70.0835 197.76 70.095 197.719C70.1526 197.754 70.216 197.789 70.2736 197.835C70.3255 197.876 70.3658 197.934 70.4119 197.986C70.4061 198.009 70.3946 198.032 70.3831 198.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05771 206.021C2.93671 206.078 2.81572 206.136 2.69473 206.194C2.6832 206.142 2.67168 206.09 2.66016 206.038C2.78691 205.992 2.9079 205.945 3.03466 205.905C3.04618 205.945 3.05194 205.986 3.05771 206.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.825 243.171C132.669 243.252 132.589 243.333 132.537 243.304C132.479 243.275 132.445 243.148 132.404 243.061C132.456 243.026 132.514 242.951 132.56 242.962C132.629 242.974 132.687 243.055 132.825 243.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34757 114C6.48585 114.503 6.32453 114.556 5.99609 114.585C6.14013 114.341 6.22656 114.202 6.34757 114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.705 112.98C54.5898 113.067 54.5322 113.142 54.4631 113.154C54.4227 113.159 54.3363 113.038 54.3421 113.009C54.3651 112.916 54.417 112.777 54.4631 112.771C54.5264 112.76 54.5898 112.87 54.705 112.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7099 244.144C44.6119 244.074 44.514 244.011 44.416 243.941C44.4448 243.878 44.4967 243.744 44.5082 243.75C44.6061 243.802 44.6983 243.883 44.7905 243.953C44.7617 244.017 44.7387 244.08 44.7099 244.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.592 112.267C142.482 112.296 142.402 112.337 142.338 112.32C142.298 112.308 142.275 112.192 142.246 112.128C142.315 112.088 142.384 112.024 142.454 112.024C142.488 112.03 142.523 112.146 142.592 112.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3965 212.445C16.2813 212.567 16.2294 212.659 16.1603 212.682C16.1257 212.694 16.0335 212.601 16.0278 212.538C16.022 212.468 16.0739 212.323 16.1027 212.323C16.1776 212.317 16.2525 212.375 16.3965 212.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03574 36.4492C3.12216 36.5361 3.21435 36.6288 3.30077 36.7157C3.27773 36.7678 3.24892 36.82 3.22587 36.8663C3.13369 36.7794 3.04726 36.6867 2.95508 36.5998C2.98389 36.5477 3.00693 36.5014 3.03574 36.4492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1244 244.318C36.0668 244.416 36.0207 244.509 35.9631 244.567C35.9516 244.578 35.8421 244.468 35.8479 244.445C35.8709 244.341 35.917 244.248 35.9516 244.15C36.0034 244.196 36.0495 244.242 36.1244 244.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5641 244.196C46.3683 244.196 46.1666 244.196 45.9707 244.196C45.9707 244.161 45.9707 244.127 45.9707 244.092C46.1666 244.092 46.3683 244.092 46.5641 244.092C46.5641 244.127 46.5641 244.161 46.5641 244.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4424 214.148C14.3444 214.113 14.2522 214.079 14.1543 214.038C14.1601 213.986 14.1716 213.934 14.1773 213.887C14.2753 213.922 14.3675 213.963 14.4654 213.997C14.4654 214.044 14.4539 214.096 14.4424 214.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7329 0.897908C15.6004 0.770463 15.4679 0.643018 15.3008 0.486609C15.6465 0.225926 15.6407 0.72412 15.7329 0.897908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8398 1.61055C87.9551 1.59317 88.0645 1.57579 88.1798 1.56421C88.1855 1.56421 88.2086 1.70903 88.2028 1.70903C88.0991 1.76117 87.9954 1.80751 87.8859 1.85386C87.8744 1.77855 87.8571 1.69745 87.8398 1.61055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5771 110.674C54.4907 110.738 54.4446 110.808 54.3928 110.808C54.3582 110.808 54.3236 110.715 54.2891 110.663C54.3352 110.617 54.3755 110.535 54.4273 110.53C54.4619 110.518 54.508 110.605 54.5771 110.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4204 80.8753C37.2533 81.0317 37.1899 81.1244 37.1611 81.1071C37.0978 81.0665 37.0459 80.9738 36.9883 80.9043C37.0401 80.8348 37.092 80.7189 37.1496 80.7131C37.2187 80.7131 37.2994 80.8 37.4204 80.8753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.665 3.73647C253.573 3.66696 253.481 3.60324 253.394 3.51634C253.383 3.50476 253.435 3.37731 253.458 3.302C253.544 3.40628 253.63 3.51634 253.717 3.62061C253.7 3.65537 253.682 3.69592 253.665 3.73647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.589 3.42358C111.699 3.46993 111.808 3.52206 111.912 3.56841C111.906 3.61475 111.9 3.6611 111.895 3.70744C111.785 3.69585 111.67 3.67847 111.561 3.66689C111.572 3.58579 111.578 3.50469 111.589 3.42358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.766 246.409C188.847 246.496 188.933 246.583 189.014 246.67C188.991 246.716 188.973 246.762 188.95 246.809C188.858 246.733 188.766 246.652 188.668 246.577C188.703 246.525 188.737 246.467 188.766 246.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1023 4.61694C80.1369 4.69804 80.1945 4.77335 80.183 4.82549C80.1715 4.88921 80.0793 4.9819 80.062 4.96452C80.0044 4.91238 79.9641 4.8197 79.918 4.74439C79.9756 4.70963 80.0274 4.66908 80.1023 4.61694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7342 109.73C68.8206 109.829 68.907 109.933 68.9934 110.031C68.9416 110.084 68.8725 110.194 68.8436 110.176C68.7572 110.113 68.6823 110.008 68.6074 109.916C68.6478 109.852 68.6938 109.794 68.7342 109.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.857 10.2363C25.736 10.2073 25.6093 10.1783 25.4883 10.1494C25.494 10.0914 25.5056 10.0335 25.5113 9.97559C25.6323 10.0219 25.7533 10.0683 25.8743 10.1146C25.8743 10.1494 25.8685 10.1899 25.857 10.2363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70068 218.817C6.61425 218.73 6.52783 218.649 6.44141 218.568C6.46445 218.522 6.48174 218.475 6.50478 218.423C6.60273 218.499 6.69492 218.568 6.79286 218.643C6.76406 218.701 6.73525 218.759 6.70068 218.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3053 10.2825C83.3802 10.3983 83.4551 10.5084 83.53 10.6243C83.5012 10.6648 83.4435 10.7343 83.4378 10.7343C83.3629 10.6358 83.2937 10.5316 83.2246 10.4215C83.2534 10.3752 83.2765 10.3288 83.3053 10.2825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.271 248.205C145.219 248.321 145.191 248.396 145.156 248.465C145.098 248.402 145.029 248.35 144.995 248.269C144.977 248.234 145.052 248.066 145.07 248.072C145.133 248.089 145.196 248.147 145.271 248.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7419 79.0333C50.6267 79.1029 50.5518 79.1724 50.5229 79.1492C50.4653 79.0971 50.425 78.987 50.3789 78.9059C50.4192 78.8769 50.4596 78.8132 50.4884 78.8306C50.5633 78.8653 50.6267 78.9349 50.7419 79.0333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.8 77.9963C112.863 78.118 112.904 78.2107 112.95 78.2976C112.898 78.3323 112.84 78.4018 112.794 78.3845C112.742 78.3671 112.685 78.286 112.673 78.2165C112.662 78.1759 112.736 78.1006 112.8 77.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.748 11.0007C236.794 11.1398 236.84 11.2325 236.851 11.3309C236.857 11.3599 236.742 11.4584 236.73 11.4468C236.673 11.3831 236.627 11.2904 236.598 11.1977C236.592 11.1687 236.673 11.0934 236.748 11.0007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1223 219.385C24.1223 219.536 24.1223 219.68 24.1165 219.831C24.1165 219.837 24.0013 219.848 24.0013 219.843C23.984 219.698 23.9725 219.547 23.9609 219.396C24.0186 219.391 24.0704 219.385 24.1223 219.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.185 12.507C255.116 12.4143 255.075 12.3622 255.035 12.3043C255.087 12.2406 255.139 12.1537 255.196 12.1247C255.231 12.1073 255.283 12.2 255.329 12.2464C255.283 12.3332 255.237 12.4086 255.185 12.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3358 14.3724C74.2609 14.2565 74.186 14.1812 74.1917 14.1465C74.2148 14.048 74.2724 13.9611 74.3185 13.8684C74.3646 13.9205 74.4452 13.9727 74.4395 14.019C74.4337 14.1233 74.3876 14.216 74.3358 14.3724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1504 249.12C33.329 249.184 33.4154 249.213 33.5076 249.242C33.45 249.277 33.3981 249.329 33.3405 249.34C33.3117 249.346 33.2771 249.271 33.1504 249.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.441 249.45C258.32 249.45 258.199 249.45 258.055 249.45C258.164 248.906 258.314 249.253 258.441 249.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0677 219.779C62.1195 219.877 62.1714 219.953 62.1944 220.039C62.2002 220.063 62.0965 220.184 62.0734 220.173C62.0101 220.132 61.964 220.039 61.9121 219.97C61.9524 219.918 61.9928 219.866 62.0677 219.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.747 75.4301C260.666 75.5228 260.585 75.6097 260.505 75.7024C260.482 75.6618 260.453 75.6213 260.43 75.5865C260.505 75.4822 260.579 75.378 260.66 75.2737C260.683 75.32 260.712 75.3722 260.747 75.4301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2771 220.26C56.1619 220.347 56.1158 220.416 56.0697 220.404C56.0178 220.393 55.9718 220.318 55.9199 220.265C55.9545 220.202 55.9891 220.08 56.0179 220.086C56.087 220.097 56.1503 220.167 56.2771 220.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6178 109.029C51.6811 109.191 51.733 109.278 51.7445 109.377C51.7503 109.412 51.6466 109.522 51.6178 109.51C51.5486 109.481 51.491 109.388 51.4219 109.325C51.4737 109.249 51.5256 109.168 51.6178 109.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2505 221.175C52.1929 221.268 52.1525 221.372 52.1295 221.36C52.0603 221.331 51.997 221.262 51.9336 221.21C51.9624 221.14 52.0027 221.007 52.0258 221.013C52.0949 221.03 52.1525 221.1 52.2505 221.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06865 72.076C5.03408 71.9196 5.00527 71.7574 4.9707 71.601C5.00527 71.5836 5.03984 71.5662 5.07441 71.5488C5.1205 71.6994 5.17235 71.8501 5.21845 72.0007C5.16659 72.0238 5.1205 72.0528 5.06865 72.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64599 19.6381C1.53076 19.6728 1.41552 19.7076 1.30029 19.7365C1.28877 19.6728 1.27725 19.6033 1.27148 19.5396C1.38672 19.5048 1.50195 19.4701 1.61142 19.4353C1.62294 19.499 1.63446 19.5685 1.64599 19.6381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7769 20.1306C71.7135 19.9858 71.6731 19.8989 71.6328 19.8062C71.6847 19.7714 71.7423 19.6961 71.7769 19.7135C71.8229 19.7367 71.8748 19.8352 71.8863 19.9105C71.8978 19.9568 71.8345 20.0205 71.7769 20.1306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.5 19.8003C137.558 19.893 137.598 19.9567 137.638 20.0204C137.581 20.0784 137.523 20.1421 137.465 20.2C137.437 20.1247 137.385 20.0552 137.385 19.9799C137.385 19.9277 137.448 19.8698 137.5 19.8003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.969 249.746C217.072 249.728 217.176 249.711 217.28 249.705C217.286 249.705 217.303 249.914 217.297 249.92C217.193 249.954 217.078 249.972 216.975 249.989C216.969 249.914 216.969 249.827 216.969 249.746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4668 20.3508C83.5532 20.2639 83.6396 20.177 83.7261 20.0901C83.7549 20.1538 83.7779 20.2233 83.8067 20.287C83.7145 20.3508 83.6166 20.4145 83.5244 20.484C83.5014 20.4435 83.4841 20.3971 83.4668 20.3508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4746 249.937C61.5898 249.937 61.7051 249.937 61.8203 249.937C61.8261 249.995 61.8261 250.053 61.8318 250.105C61.7166 250.128 61.6014 250.151 61.4861 250.174C61.4804 250.093 61.4804 250.012 61.4746 249.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.412 22.5347C13.5215 22.5636 13.631 22.5926 13.7404 22.6216C13.7347 22.6795 13.7289 22.7838 13.7174 22.7896C13.6137 22.8011 13.51 22.7953 13.4062 22.7953C13.4062 22.7085 13.412 22.6216 13.412 22.5347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.463 249.833C251.561 249.908 251.654 249.977 251.844 250.117C251.682 250.157 251.613 250.209 251.556 250.186C251.492 250.157 251.44 250.064 251.383 249.995C251.406 249.943 251.435 249.891 251.463 249.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.879 24.0813C2.8502 24.2725 2.82139 24.4578 2.78106 24.7301C2.52179 24.3825 2.7753 24.2493 2.879 24.0813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.637 25.1067C141.579 25.0603 141.539 25.0314 141.51 25.0024C141.544 24.9445 141.579 24.8692 141.625 24.8344C141.642 24.8228 141.694 24.8865 141.729 24.9155C141.694 24.9792 141.665 25.0429 141.637 25.1067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.052 25.5237C105.908 25.5643 105.81 25.6396 105.764 25.599C105.706 25.5527 105.695 25.4079 105.66 25.3036C105.729 25.2688 105.81 25.1819 105.873 25.2109C105.931 25.2283 105.966 25.3615 106.052 25.5237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.645 223.226C259.732 223.301 259.818 223.376 259.905 223.446C259.87 223.504 259.835 223.567 259.801 223.625C259.726 223.533 259.651 223.44 259.576 223.347C259.599 223.307 259.622 223.266 259.645 223.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.156 30.8474C159.248 30.9864 159.312 31.0502 159.341 31.1371C159.352 31.1718 159.289 31.3166 159.26 31.3108C159.185 31.3051 159.116 31.2471 159.041 31.2124C159.081 31.1139 159.11 31.0154 159.156 30.8474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0295 105.467C46.9315 105.496 46.8393 105.53 46.7414 105.542C46.7299 105.542 46.7126 105.449 46.6953 105.397C46.7933 105.345 46.8854 105.293 46.9834 105.235C46.9949 105.316 47.0122 105.391 47.0295 105.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8592 251.281C60.9687 251.281 61.0896 251.235 61.1761 251.292C61.2855 251.374 61.1645 251.588 61.0147 251.542C60.9571 251.524 60.9053 251.489 60.8477 251.46C60.8534 251.402 60.8592 251.345 60.8592 251.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2761 31.7511C23.1205 31.8206 23.0514 31.8785 22.988 31.8727C22.9419 31.8669 22.8958 31.7743 22.8555 31.7279C22.9131 31.6468 22.9592 31.5194 23.0226 31.502C23.0744 31.4904 23.1378 31.6121 23.2761 31.7511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5102 251.623C66.5967 251.75 66.6831 251.883 66.7695 252.011C66.7234 252.086 66.6773 252.161 66.6255 252.231C66.5218 252.138 66.4181 252.046 66.3086 251.947C66.3777 251.843 66.4469 251.739 66.5102 251.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.946 32.2841C104.865 32.3304 104.791 32.4115 104.767 32.3884C104.716 32.3362 104.687 32.2262 104.646 32.1451C104.704 32.1219 104.767 32.0639 104.814 32.0813C104.86 32.0987 104.888 32.1914 104.946 32.2841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9551 252.509C40.0415 252.416 40.1279 252.318 40.2143 252.225C40.2432 252.295 40.3065 252.422 40.3008 252.428C40.2201 252.521 40.1279 252.596 40.0357 252.677C40.0127 252.619 39.9839 252.561 39.9551 252.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1321 252.445C58.0632 252.509 58.0113 252.584 57.9537 252.602C57.9307 252.607 57.85 252.474 57.8558 252.439C57.8788 252.347 57.9422 252.277 57.9883 252.196C58.0228 252.26 58.0632 252.324 58.1321 252.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97637 33.7844C3.08584 33.8192 3.19531 33.8481 3.30478 33.8829C3.29902 33.9235 3.29902 33.964 3.29325 34.0046C3.18378 34.0046 3.07431 34.0046 2.96484 34.0046C2.97061 33.9292 2.97637 33.8539 2.97637 33.7844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2164 225.728C50.3028 225.78 50.395 225.838 50.4814 225.89C50.4699 225.919 50.4642 225.954 50.4526 225.983C50.3662 225.925 50.2798 225.867 50.1934 225.809C50.1991 225.786 50.2049 225.757 50.2164 225.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.18 253.216C79.0705 253.106 78.961 252.996 78.8516 252.886C78.8746 252.833 78.8919 252.781 78.9149 252.729C79.0302 252.828 79.1512 252.932 79.2664 253.036C79.2376 253.1 79.2088 253.158 79.18 253.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9101 35.3195C30.8294 35.2153 30.7545 35.111 30.6738 35.0067C30.7026 34.9662 30.7257 34.9314 30.7545 34.8909C30.8294 34.9951 30.9101 35.0994 30.985 35.2037C30.9619 35.2442 30.9331 35.279 30.9101 35.3195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2125 104.783C85.2989 104.939 85.345 105.02 85.3911 105.107C85.3277 105.159 85.2643 105.235 85.1952 105.246C85.1549 105.252 85.0742 105.136 85.0742 105.096C85.0915 105.003 85.1491 104.928 85.2125 104.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4914 35.0647C1.41074 35.2617 1.80253 35.6208 1.33008 35.7193C1.38769 35.476 1.43955 35.2732 1.4914 35.0647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.95 34.949C101.991 35.1749 102.025 35.2908 102.025 35.4008C102.025 35.4588 101.95 35.563 101.933 35.5572C101.864 35.5283 101.806 35.4645 101.754 35.395C101.749 35.3892 101.806 35.2792 101.95 34.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.718 35.673C114.661 35.6962 114.597 35.7599 114.54 35.7425C114.471 35.7252 114.407 35.6498 114.344 35.5977C114.378 35.534 114.407 35.4181 114.442 35.4181C114.511 35.4123 114.58 35.4703 114.655 35.505C114.672 35.5572 114.695 35.6151 114.718 35.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.057 254.542C196.976 254.461 196.89 254.38 196.815 254.287C196.809 254.282 196.867 254.154 196.872 254.154C196.97 254.206 197.068 254.27 197.161 254.334C197.126 254.403 197.091 254.473 197.057 254.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3699 255.012C26.3065 254.855 26.2489 254.699 26.1855 254.537C26.2201 254.508 26.2489 254.479 26.2835 254.45C26.3584 254.606 26.4275 254.757 26.5024 254.913C26.4621 254.948 26.416 254.983 26.3699 255.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7022 67.8413C21.6216 67.8876 21.5467 67.9571 21.5294 67.9398C21.4775 67.8703 21.4372 67.766 21.4084 67.6675C21.4026 67.6559 21.5236 67.5401 21.5352 67.5574C21.5928 67.627 21.6331 67.7196 21.7022 67.8413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.711 38.6621C102.769 38.7316 102.815 38.7838 102.861 38.8301C102.815 38.8996 102.769 38.9749 102.717 39.0444C102.677 38.9865 102.608 38.9286 102.602 38.8649C102.596 38.8127 102.665 38.7432 102.711 38.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0575 40.5508C88.1324 40.7246 88.19 40.8115 88.2015 40.9099C88.213 40.9795 88.1612 41.0664 88.1036 41.2517C88.0459 41.0837 87.9941 40.9968 87.9883 40.8984C87.9768 40.823 88.0171 40.7419 88.0575 40.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.177 255.017C48.0503 255.029 47.9351 255.035 47.6758 255.052C47.9408 254.82 48.056 254.583 48.177 255.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.134 227.57C212.03 227.686 211.972 227.796 211.909 227.808C211.851 227.814 211.794 227.709 211.73 227.652C211.777 227.565 211.817 227.431 211.88 227.408C211.938 227.385 212.013 227.484 212.134 227.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9935 42.8332C29.9071 42.9433 29.8149 43.0534 29.6536 43.2561C29.6075 42.7811 29.74 42.7174 29.9935 42.8332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.97 49.1707C228.849 49.1707 228.722 49.1707 228.555 49.1707C228.716 48.6956 228.849 48.9389 228.97 49.1707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9258 255.504C60.162 255.504 60.2772 255.504 60.4443 255.504C60.3118 255.904 60.1851 255.759 59.9258 255.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.689 104.777C57.5795 104.818 57.4758 104.864 57.3663 104.893C57.3548 104.893 57.3317 104.8 57.3145 104.748C57.4182 104.673 57.5219 104.603 57.6256 104.528C57.6486 104.609 57.6717 104.696 57.689 104.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.105 50.3003C166.192 50.4335 166.244 50.5146 166.296 50.5957C166.232 50.6595 166.175 50.7464 166.1 50.7811C166.071 50.7927 165.973 50.6826 165.979 50.6421C165.99 50.5378 166.048 50.4509 166.105 50.3003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8636 50.5898C83.95 50.6825 84.0307 50.7752 84.1171 50.8679C84.094 50.9142 84.0768 50.9606 84.0537 51.0069C83.9558 50.9316 83.8636 50.8563 83.7656 50.7868C83.806 50.7231 83.8348 50.6536 83.8636 50.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6088 51.4356C29.5224 51.3603 29.4359 51.2849 29.3438 51.2038C29.3726 51.1343 29.4071 51.0648 29.4359 50.9895C29.5166 51.0938 29.5973 51.1923 29.6779 51.2965C29.6606 51.3429 29.6318 51.3892 29.6088 51.4356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9582 228.341C30.0043 228.445 30.0561 228.532 30.0734 228.625C30.0792 228.648 29.964 228.764 29.9467 228.752C29.8833 228.7 29.843 228.601 29.7969 228.526C29.8372 228.474 29.8833 228.422 29.9582 228.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8568 146.799C40.0527 146.811 40.2429 146.822 40.4388 146.834C40.4388 146.88 40.4388 146.921 40.4388 146.967C40.2313 146.967 40.0297 146.967 39.8223 146.967C39.8338 146.909 39.8453 146.851 39.8568 146.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.846 256.639C174.759 256.72 174.696 256.813 174.661 256.796C174.598 256.761 174.552 256.657 174.5 256.581C174.546 256.524 174.598 256.413 174.633 256.425C174.702 256.46 174.759 256.547 174.846 256.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3747 213.407C21.3171 213.436 21.2595 213.488 21.2076 213.476C21.1385 213.459 21.0751 213.383 21.0117 213.331C21.0405 213.273 21.0751 213.157 21.1039 213.157C21.173 213.157 21.2422 213.215 21.3113 213.244C21.3286 213.296 21.3517 213.354 21.3747 213.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1566 148.103C44.0241 148.369 43.9492 148.525 43.8224 148.786C43.7591 148.346 43.7936 148.143 44.1566 148.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4707 229.754C43.5571 229.719 43.6378 229.685 43.7242 229.644C43.7357 229.696 43.7415 229.754 43.753 229.806C43.6666 229.841 43.5802 229.87 43.4938 229.905C43.4822 229.853 43.4765 229.806 43.4707 229.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4852 136.754C31.3182 136.801 31.2317 136.864 31.1799 136.824C31.128 136.789 31.1107 136.644 31.0762 136.552C31.1453 136.517 31.226 136.447 31.2894 136.465C31.3354 136.488 31.3815 136.604 31.4852 136.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9631 257.555C65.8652 257.676 65.8133 257.769 65.7442 257.798C65.7154 257.81 65.6117 257.694 65.6174 257.642C65.6232 257.543 65.6808 257.45 65.7154 257.352C65.7787 257.41 65.8479 257.462 65.9631 257.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4661 152.169C51.3566 152.268 51.2414 152.36 51.1319 152.459C51.1146 152.418 51.0974 152.378 51.0801 152.331C51.1953 152.239 51.3048 152.152 51.42 152.059C51.4373 152.094 51.4488 152.129 51.4661 152.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6098 136.163C25.4772 136.273 25.4139 136.366 25.3562 136.36C25.2929 136.355 25.2353 136.25 25.1719 136.192C25.2237 136.123 25.2698 136.007 25.3274 135.995C25.3908 135.984 25.4657 136.071 25.6098 136.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4084 63.9195C35.2989 63.8558 35.1837 63.7979 35.0742 63.7341C35.0857 63.6704 35.103 63.6067 35.1145 63.543C35.2298 63.5951 35.3508 63.6414 35.466 63.6878C35.4487 63.7631 35.4257 63.8384 35.4084 63.9195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.46 153.38C108.345 153.438 108.264 153.519 108.207 153.496C108.149 153.467 108.114 153.339 108.068 153.252C108.143 153.218 108.224 153.154 108.299 153.154C108.339 153.148 108.379 153.258 108.46 153.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4944 59.7891C57.3331 59.8007 57.2179 59.8065 57.0508 59.8181C57.2121 59.3778 57.3216 59.3662 57.4944 59.7891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.351 101.226C76.4835 101.788 76.4316 101.962 76.0859 101.852C76.1666 101.672 76.2242 101.533 76.351 101.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96659 101.301C4.86289 101.417 4.82255 101.498 4.77646 101.504C4.72461 101.51 4.66123 101.452 4.60938 101.423C4.63242 101.354 4.65547 101.226 4.68428 101.22C4.75341 101.209 4.82832 101.255 4.96659 101.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1047 153.305C81.2141 153.363 81.3236 153.415 81.4273 153.478C81.4331 153.478 81.4043 153.629 81.3928 153.629C81.2833 153.618 81.1681 153.589 81.0586 153.565C81.0759 153.478 81.0874 153.392 81.1047 153.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2143 156.161C99.1451 156.045 99.0645 155.969 99.0645 155.888C99.0645 155.825 99.1624 155.755 99.2143 155.686C99.2603 155.767 99.318 155.848 99.3352 155.94C99.3468 155.981 99.2719 156.056 99.2143 156.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.795 157.962C105.852 158.072 105.892 158.159 105.939 158.246C105.875 158.304 105.8 158.42 105.76 158.397C105.702 158.362 105.662 158.234 105.639 158.136C105.633 158.119 105.72 158.049 105.795 157.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1169 100.734C61.0247 100.792 60.9556 100.867 60.8807 100.873C60.8403 100.879 60.8 100.763 60.7539 100.699C60.8346 100.624 60.9095 100.543 60.9959 100.49C61.0017 100.485 61.0593 100.618 61.1169 100.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3613 134.321C18.4881 134.327 18.6206 134.339 18.7934 134.35C18.6436 134.773 18.5054 134.669 18.3613 134.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.719 133.412C55.6499 133.522 55.598 133.603 55.5404 133.678C55.4886 133.603 55.4425 133.533 55.3906 133.458C55.4482 133.383 55.4943 133.29 55.5635 133.244C55.5865 133.232 55.6441 133.331 55.719 133.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.528 132.583C176.379 132.595 176.298 132.63 176.235 132.601C176.194 132.578 176.142 132.41 176.154 132.392C176.206 132.323 176.292 132.23 176.344 132.253C176.402 132.271 176.442 132.41 176.528 132.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.948 230.339C153.856 230.339 153.77 230.339 153.678 230.339C153.672 230.299 153.672 230.258 153.666 230.218C153.758 230.195 153.85 230.171 153.943 230.148C153.943 230.212 153.943 230.276 153.948 230.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7891 132.16C23.887 132.108 23.9561 132.039 24.0253 132.045C24.0714 132.045 24.1117 132.149 24.1578 132.201C24.0771 132.27 24.0022 132.346 23.9158 132.392C23.9043 132.404 23.8524 132.282 23.7891 132.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8605 130.202C45.947 130.255 46.0392 130.295 46.1198 130.365C46.1313 130.376 46.091 130.509 46.0737 130.591C45.9873 130.527 45.9009 130.463 45.8145 130.399C45.8317 130.336 45.8433 130.272 45.8605 130.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1182 58.7059C42.9453 58.7928 42.8819 58.8565 42.8243 58.8507C42.7494 58.8449 42.6745 58.787 42.5996 58.7465C42.6457 58.6596 42.6745 58.5205 42.7321 58.4974C42.7955 58.4742 42.8762 58.5611 43.1182 58.7059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.152 129.345C77.2038 129.472 77.2614 129.6 77.3133 129.727C77.2787 129.756 77.2211 129.82 77.2096 129.808C77.1404 129.71 77.077 129.594 77.0137 129.484C77.054 129.432 77.1059 129.391 77.152 129.345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1209 167.324C73.9999 167.266 73.8847 167.208 73.7637 167.156C73.7752 167.103 73.7925 167.046 73.804 166.993C73.9192 167.057 74.0345 167.127 74.1555 167.19C74.1439 167.231 74.1324 167.277 74.1209 167.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6498 169.531C16.523 169.496 16.3963 169.467 16.2695 169.432C16.2753 169.368 16.2868 169.311 16.2926 169.247C16.4251 169.282 16.5576 169.322 16.6901 169.357C16.6786 169.421 16.6613 169.479 16.6498 169.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3516 259.211C58.4898 259.124 58.5647 259.049 58.6396 259.043C58.68 259.038 58.7722 259.177 58.7664 259.206C58.7433 259.298 58.6857 259.385 58.6281 259.432C58.5993 259.449 58.5359 259.362 58.3516 259.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65039 169.907C5.76562 169.855 5.88085 169.803 5.99609 169.751C6.00761 169.815 6.02489 169.878 6.03642 169.942C5.92119 169.994 5.80595 170.04 5.69072 170.093C5.6792 170.029 5.66768 169.971 5.65039 169.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.367 230.467C181.258 230.484 181.148 230.496 181.039 230.513C181.033 230.461 181.033 230.409 181.027 230.357C181.137 230.357 181.252 230.357 181.362 230.357C181.367 230.397 181.367 230.432 181.367 230.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9169 230.884C97.7786 230.861 97.6461 230.838 97.5078 230.814C97.5078 230.774 97.5078 230.727 97.5078 230.687C97.6461 230.687 97.7844 230.687 97.9226 230.687C97.9226 230.745 97.9169 230.814 97.9169 230.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9881 129.026C27.8959 129.084 27.8383 129.154 27.7979 129.136C27.7346 129.102 27.6827 129.015 27.6309 128.951C27.6827 128.893 27.7461 128.777 27.7922 128.789C27.8556 128.806 27.9074 128.916 27.9881 129.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.282 170.295C149.224 170.365 149.19 170.458 149.144 170.463C149.092 170.469 149.034 170.406 148.977 170.371C149.023 170.284 149.069 170.197 149.109 170.11C149.161 170.162 149.207 170.214 149.282 170.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03808 58.3755C8.88251 58.3987 8.79033 58.4566 8.74424 58.4102C8.68662 58.3581 8.66934 58.2249 8.63477 58.1322C8.7039 58.1032 8.78457 58.0221 8.83642 58.0511C8.8998 58.08 8.93437 58.2017 9.03808 58.3755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3925 260.764C40.3118 260.677 40.2312 260.59 40.1562 260.497C40.1793 260.451 40.2254 260.37 40.2311 260.37C40.3118 260.451 40.3925 260.538 40.4674 260.625C40.4443 260.677 40.4155 260.723 40.3925 260.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.06 128.488C220.962 128.546 220.899 128.615 220.864 128.598C220.795 128.563 220.743 128.476 220.68 128.407C220.737 128.349 220.801 128.233 220.858 128.244C220.916 128.256 220.968 128.372 221.06 128.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9777 170.573C51.1045 170.649 51.2312 170.718 51.358 170.794C51.3465 170.846 51.3292 170.898 51.3177 170.95C51.1909 170.875 51.0584 170.805 50.9316 170.73C50.9489 170.678 50.9604 170.626 50.9777 170.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3272 96.7656C71.31 96.9684 71.2869 97.1769 71.2696 97.3797C71.2351 97.3739 71.2005 97.3623 71.1602 97.3565C71.1832 97.1537 71.2005 96.951 71.2235 96.7424C71.2581 96.7482 71.2927 96.754 71.3272 96.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.073 260.776C166.831 260.619 166.71 260.544 166.543 260.434C166.843 260.127 166.935 260.289 167.073 260.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9837 141.244C39.8742 141.331 39.7647 141.417 39.661 141.504C39.638 141.464 39.6207 141.423 39.5977 141.383C39.6898 141.267 39.782 141.145 39.8742 141.029C39.9088 141.099 39.9491 141.168 39.9837 141.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48749 260.996C2.41835 261.031 2.33193 261.112 2.2916 261.077C2.23975 261.03 2.2167 260.897 2.21094 260.799C2.21094 260.764 2.29736 260.689 2.34345 260.689C2.42412 260.695 2.49902 260.747 2.57968 260.781C2.54511 260.851 2.5163 260.92 2.48749 260.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5801 126.75C34.6146 126.611 34.655 126.472 34.6895 126.339C34.7529 126.391 34.8163 126.449 34.8739 126.501C34.8048 126.611 34.7356 126.721 34.6665 126.831C34.6377 126.802 34.6089 126.773 34.5801 126.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1309 95.6648C66.0214 95.6764 65.9177 95.688 65.8082 95.688C65.8024 95.688 65.7852 95.5374 65.7852 95.5374C65.8889 95.491 65.9926 95.4505 66.0963 95.4099C66.1136 95.4968 66.1251 95.5779 66.1309 95.6648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.065 55.4213C236.967 55.3576 236.864 55.2881 236.766 55.2243C236.783 55.1722 236.794 55.1259 236.812 55.0737C236.91 55.1375 237.013 55.2012 237.111 55.2649C237.1 55.317 237.083 55.3692 237.065 55.4213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0612 261.337C67.9172 261.019 67.8596 260.88 67.7559 260.654C68.0382 260.694 68.188 260.752 68.0612 261.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.607 170.788C233.711 170.77 233.821 170.747 233.924 170.741C233.936 170.741 233.942 170.892 233.953 170.967C233.838 170.991 233.728 171.014 233.613 171.031C233.613 170.95 233.607 170.869 233.607 170.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0538 171.877C56.0999 172.109 56.1345 172.219 56.1345 172.335C56.1345 172.393 56.0596 172.503 56.0423 172.497C55.9789 172.468 55.9155 172.404 55.8637 172.329C55.8579 172.311 55.9155 172.207 56.0538 171.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.663 125.267C8.60538 125.365 8.57081 125.423 8.53624 125.481C8.49015 125.406 8.42677 125.33 8.40372 125.244C8.3922 125.203 8.45558 125.122 8.49015 125.064C8.53624 125.128 8.59386 125.191 8.663 125.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77676 53.7759C7.85742 53.9786 7.90927 54.1235 7.97841 54.2972C7.74795 54.2335 7.74795 54.2335 7.77676 53.7759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7377 261.5C39.6513 261.413 39.5591 261.332 39.4727 261.245C39.513 261.181 39.5476 261.117 39.5879 261.059C39.6628 261.169 39.7377 261.279 39.8126 261.39C39.7895 261.424 39.7607 261.459 39.7377 261.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7905 234.754C31.7041 234.678 31.6177 234.603 31.5312 234.528C31.5485 234.481 31.5658 234.435 31.5831 234.394C31.6811 234.458 31.7732 234.522 31.8712 234.586C31.8481 234.638 31.8193 234.696 31.7905 234.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.977 234.916C91.8963 234.852 91.8099 234.794 91.735 234.73C91.7293 234.725 91.7638 234.603 91.7638 234.603C91.856 234.638 91.9424 234.678 92.0289 234.719C92.0173 234.788 91.9943 234.852 91.977 234.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.834 124.068C256.903 124.195 256.938 124.265 256.978 124.334C256.915 124.398 256.857 124.485 256.788 124.514C256.765 124.525 256.667 124.375 256.679 124.34C256.702 124.247 256.771 124.172 256.834 124.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0208 176.43C57.136 176.477 57.2455 176.523 57.3607 176.563C57.3492 176.633 57.3319 176.702 57.3204 176.772C57.2052 176.726 57.0957 176.673 56.9805 176.627C56.992 176.569 57.0093 176.5 57.0208 176.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2187 123.865C83.0228 123.865 82.9076 123.865 82.7578 123.865C82.9019 123.448 83.0113 123.506 83.2187 123.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52187 261.644C4.75234 261.83 4.75234 261.83 4.42969 262.177C4.48154 261.928 4.51611 261.772 4.54492 261.615L4.52187 261.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9459 178.394C63.9689 178.51 63.9978 178.626 64.0266 178.742C63.9747 178.765 63.9171 178.782 63.8652 178.805C63.8652 178.678 63.8652 178.545 63.8652 178.417C63.894 178.406 63.9171 178.4 63.9459 178.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.084 94.2571C45.1992 94.1934 45.3145 94.1296 45.4297 94.0659C45.447 94.1412 45.47 94.2165 45.4873 94.2918C45.3721 94.3498 45.2568 94.4077 45.1416 94.4656C45.1186 94.3903 45.1013 94.3266 45.084 94.2571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4023 123.32C46.5176 123.413 46.6386 123.506 46.8575 123.679C46.4715 123.79 46.3851 123.645 46.4196 123.297L46.4023 123.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0436 94.6453C37.9687 94.5642 37.8881 94.4947 37.8189 94.402C37.8132 94.3962 37.8535 94.3093 37.8708 94.2629C37.963 94.3498 38.0494 94.4309 38.1416 94.512C38.107 94.5584 38.0724 94.5989 38.0436 94.6453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.771 182.217C158.753 181.986 158.736 181.748 158.719 181.516C158.753 181.511 158.788 181.499 158.822 181.493C158.857 181.725 158.892 181.957 158.92 182.188C158.869 182.194 158.822 182.206 158.771 182.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.409 182.293C223.311 182.246 223.213 182.206 223.121 182.142C223.11 182.136 223.15 181.997 223.162 181.922C223.259 181.974 223.357 182.026 223.461 182.078C223.444 182.148 223.427 182.217 223.409 182.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7071 183.868C55.5919 183.787 55.4824 183.7 55.3672 183.619C55.3902 183.555 55.4133 183.492 55.4363 183.434C55.5516 183.527 55.6726 183.619 55.7878 183.718C55.7647 183.764 55.7359 183.816 55.7071 183.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.907 183.955C143.878 184.129 143.855 184.303 143.826 184.471C143.792 184.465 143.751 184.459 143.717 184.448C143.728 184.268 143.74 184.094 143.751 183.915C143.803 183.932 143.855 183.944 143.907 183.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3309 120.864C52.256 120.934 52.1984 121.021 52.1293 121.05C52.1062 121.061 52.014 120.905 52.0198 120.899C52.0716 120.795 52.1408 120.708 52.2042 120.621C52.2387 120.685 52.2733 120.754 52.3309 120.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9227 94.2862C17.8594 94.3557 17.8133 94.431 17.7729 94.431C17.7211 94.431 17.675 94.3557 17.6289 94.3094C17.675 94.2399 17.7211 94.153 17.7787 94.1124C17.796 94.1008 17.8594 94.2109 17.9227 94.2862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.82 185.033C154.889 185.149 154.964 185.224 154.981 185.317C154.987 185.363 154.889 185.444 154.837 185.514C154.791 185.427 154.733 185.346 154.704 185.253C154.693 185.207 154.762 185.131 154.82 185.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7318 262.27C65.6051 262.282 65.4726 262.34 65.3631 262.282C65.3112 262.253 65.2997 262.027 65.2363 261.708C65.4783 261.986 65.6108 262.131 65.7376 262.282C65.7376 262.288 65.7318 262.27 65.7318 262.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2009 143.283C69.2009 143.057 69.2009 142.831 69.2009 142.553C69.5408 142.35 69.9038 142.142 70.2668 141.927C70.0651 142.698 69.8231 143.347 69.1836 143.265L69.2009 143.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.626 180.902C153.695 181.748 153.759 182.588 153.833 183.48C153.378 183.295 153.205 182.75 152.998 182.269C152.716 181.621 153.292 181.314 153.263 180.7C153.43 180.798 153.54 180.868 153.655 180.931L153.626 180.902Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2687_2583",
    x1: 204.263,
    y1: 114.288,
    x2: 161.664,
    y2: 231.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D897BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#880C55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2687_2583",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.918 71.2342) scale(44.1716 44.4121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA9DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7AEC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWebinar);
export default __webpack_public_path__ + "static/media/NoWebinar.0bec20f3bf23e36e963b214cabf5fb16.svg";
export { ForwardRef as ReactComponent };